/* ============================================================================
FILE: goody-biographie-fr-en-es-20260726.js
MODE: FR / EN / ES + protections canoniques + audio + panneau modal
ROOT: [data-goody-biography-panel]
TRIGGER: [data-goody-biographie] dans le bloc d’introduction existant

RÔLE
- Le panneau reste masqué jusqu’au clic sur « Biographie ».
- L’animation d’introduction est masquée et mise en pause sans être réinitialisée.
- « Fermer » restaure et reprend l’animation exactement à son état antérieur.
- Langue stockée dans po_lex_lang et goody_gp_lang.
- Les termes canoniques restent en français et sont protégés de toute traduction.
- « collections / collections / colecciones » pointe vers la rubrique Collections du CV.
============================================================================ */
(function(){
  "use strict";

  if(window.__GOODY_BIOGRAPHIE_FR_EN_ES_20260726__) return;
  window.__GOODY_BIOGRAPHIE_FR_EN_ES_20260726__ = true;

  var STORAGE_KEY = "po_lex_lang";
  var STORAGE_KEY_COMPAT = "goody_gp_lang";
  var ROOT_SELECTOR = "[data-goody-biography-panel]";
  var TRIGGER_SELECTOR = "[data-goody-biographie]";
  var INTRO_SELECTOR = "#goody-opening-intro";

  var URLS = {
    posoennoisme: "https://goodyart.store/pages/posoennoisme",
    multiple: "https://goodyart.store/pages/multiple-pluriel",
    peindre: "https://goodyart.store/pages/peindre-la-ligne",
    collections: "https://goodyart.store/pages/mon-cv#gy-cv-collections",
    prixArt: "https://mondialartacademia.com/jury-mondial-art-academia/"
  };

  var BIO_IMAGE = {
    src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/moi25.jpg?v=1785126439",
    alt: {
      fr: "Portrait de Goodÿ",
      en: "Portrait of Goodÿ",
      es: "Retrato de Goodÿ"
    }
  };

  var lastTrigger = null;
  var synth = (typeof window !== "undefined" && window.speechSynthesis) ? window.speechSynthesis : null;
  var audioState = { active:false, chunks:[], index:0, lang:"fr" };

  function str(v){ return v == null ? "" : String(v); }

  function normLang(raw){
    var s = str(raw).toLowerCase().trim().replace(/_/g,"-");
    if(s === "en" || s.indexOf("en-") === 0) return "en";
    if(s === "es" || s.indexOf("es-") === 0) return "es";
    return "fr";
  }

  function readLang(){
    var value = "";
    try{ value = localStorage.getItem(STORAGE_KEY) || ""; }catch(e){}
    if(!value){
      try{ value = localStorage.getItem(STORAGE_KEY_COMPAT) || ""; }catch(_e){}
    }
    if(value) return normLang(value);
    return normLang(document.documentElement.getAttribute("lang") || "fr");
  }

  function storeLang(lang){
    var l = normLang(lang);
    try{ localStorage.setItem(STORAGE_KEY,l); }catch(e){}
    try{ localStorage.setItem(STORAGE_KEY_COMPAT,l); }catch(_e){}
    try{ document.documentElement.setAttribute("lang",l); }catch(__e){}
    return l;
  }

  function escapeHTML(value){
    return str(value)
      .replace(/&/g,"&amp;")
      .replace(/</g,"&lt;")
      .replace(/>/g,"&gt;")
      .replace(/\"/g,"&quot;")
      .replace(/'/g,"&#39;");
  }

  function canonical(text,href){
    var safe = escapeHTML(text);
    var span = '<span class="goody-biography-panel__canonical notranslate" translate="no" lang="fr">'+safe+'</span>';
    if(!href) return span;
    return '<a class="goody-biography-panel__canonical-link notranslate" translate="no" lang="fr" href="'+escapeHTML(href)+'" target="_self" rel="noopener">'+span+'</a>';
  }

  function collectionWord(text){
    return '<a class="goody-biography-panel__collection-link" href="'+URLS.collections+'" target="_self" rel="noopener">'+escapeHTML(text)+'</a>';
  }

  function prizeArtLink(text){
    return '<a class="goody-biography-panel__collection-link" href="'+URLS.prixArt+'" target="_blank" rel="noopener noreferrer">'+escapeHTML(text)+'</a>';
  }

  var TOKENS = {
    "[[GOODY]]": function(){ return canonical("Goodÿ",""); },
    "[[POSO]]": function(){ return canonical("Posœnnoïsme",URLS.posoennoisme); },
    "[[MULTIPLE_CAP]]": function(){ return canonical("Multiple-Pluriel",URLS.multiple); },
    "[[MULTIPLE_EXPO]]": function(){ return canonical("Multiple pluriel",URLS.multiple); },
    "[[ART_POSO]]": function(){ return canonical("art posœnnoïaque",""); },
    "[[CHEMIN]]": function(){ return canonical("Chemin de Croire",""); },
    "[[PEINDRE]]": function(){ return canonical("« peignant la ligne pour dessiner la couleur »",URLS.peindre); }
  };

  function expandTokens(html,lang){
    var out = str(html);
    Object.keys(TOKENS).forEach(function(token){
      out = out.split(token).join(TOKENS[token]());
    });
    var collections = lang === "es" ? "colecciones" : "collections";
    out = out.split("[[COLLECTIONS]]").join(collectionWord(collections));

    var prixArt = lang === "en"
      ? "International Prize for Art Professionals"
      : (lang === "es" ? "Premio Internacional de los Profesionales del Arte" : "Prix international des professionnels de l’art");
    out = out.split("[[PRIX_ART]]").join(prizeArtLink(prixArt));
    return out;
  }

  var CONTENT = {
    fr: {
      eyebrow: "Biographie",
      title: "[[GOODY]]",
      close: "Fermer",
      listen: "Écouter",
      stop: "Arrêter",
      paragraphs: [
        `Figure active de la scène artistique guadeloupéenne, [[GOODY]] — Gilles EUGENE, né en 1975 — développe depuis le tournant des années 2000 une œuvre transdisciplinaire située aux frontières de l’abstraction, de la figuration et de l’écriture symbolique. Par la peinture, le dessin, la sculpture, l’installation, la performance et les pratiques numériques, il interroge la complexité du monde, la mémoire, le territoire, les systèmes de croyance, la circulation des savoirs et la coexistence des contraires. Son œuvre trouve aujourd’hui son architecture théorique dans le [[POSO]], pensée du [[MULTIPLE_CAP]] qui considère chaque forme, chaque connaissance et chaque point de vue comme une composante mobile d’un ensemble toujours en devenir.`,
        `[[GOODY]] naît le 22 novembre 1975 en Guadeloupe, territoire dont la géographie, l’histoire composite et les tensions culturelles constituent la matrice première de son travail. Autodidacte, il suit d’abord un parcours dans la gestion commerciale avant de se consacrer à la création et de déclarer son activité d’artiste-auteur en novembre 2000. Dès 2001, son exposition <em>[[MULTIPLE_EXPO]]</em>, présentée au Centre des Arts et de la Culture de Pointe-à-Pitre, énonce une intuition qui traversera toute son œuvre : l’individu, la société et l’histoire ne peuvent être saisis comme des unités stables, mais comme des agrégats de fragments, de contradictions, d’héritages et de devenirs.`,
        `Les premiers cycles — <em>Urbanis</em> en 2003 et 2005, <em>Distension</em> en 2006, <em>La Marche du temps</em> en 2008, puis <em>Péyi-la</em> entre 2010 et 2013 — installent une grammaire plastique fondée sur la stratification, la fragmentation et la tension. La couleur n’y remplit pas seulement les formes : elle les met en mouvement, les désassemble et les recompose. Lorsque [[GOODY]] participe en 2011 à l’exposition <em>Jeunes plasticiens de Guadeloupe</em> à la Fondation Clément, le commissaire Michel Rovélas relève dans ses peintures des dominantes terrestres, une forte sensation de profondeur et des fragments orientés dans des directions contradictoires, chargés d’une énergie tantôt contenue, tantôt frénétique. L’espace pictural devient ainsi moins un lieu de représentation qu’un champ de forces : quelque chose s’y défait tandis qu’autre chose cherche à advenir.`,
        `Dans <em>Péyi-la</em>, le territoire ne se réduit ni au paysage ni à l’identité. Il devient une matrice mentale, sociale et historique dans laquelle coexistent appartenances, ruptures, résistances et déplacements. Les titres en créole, en français, en anglais ou en latin ne traduisent pas un simple changement de langue : ils déplacent les seuils de lecture et font de l’œuvre un espace polyphonique. Des tableaux comme <em>Pa pè</em>, <em>Dékatman</em>, <em>Tonbé</em> ou <em>Fearless</em> mettent en jeu le corps, la peur, la chute et la résistance, tout en maintenant ouverte la relation entre l’expérience individuelle et la mémoire collective.`,
        `À partir de 2015, le cycle <em>Ordo ab Chaos</em>, présenté en Guadeloupe, à Miami puis à Cascais au Portugal, approfondit cette pensée des antagonismes. [[GOODY]] y explore la capacité des ruptures, des désordres et des oppositions à produire de nouvelles organisations. Le chaos n’y constitue pas l’envers de l’ordre, mais sa réserve potentielle : un milieu dans lequel lignes, couleurs, figures et symboles peuvent engendrer des équilibres provisoires. Cette période accompagne l’élargissement géographique de son travail, exposé notamment aux États-Unis, au Portugal, au Royaume-Uni, en Russie, en Italie et en Colombie, sans que cet élargissement n’efface son ancrage archipélagique guadeloupéen.`,
        `Présentée en 2019 au Centre culturel Rémy Nainsouta de Pointe-à-Pitre, la série <em>Rézonans</em> déplace cette recherche vers les relations entre parole, histoire et transmission. Les mots et les maux s’y répondent comme des échos différés. L’œuvre devient le lieu où les événements demeurés actifs dans les mémoires peuvent être reconnus, traversés et réinterprétés. Le détail, parfois presque enfoui dans la composition, agit comme une clef du discours général : élément apparemment secondaire, il peut modifier l’ensemble du sens et rendre visible ce que l’histoire dominante avait relégué à sa périphérie.`,
        `Cette conception évolutive de l’œuvre se manifeste avec une acuité particulière dans <em>Les œuvres prolongées</em>. Commencé en 2015-2016 et repris après le retour en Guadeloupe, à partir de 2022, cet ensemble refuse de considérer le tableau comme un objet définitivement achevé. [[GOODY]] revient sur certaines œuvres plusieurs années après leur première réalisation, non pour les corriger ou les répéter, mais pour révéler des lignes, des tensions et des strates demeurées en réserve. En [[PEINDRE]], il fait du temps un matériau plastique. L’œuvre conserve son identité première tout en accueillant son propre devenir ; prolongée par de nouvelles interventions picturales puis par des créations littéraires, elle demeure ouverte à d’autres états d’elle-même.`,
        `En janvier 2025, [[GOODY]] rassemble les dimensions dispersées de cette recherche sous le nom de [[POSO]] et inscrit son travail dans le cycle [[CHEMIN]]. Le [[POSO]] ne désigne pas seulement un style visuel : il propose une méthode de questionnement, d’addition et de mise en relation des savoirs, des éducations, des pensées, des symboles, des rituels, des héritages et des points de vue. Plutôt que de résoudre les contradictions, [[GOODY]] les maintient en présence afin d’examiner ce qu’elles produisent ensemble. L’[[ART_POSO]] se construit ainsi comme un espace de reliance dans lequel la pluralité ne doit être ni réduite à l’unité ni abandonnée à la dispersion.`,
        `Cette pensée dépasse le seul champ de l’atelier. [[GOODY]] intervient dans les milieux scolaire, socioéducatif et carcéral, tout en participant à la professionnalisation des artistes-auteurs et à la structuration économique des arts visuels en Guadeloupe. Secrétaire général du CAAP et délégué régional pour la Guadeloupe, il considère les conditions matérielles, juridiques et économiques de la création comme une partie intégrante de la responsabilité artistique. Son engagement relie ainsi production des œuvres, transmission des connaissances et défense de la liberté d’expression dans sa diversité culturelle.`,
        `Présent dans des [[COLLECTIONS]] privées, publiques et muséales, notamment celle de la Fondation Clément, [[GOODY]] a reçu la médaille de bronze du [[PRIX_ART]] pour l’édition 2019, puis une médaille d’or pour l’édition 2023. En 2026, son travail est présenté au Fonds d’art contemporain du Département de la Guadeloupe, à la PooL Art Fair de Pointe-à-Pitre et au Marché d’art de la Fondation Clément. À travers ces circulations, son œuvre poursuit une même interrogation : comment représenter un monde dont l’unité apparente est continuellement travaillée par des histoires, des temporalités et des vérités multiples ? Pour [[GOODY]], la réponse ne réside pas dans une image définitive, mais dans une forme capable de continuer à penser.`
      ],
      copyright: `<em>Le [[POSO]], l’[[ART_POSO]] et les concepts associés sont la propriété intellectuelle de [[GOODY]] – Gilles EUGENE. © ADAGP Paris 2024.</em>`
    },

    en: {
      eyebrow: "Biography",
      title: "[[GOODY]]",
      close: "Close",
      listen: "Listen",
      stop: "Stop",
      paragraphs: [
        `An active figure in the Guadeloupean art scene, [[GOODY]] — Gilles EUGENE, born in 1975 — has developed since the turn of the 2000s a transdisciplinary body of work situated at the boundaries of abstraction, figuration and symbolic writing. Through painting, drawing, sculpture, installation, performance and digital practices, he examines the complexity of the world, memory, territory, systems of belief, the circulation of knowledge and the coexistence of opposites. His work now finds its theoretical architecture in [[POSO]], a thought of the [[MULTIPLE_CAP]] that regards each form, each body of knowledge and each point of view as a mobile component of an ensemble always in the making.`,
        `[[GOODY]] was born on 22 November 1975 in Guadeloupe, a territory whose geography, composite history and cultural tensions form the primary matrix of his work. Self-taught, he first pursued a path in commercial management before devoting himself to creation and formally registering his activity as an artist-author in November 2000. As early as 2001, his exhibition <em>[[MULTIPLE_EXPO]]</em>, presented at the Centre des Arts et de la Culture in Pointe-à-Pitre, stated an intuition that would run through his entire practice: the individual, society and history cannot be grasped as stable units, but as aggregates of fragments, contradictions, inheritances and becomings.`,
        `The first cycles — <em>Urbanis</em> in 2003 and 2005, <em>Distension</em> in 2006, <em>La Marche du temps</em> in 2008, followed by <em>Péyi-la</em> between 2010 and 2013 — established a visual grammar grounded in stratification, fragmentation and tension. Colour does more than fill forms: it sets them in motion, disassembles them and recomposes them. When [[GOODY]] took part in the 2011 exhibition <em>Jeunes plasticiens de Guadeloupe</em> at the Fondation Clément, curator Michel Rovélas noted earthy dominant hues in his paintings, a powerful sense of depth and fragments pointing in contradictory directions, charged with an energy at times contained and at times frenetic. The pictorial space consequently becomes less a place of representation than a field of forces: something comes apart there while something else seeks to emerge.`,
        `In <em>Péyi-la</em>, territory is reduced neither to landscape nor to identity. It becomes a mental, social and historical matrix in which belonging, rupture, resistance and displacement coexist. Titles in Creole, French, English or Latin do more than mark a change of language: they shift the thresholds of reading and turn the work into a polyphonic space. Paintings such as <em>Pa pè</em>, <em>Dékatman</em>, <em>Tonbé</em> and <em>Fearless</em> bring the body, fear, falling and resistance into play while keeping open the relation between individual experience and collective memory.`,
        `From 2015 onward, the cycle <em>Ordo ab Chaos</em>, presented in Guadeloupe, Miami and then Cascais in Portugal, deepened this thought of antagonisms. [[GOODY]] explored the capacity of ruptures, disorders and oppositions to produce new organisations. Chaos does not function there as the reverse of order, but as its potential reserve: a milieu in which lines, colours, figures and symbols can generate provisional balances. This period accompanied the geographical expansion of his work, shown notably in the United States, Portugal, the United Kingdom, Russia, Italy and Colombia, while preserving its Guadeloupean archipelagic grounding.`,
        `Presented in 2019 at the Centre culturel Rémy Nainsouta in Pointe-à-Pitre, the series <em>Rézonans</em> shifted this inquiry towards the relations between speech, history and transmission. Words and wounds answer one another like delayed echoes. The work becomes the place where events that remain active in memory can be recognised, traversed and reinterpreted. Detail, sometimes almost buried within the composition, acts as a key to the general discourse: an apparently secondary element can alter the whole field of meaning and make visible what dominant history had relegated to its margins.`,
        `This evolving conception of the work appears with particular intensity in <em>Les œuvres prolongées</em>. Begun in 2015–2016 and resumed after his return to Guadeloupe from 2022 onward, this body of work refuses to treat the painting as a definitively completed object. [[GOODY]] returns to certain works several years after their first making, not to correct or repeat them, but to reveal lines, tensions and strata that had remained in reserve. Through [[PEINDRE]], he turns time into a visual material. The work retains its first identity while welcoming its own becoming; extended through new pictorial interventions and later through literary creations, it remains open to other states of itself.`,
        `In January 2025, [[GOODY]] gathered the dispersed dimensions of this inquiry under the name [[POSO]] and inscribed his work within the cycle [[CHEMIN]]. [[POSO]] designates more than a visual style: it proposes a method of questioning, addition and relational activation among forms of knowledge, educations, thoughts, symbols, rituals, inheritances and points of view. Rather than resolving contradictions, [[GOODY]] keeps them present in order to examine what they produce together. [[ART_POSO]] thus takes shape as a space of relation in which plurality is neither reduced to unity nor abandoned to dispersion.`,
        `This thought extends beyond the studio. [[GOODY]] works in school, socio-educational and prison environments while contributing to the professional development of artist-authors and to the economic structuring of the visual arts in Guadeloupe. As Secretary-General of the CAAP and regional delegate for Guadeloupe, he regards the material, legal and economic conditions of creation as an integral part of artistic responsibility. His commitment consequently connects the production of works, the transmission of knowledge and the defence of freedom of expression in its cultural diversity.`,
        `Represented in private, public and museum [[COLLECTIONS]], including that of the Fondation Clément, [[GOODY]] received the bronze medal of the [[PRIX_ART]] for the 2019 edition, followed by a gold medal for the 2023 edition. In 2026, his work is presented at the Fonds d’art contemporain du Département de la Guadeloupe, the PooL Art Fair in Pointe-à-Pitre and the Marché d’art of the Fondation Clément. Across these circulations, his work pursues the same question: how can one represent a world whose apparent unity is continually worked through by multiple histories, temporalities and truths? For [[GOODY]], the answer lies not in a definitive image, but in a form capable of continuing to think.`
      ],
      copyright: `<em>[[POSO]], [[ART_POSO]] and the associated concepts are the intellectual property of [[GOODY]] – Gilles EUGENE. © ADAGP Paris 2024.</em>`
    },

    es: {
      eyebrow: "Biografía",
      title: "[[GOODY]]",
      close: "Cerrar",
      listen: "Escuchar",
      stop: "Detener",
      paragraphs: [
        `Figura activa de la escena artística guadalupeña, [[GOODY]] — Gilles EUGENE, nacido en 1975 — desarrolla desde el cambio de milenio una obra transdisciplinar situada en las fronteras de la abstracción, la figuración y la escritura simbólica. Mediante la pintura, el dibujo, la escultura, la instalación, la performance y las prácticas digitales, interroga la complejidad del mundo, la memoria, el territorio, los sistemas de creencias, la circulación de los saberes y la coexistencia de los contrarios. Su obra encuentra hoy su arquitectura teórica en [[POSO]], pensamiento del [[MULTIPLE_CAP]] que considera cada forma, cada conocimiento y cada punto de vista como un componente móvil de un conjunto siempre en devenir.`,
        `[[GOODY]] nace el 22 de noviembre de 1975 en Guadalupe, territorio cuya geografía, historia compuesta y tensiones culturales constituyen la matriz primera de su trabajo. Autodidacta, sigue inicialmente una trayectoria en la gestión comercial antes de dedicarse a la creación y declarar su actividad de artista-autor en noviembre de 2000. Ya en 2001, su exposición <em>[[MULTIPLE_EXPO]]</em>, presentada en el Centre des Arts et de la Culture de Pointe-à-Pitre, enuncia una intuición que atravesará toda su obra: el individuo, la sociedad y la historia no pueden comprenderse como unidades estables, sino como agregados de fragmentos, contradicciones, herencias y devenires.`,
        `Los primeros ciclos — <em>Urbanis</em> en 2003 y 2005, <em>Distension</em> en 2006, <em>La Marche du temps</em> en 2008 y luego <em>Péyi-la</em> entre 2010 y 2013 — instalan una gramática plástica fundada en la estratificación, la fragmentación y la tensión. El color no se limita a llenar las formas: las pone en movimiento, las desarticula y las recompone. Cuando [[GOODY]] participa en 2011 en la exposición <em>Jeunes plasticiens de Guadeloupe</em> en la Fondation Clément, el comisario Michel Rovélas señala en sus pinturas dominantes terrosas, una intensa sensación de profundidad y fragmentos orientados en direcciones contradictorias, cargados de una energía a veces contenida y a veces frenética. El espacio pictórico se convierte así menos en un lugar de representación que en un campo de fuerzas: algo se deshace mientras otra cosa intenta advenir.`,
        `En <em>Péyi-la</em>, el territorio no se reduce ni al paisaje ni a la identidad. Se convierte en una matriz mental, social e histórica en la que coexisten pertenencias, rupturas, resistencias y desplazamientos. Los títulos en criollo, francés, inglés o latín no expresan un simple cambio de lengua: desplazan los umbrales de lectura y hacen de la obra un espacio polifónico. Cuadros como <em>Pa pè</em>, <em>Dékatman</em>, <em>Tonbé</em> o <em>Fearless</em> ponen en juego el cuerpo, el miedo, la caída y la resistencia, manteniendo abierta la relación entre la experiencia individual y la memoria colectiva.`,
        `A partir de 2015, el ciclo <em>Ordo ab Chaos</em>, presentado en Guadalupe, Miami y después en Cascais, Portugal, profundiza este pensamiento de los antagonismos. [[GOODY]] explora allí la capacidad de las rupturas, los desórdenes y las oposiciones para producir nuevas organizaciones. El caos no constituye el reverso del orden, sino su reserva potencial: un medio en el que líneas, colores, figuras y símbolos pueden engendrar equilibrios provisionales. Este periodo acompaña la ampliación geográfica de su trabajo, expuesto especialmente en Estados Unidos, Portugal, Reino Unido, Rusia, Italia y Colombia, sin que esa expansión borre su anclaje archipelágico guadalupeño.`,
        `Presentada en 2019 en el Centre culturel Rémy Nainsouta de Pointe-à-Pitre, la serie <em>Rézonans</em> desplaza esta investigación hacia las relaciones entre palabra, historia y transmisión. Las palabras y los males se responden como ecos diferidos. La obra se convierte en el lugar donde los acontecimientos que permanecen activos en las memorias pueden ser reconocidos, atravesados y reinterpretados. El detalle, a veces casi sepultado en la composición, actúa como una clave del discurso general: un elemento aparentemente secundario puede modificar el conjunto del sentido y hacer visible aquello que la historia dominante había relegado a su periferia.`,
        `Esta concepción evolutiva de la obra se manifiesta con especial intensidad en <em>Les œuvres prolongées</em>. Iniciado en 2015–2016 y retomado tras el regreso a Guadalupe, a partir de 2022, este conjunto rechaza considerar el cuadro como un objeto definitivamente concluido. [[GOODY]] vuelve a determinadas obras varios años después de su primera realización, no para corregirlas o repetirlas, sino para revelar líneas, tensiones y estratos que permanecían en reserva. Mediante [[PEINDRE]], convierte el tiempo en material plástico. La obra conserva su identidad primera a la vez que acoge su propio devenir; prolongada por nuevas intervenciones pictóricas y posteriormente por creaciones literarias, permanece abierta a otros estados de sí misma.`,
        `En enero de 2025, [[GOODY]] reúne las dimensiones dispersas de esta investigación bajo el nombre de [[POSO]] e inscribe su trabajo en el ciclo [[CHEMIN]]. [[POSO]] no designa únicamente un estilo visual: propone un método de interrogación, adición y puesta en relación de saberes, educaciones, pensamientos, símbolos, rituales, herencias y puntos de vista. En lugar de resolver las contradicciones, [[GOODY]] las mantiene presentes para examinar lo que producen juntas. [[ART_POSO]] se construye así como un espacio de relación en el que la pluralidad no se reduce a la unidad ni se abandona a la dispersión.`,
        `Este pensamiento rebasa el campo del taller. [[GOODY]] interviene en medios escolares, socioeducativos y penitenciarios, al tiempo que participa en la profesionalización de los artistas-autores y en la estructuración económica de las artes visuales en Guadalupe. Secretario general del CAAP y delegado regional para Guadalupe, considera las condiciones materiales, jurídicas y económicas de la creación como una parte integrante de la responsabilidad artística. Su compromiso vincula así la producción de las obras, la transmisión de los conocimientos y la defensa de la libertad de expresión en su diversidad cultural.`,
        `Presente en [[COLLECTIONS]] privadas, públicas y museísticas, entre ellas la de la Fondation Clément, [[GOODY]] recibió la medalla de bronce del [[PRIX_ART]] en la edición de 2019 y posteriormente una medalla de oro en la edición de 2023. En 2026, su trabajo se presenta en el Fonds d’art contemporain du Département de la Guadeloupe, en la PooL Art Fair de Pointe-à-Pitre y en el Marché d’art de la Fondation Clément. A través de estas circulaciones, su obra mantiene una misma interrogación: ¿cómo representar un mundo cuya unidad aparente está continuamente trabajada por historias, temporalidades y verdades múltiples? Para [[GOODY]], la respuesta no reside en una imagen definitiva, sino en una forma capaz de seguir pensando.`
      ],
      copyright: `<em>[[POSO]], [[ART_POSO]] y los conceptos asociados son propiedad intelectual de [[GOODY]] – Gilles EUGENE. © ADAGP Paris 2024.</em>`
    }
  };

  function roots(){
    return Array.prototype.slice.call(document.querySelectorAll(ROOT_SELECTOR));
  }

  function getContent(lang){
    return CONTENT[normLang(lang)] || CONTENT.fr;
  }

  function setSlot(root,name,html){
    if(!root) return;
    root.querySelectorAll('[data-goody-bio-slot="'+name+'"]').forEach(function(node){
      node.innerHTML = html;
    });
  }

  function ensureControlStyles(){
    if(document.getElementById("goody-biography-controls-fallback-style")) return;
    var style = document.createElement("style");
    style.id = "goody-biography-controls-fallback-style";
    style.textContent = [
      ".goody-biography-panel__controlbar[data-goody-bio-controlbar]{display:flex!important;visibility:visible!important;opacity:1!important;pointer-events:auto!important;position:relative!important;z-index:2147483500!important;width:100%!important;align-items:center!important;justify-content:space-between!important;gap:18px!important;}",
      ".goody-biography-panel__languages,.goody-biography-panel__actions{display:flex!important;visibility:visible!important;opacity:1!important;pointer-events:auto!important;align-items:center!important;gap:12px!important;}",
      ".goody-biography-panel__actions{margin-left:auto!important;}",
      ".goody-biography-panel__lang,.goody-biography-panel__audio,.goody-biography-panel__close{display:inline-flex!important;visibility:visible!important;opacity:1!important;pointer-events:auto!important;align-items:center!important;justify-content:center!important;border-radius:999px!important;border:1px solid #d4af37!important;background:#d4af37!important;color:#fff!important;font-size:1.26rem!important;font-weight:700!important;padding:12px 20px!important;}",
      ".goody-biography-panel__lang{min-width:63px!important;}",
      ".goody-biography-panel__audio,.goody-biography-panel__close{gap:.63rem!important;}",
      ".goody-biography-panel__lang.is-active{background:#b8891f!important;border-color:#b8891f!important;}",
      "@media(max-width:749px){.goody-biography-panel__controlbar[data-goody-bio-controlbar]{flex-wrap:nowrap!important;justify-content:space-between!important;column-gap:clamp(1rem,8vw,4rem)!important;}.goody-biography-panel__languages{flex:0 0 auto!important;justify-content:flex-start!important;gap:.15rem!important;}.goody-biography-panel__actions{flex:0 0 auto!important;margin-left:auto!important;justify-content:flex-end!important;gap:.30rem!important;}.goody-biography-panel__lang{min-width:3.525rem!important;padding:.75rem .63rem!important;font-size:1.35rem!important;}.goody-biography-panel__audio,.goody-biography-panel__close{padding:.75rem .84rem!important;font-size:1.41rem!important;white-space:nowrap!important;}}",
      "@media(max-width:430px){.goody-biography-panel__controlbar[data-goody-bio-controlbar]{column-gap:.75rem!important;}.goody-biography-panel__languages{gap:.09rem!important;}.goody-biography-panel__actions{gap:.18rem!important;}.goody-biography-panel__lang{min-width:3.18rem!important;padding:.66rem .51rem!important;font-size:1.245rem!important;}.goody-biography-panel__audio,.goody-biography-panel__close{padding:.675rem .645rem!important;font-size:1.29rem!important;}}"
    ].join("");
    document.head.appendChild(style);
  }

  function ensureControls(root){
    if(!root) return;
    ensureControlStyles();
    var surface = root.querySelector(".goody-biography-panel__surface") || root;
    var scroll = root.querySelector("[data-goody-bio-scroll]");
    var bar = root.querySelector("[data-goody-bio-controlbar]");
    if(!bar){
      bar = document.createElement("div");
      bar.className = "goody-biography-panel__controlbar";
      bar.setAttribute("data-goody-bio-controlbar","");
      if(scroll && scroll.parentNode) scroll.parentNode.insertBefore(bar,scroll);
      else surface.insertBefore(bar,surface.firstChild);
    }

    var languages = bar.querySelector(".goody-biography-panel__languages");
    if(!languages){
      languages = document.createElement("div");
      languages.className = "goody-biography-panel__languages";
      languages.setAttribute("role","group");
      languages.setAttribute("aria-label","Choix de langue");
      bar.appendChild(languages);
    }

    ["fr","en","es"].forEach(function(code){
      if(languages.querySelector('[data-goody-bio-lang="'+code+'"]')) return;
      var button = document.createElement("button");
      button.type = "button";
      button.className = "goody-biography-panel__lang";
      button.setAttribute("data-goody-bio-lang",code);
      button.setAttribute("aria-pressed","false");
      button.textContent = code.toUpperCase();
      languages.appendChild(button);
    });

    var actions = bar.querySelector(".goody-biography-panel__actions");
    if(!actions){
      actions = document.createElement("div");
      actions.className = "goody-biography-panel__actions";
      bar.appendChild(actions);
    }

    var audio = bar.querySelector("[data-goody-bio-audio]");
    if(!audio){
      audio = document.createElement("button");
      audio.type = "button";
      audio.className = "goody-biography-panel__audio";
      audio.setAttribute("data-goody-bio-audio","");
      audio.setAttribute("aria-pressed","false");
      audio.innerHTML = '<span class="goody-biography-panel__audio-icon" aria-hidden="true">▶</span><span data-goody-bio-slot="audio_label">Écouter</span>';
      actions.appendChild(audio);
    }else if(audio.parentNode !== actions){
      actions.appendChild(audio);
    }

    var close = bar.querySelector("[data-goody-bio-close]");
    if(!close){
      close = document.createElement("button");
      close.type = "button";
      close.className = "goody-biography-panel__close goody-biography-panel__close--controlbar";
      close.setAttribute("data-goody-bio-close","");
      close.innerHTML = '<span aria-hidden="true">×</span><span data-goody-bio-slot="close_label">Fermer</span>';
      actions.appendChild(close);
    }else if(close.parentNode !== actions){
      actions.appendChild(close);
    }
  }

  function render(root,lang){
    if(!root) return;
    ensureControls(root);
    var l = normLang(lang);
    var data = getContent(l);
    root.setAttribute("lang",l);

    var portrait = root.querySelector("[data-goody-bio-image]");
    if(portrait){
      portrait.src = BIO_IMAGE.src;
      portrait.alt = BIO_IMAGE.alt[l] || BIO_IMAGE.alt.fr;
      portrait.setAttribute("lang",l);
    }

    setSlot(root,"eyebrow",escapeHTML(data.eyebrow));
    setSlot(root,"title",expandTokens(data.title,l));
    setSlot(root,"close_label",escapeHTML(data.close));
    setSlot(root,"audio_label",escapeHTML(audioState.active ? data.stop : data.listen));

    var body = root.querySelector("[data-goody-bio-body]");
    if(body){
      var html = data.paragraphs.map(function(paragraph){
        return '<p>'+expandTokens(paragraph,l)+'</p>';
      }).join("");
      html += '<p class="goody-biography-panel__copyright">'+expandTokens(data.copyright,l)+'</p>';
      body.innerHTML = html;
    }

    root.querySelectorAll("[data-goody-bio-lang]").forEach(function(button){
      var active = normLang(button.getAttribute("data-goody-bio-lang")) === l;
      button.classList.toggle("is-active",active);
      button.setAttribute("aria-pressed",active ? "true" : "false");
    });

    var audioButton = root.querySelector("[data-goody-bio-audio]");
    if(audioButton){
      var audioLabel = audioState.active ? data.stop : data.listen;
      audioButton.setAttribute("aria-pressed",audioState.active ? "true" : "false");
      audioButton.setAttribute("aria-label",audioLabel);
      audioButton.setAttribute("title",audioLabel);
      audioButton.classList.toggle("is-playing",audioState.active);
    }
  }

  function setLang(lang,notify){
    var l = storeLang(lang);
    stopAudio(false);
    roots().forEach(function(root){ render(root,l); });
    if(notify !== false){
      try{ window.dispatchEvent(new CustomEvent("po:locale-changed",{detail:{lang:l,source:"goody-biography"}})); }
      catch(e){ try{ window.dispatchEvent(new Event("po:locale-changed")); }catch(_e){} }
    }
    return l;
  }

  function textChunks(text,maxLength){
    var clean = str(text).replace(/\s+/g," ").trim();
    if(!clean) return [];
    var sentences = clean.match(/[^.!?…]+[.!?…]+|[^.!?…]+$/g) || [clean];
    var chunks = [];
    var current = "";
    sentences.forEach(function(sentence){
      var s = sentence.trim();
      if(!s) return;
      if((current+" "+s).trim().length <= maxLength){
        current = (current+" "+s).trim();
      }else{
        if(current) chunks.push(current);
        while(s.length > maxLength){
          var cut = s.lastIndexOf(" ",maxLength);
          if(cut < Math.floor(maxLength*.55)) cut = maxLength;
          chunks.push(s.slice(0,cut).trim());
          s = s.slice(cut).trim();
        }
        current = s;
      }
    });
    if(current) chunks.push(current);
    return chunks;
  }

  function voiceFor(lang){
    if(!synth || !synth.getVoices) return null;
    var code = lang === "en" ? "en" : (lang === "es" ? "es" : "fr");
    var voices = synth.getVoices() || [];
    for(var i=0;i<voices.length;i++){
      if(str(voices[i].lang).toLowerCase().indexOf(code) === 0) return voices[i];
    }
    return null;
  }

  function updateAudioUI(root){
    var l = normLang(root ? root.getAttribute("lang") : audioState.lang);
    var data = getContent(l);
    var button = root ? root.querySelector("[data-goody-bio-audio]") : null;
    if(button){
      var labelText = audioState.active ? data.stop : data.listen;
      button.setAttribute("aria-pressed",audioState.active ? "true" : "false");
      button.setAttribute("aria-label",labelText);
      button.setAttribute("title",labelText);
      button.classList.toggle("is-playing",audioState.active);
      var label = button.querySelector('[data-goody-bio-slot="audio_label"]');
      if(label) label.textContent = labelText;
    }
  }

  function speakNext(root){
    if(!synth || !audioState.active) return;
    if(audioState.index >= audioState.chunks.length){
      audioState.active = false;
      audioState.index = 0;
      audioState.chunks = [];
      updateAudioUI(root);
      return;
    }

    var utterance = new SpeechSynthesisUtterance(audioState.chunks[audioState.index]);
    utterance.lang = audioState.lang === "en" ? "en-US" : (audioState.lang === "es" ? "es-ES" : "fr-FR");
    utterance.rate = .96;
    utterance.pitch = 1;
    var voice = voiceFor(audioState.lang);
    if(voice) utterance.voice = voice;
    utterance.onend = function(){ audioState.index += 1; speakNext(root); };
    utterance.onerror = function(){ stopAudio(true); };
    synth.speak(utterance);
  }

  function startAudio(root){
    if(!root) return;
    if(!synth){
      var button = root.querySelector("[data-goody-bio-audio]");
      if(button){
        var label = button.querySelector('[data-goody-bio-slot="audio_label"]');
        if(label) label.textContent = normLang(root.getAttribute("lang")) === "en" ? "Audio unavailable" : (normLang(root.getAttribute("lang")) === "es" ? "Audio no disponible" : "Audio indisponible");
      }
      return;
    }
    stopAudio(false);
    var body = root.querySelector("[data-goody-bio-body]");
    var title = root.querySelector("[data-goody-bio-slot='title']");
    var text = ((title ? title.textContent+". " : "") + (body ? body.textContent : "")).trim();
    audioState.lang = normLang(root.getAttribute("lang"));
    audioState.chunks = textChunks(text,210);
    audioState.index = 0;
    audioState.active = audioState.chunks.length > 0;
    updateAudioUI(root);
    if(audioState.active){
      try{ synth.resume(); }catch(e){}
      speakNext(root);
    }
  }

  function stopAudio(showStopped){
    if(synth){
      try{ synth.cancel(); }catch(e){}
    }
    audioState.active = false;
    audioState.index = 0;
    audioState.chunks = [];
    roots().forEach(function(root){ updateAudioUI(root); });
  }

  function openPanel(trigger){
    var root = document.querySelector(ROOT_SELECTOR);
    if(!root) return false;
    lastTrigger = trigger || document.activeElement || null;
    stopAudio(false);
    render(root,readLang());
    root.hidden = false;
    root.setAttribute("aria-hidden","false");
    document.documentElement.classList.add("goody-biography-open");
    if(document.body) document.body.classList.add("goody-biography-open");
    requestAnimationFrame(function(){
      root.classList.add("is-open");
      var scroll = root.querySelector("[data-goody-bio-scroll]");
      if(scroll){ scroll.scrollTop = 0; }
      var close = root.querySelector("[data-goody-bio-close]");
      if(close) close.focus({preventScroll:true});
    });
    try{ window.dispatchEvent(new CustomEvent("goody:biography-opened")); }catch(e){}
    return true;
  }

  function closePanel(){
    var root = document.querySelector(ROOT_SELECTOR);
    if(!root) return false;
    stopAudio(false);
    root.classList.remove("is-open");
    document.documentElement.classList.remove("goody-biography-open");
    if(document.body) document.body.classList.remove("goody-biography-open");
    window.setTimeout(function(){
      root.hidden = true;
      root.setAttribute("aria-hidden","true");
      if(lastTrigger && typeof lastTrigger.focus === "function"){
        try{ lastTrigger.focus({preventScroll:true}); }catch(e){ try{ lastTrigger.focus(); }catch(_e){} }
      }
    },430);
    try{ window.dispatchEvent(new CustomEvent("goody:biography-closed")); }catch(e){}
    return true;
  }

  function focusables(root){
    if(!root) return [];
    return Array.prototype.slice.call(root.querySelectorAll('button:not([disabled]),a[href],input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])'))
      .filter(function(node){ return !node.hidden && node.offsetParent !== null; });
  }

  function onDocumentClick(event){
    var trigger = event.target && event.target.closest ? event.target.closest(TRIGGER_SELECTOR) : null;
    if(trigger){
      event.preventDefault();
      event.stopPropagation();
      openPanel(trigger);
      return;
    }

    var close = event.target && event.target.closest ? event.target.closest("[data-goody-bio-close]") : null;
    if(close){
      event.preventDefault();
      closePanel();
      return;
    }

    var langButton = event.target && event.target.closest ? event.target.closest("[data-goody-bio-lang]") : null;
    if(langButton){
      event.preventDefault();
      setLang(langButton.getAttribute("data-goody-bio-lang"),true);
      return;
    }

    var audioButton = event.target && event.target.closest ? event.target.closest("[data-goody-bio-audio]") : null;
    if(audioButton){
      event.preventDefault();
      var root = audioButton.closest(ROOT_SELECTOR);
      if(audioState.active) stopAudio(true); else startAudio(root);
    }
  }

  function onDocumentKeydown(event){
    var root = document.querySelector(ROOT_SELECTOR+".is-open");
    if(!root) return;
    if(event.key === "Escape"){
      event.preventDefault();
      closePanel();
      return;
    }
    if(event.key === "Tab"){
      var items = focusables(root);
      if(!items.length) return;
      var first = items[0];
      var last = items[items.length-1];
      if(event.shiftKey && document.activeElement === first){ event.preventDefault(); last.focus(); }
      else if(!event.shiftKey && document.activeElement === last){ event.preventDefault(); first.focus(); }
    }
  }



  /* ============================================================================
  LIBELLULE SVG RÉALISTE — INJECTION, STYLES ET VOL
  - SVG injecté par le présent asset JS afin d’alléger le bloc Liquid.
  - Taille réduite de 50 %.
  - Battement des ailes augmenté de 50 %.
  - Vol ample, irrégulier et limité à la partie haute du panneau.
  ============================================================================ */
  var GOODY_REAL_DRAGONFLY_SVG = `<svg class="goody-real-dragonfly__svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 936 1280" preserveAspectRatio="xMidYMid meet" aria-hidden="true">
      <defs>
        <g id="goodyDragonflySource" transform="translate(0.000000,936.000000) scale(0.100000,-0.100000)"
    fill="currentColor" stroke="none">
    <path d="M6505 9315 c-47 -59 -89 -81 -122 -66 -59 27 -227 -5 -270 -51 -38
    -40 -87 -158 -91 -219 -9 -129 81 -265 190 -284 57 -11 64 -26 39 -87 -34 -86
    -74 -268 -75 -343 0 -42 5 -83 14 -103 14 -30 13 -36 -8 -75 -26 -50 -28 -74
    -6 -105 22 -32 11 -56 -24 -48 -86 18 -531 99 -667 121 -88 14 -243 42 -345
    61 -209 40 -481 87 -805 139 -241 38 -592 109 -780 156 -141 36 -342 80 -546
    119 -226 43 -436 88 -519 112 -41 11 -127 32 -190 45 -307 65 -495 101 -501
    97 -4 -2 -5 -13 -2 -23 6 -25 -23 -68 -58 -86 -24 -13 -30 -13 -43 0 -12 12
    -13 22 -6 41 18 46 10 49 -25 9 l-34 -40 -58 20 c-54 18 -58 23 -63 55 -5 34
    -6 34 -18 13 -9 -17 -22 -23 -46 -23 -40 0 -54 24 -31 50 20 22 19 46 -2 55
    -10 4 -72 11 -138 15 -66 5 -192 19 -280 31 -123 17 -208 23 -365 23 -233 0
    -366 -17 -454 -57 -93 -43 -122 -71 -150 -145 l-26 -67 20 -41 c12 -23 25 -70
    31 -105 6 -35 18 -82 28 -104 23 -51 148 -213 221 -286 60 -60 168 -138 206
    -148 14 -3 41 -28 62 -55 28 -38 64 -65 147 -114 60 -35 132 -73 160 -83 66
    -24 395 -204 510 -278 128 -83 406 -225 500 -256 44 -15 112 -40 150 -56 39
    -16 108 -38 155 -49 47 -12 164 -44 260 -72 100 -29 256 -64 370 -83 202 -35
    442 -84 662 -136 150 -35 302 -59 374 -59 46 0 52 3 58 24 10 40 234 130 280
    113 28 -11 17 -22 -56 -58 -40 -19 -91 -49 -115 -66 -55 -42 -97 -59 -164 -68
    -30 -4 -110 -20 -179 -35 -115 -27 -394 -79 -500 -95 -106 -16 -352 -67 -449
    -94 -236 -65 -416 -98 -686 -125 -82 -9 -190 -27 -240 -40 -557 -152 -638
    -179 -842 -281 -137 -69 -181 -96 -241 -150 -88 -81 -124 -131 -148 -208 -18
    -58 -18 -59 3 -75 11 -10 23 -29 27 -44 9 -41 120 -135 211 -178 88 -42 224
    -89 325 -113 36 -8 94 -22 130 -30 150 -36 363 -57 720 -72 285 -12 578 -51
    750 -100 47 -13 141 -29 210 -35 69 -6 143 -15 166 -20 22 -5 123 -16 225 -25
    101 -8 252 -25 334 -36 156 -22 248 -22 480 2 240 24 473 83 700 178 70 30
    368 149 500 201 269 106 520 269 734 480 139 136 182 227 196 415 10 143 68
    401 96 429 26 27 33 -21 46 -274 7 -144 17 -276 22 -295 6 -24 5 -58 -4 -112
    -10 -55 -15 -175 -15 -408 -1 -181 -6 -379 -13 -440 -15 -145 -13 -566 3 -732
    12 -128 12 -135 -11 -215 -22 -81 -23 -93 -20 -473 2 -374 1 -393 -19 -455
    -21 -64 -21 -69 -10 -450 6 -212 16 -398 21 -413 11 -37 -7 -373 -26 -487 -22
    -128 -19 -171 15 -251 l31 -70 -46 -180 c-34 -136 -45 -200 -45 -258 0 -72 1
    -77 30 -101 l30 -25 -26 -145 c-36 -209 -40 -268 -20 -327 9 -26 24 -102 32
    -168 21 -162 47 -250 80 -271 23 -16 27 -16 41 -1 14 14 14 22 3 62 -8 29 -10
    68 -6 107 6 63 18 88 42 88 7 0 29 14 47 30 19 17 42 30 50 30 25 0 55 -78 77
    -204 24 -135 31 -156 55 -176 15 -13 19 -12 36 9 11 13 19 37 19 55 0 17 5
    113 10 213 8 161 12 188 35 244 43 102 44 150 1 272 -38 110 -44 167 -26 245
    11 44 8 67 -28 242 -10 52 -24 127 -30 165 -6 39 -14 84 -17 100 -5 25 -1 36
    24 63 l31 32 -1 117 c0 65 -5 156 -10 203 -16 143 -30 1319 -17 1440 9 85 18
    672 21 1375 0 55 -5 298 -11 541 -11 407 -9 997 4 1192 4 55 10 82 18 82 13 0
    92 -171 107 -230 4 -19 15 -96 25 -170 19 -159 42 -254 79 -333 24 -51 37 -64
    109 -111 98 -64 184 -114 331 -191 61 -32 151 -82 200 -111 161 -94 378 -157
    677 -195 153 -19 234 -34 503 -94 295 -65 402 -70 609 -30 132 26 287 51 691
    110 415 60 599 96 739 145 89 30 290 65 701 120 204 27 393 53 420 56 47 6
    410 146 570 219 114 53 140 96 124 215 -16 112 -84 201 -242 314 -106 76 -323
    162 -521 207 -94 21 -205 48 -246 59 -115 32 -178 39 -397 49 -111 5 -206 12
    -211 15 -4 3 -77 12 -162 21 -85 9 -156 18 -159 20 -3 2 -82 8 -176 14 -219
    15 -350 28 -450 46 -45 8 -187 30 -317 49 -246 36 -253 38 -398 117 -30 17
    -94 49 -142 72 -111 52 -117 72 -19 64 79 -7 155 -41 289 -131 46 -31 82 -49
    82 -42 0 17 -100 90 -202 146 -88 49 -103 66 -65 75 50 13 263 -107 335 -189
    17 -20 37 -36 44 -36 7 0 48 15 93 34 44 19 136 51 205 71 185 54 280 90 435
    168 77 38 245 116 373 173 229 103 345 169 505 292 69 53 346 202 431 233 138
    49 225 83 299 115 43 19 84 34 91 34 7 0 43 19 79 43 37 23 102 62 146 86 134
    73 333 276 400 408 6 12 11 38 11 57 0 42 -31 159 -53 203 -54 103 -249 183
    -442 183 -57 -1 -59 -1 -35 -15 14 -8 35 -14 47 -15 12 0 31 -10 43 -22 11
    -12 20 -17 20 -11 0 22 37 23 114 3 96 -26 141 -48 183 -92 51 -53 94 -168 63
    -168 -13 0 -119 58 -142 78 -10 8 -18 25 -18 36 -1 20 -1 20 -11 3 -6 -11 -25
    -25 -42 -32 l-30 -13 46 -20 c44 -20 59 -43 37 -57 -5 -3 -67 17 -138 45 -71
    28 -143 50 -163 49 -29 0 -24 -4 41 -27 60 -22 76 -31 78 -50 5 -31 -22 -38
    -64 -18 -19 9 -48 16 -65 16 -20 0 -38 9 -54 26 -21 22 -27 25 -40 14 -13 -11
    -34 -11 -115 0 -82 11 -108 11 -142 0 -24 -7 -47 -14 -53 -15 -5 -2 20 -4 56
    -4 36 -1 72 -7 81 -13 27 -22 29 -46 5 -63 -12 -8 -16 -15 -9 -15 8 0 28 -11
    45 -24 24 -17 50 -25 100 -29 51 -4 77 -11 105 -31 38 -26 72 -34 72 -17 0 5
    -14 11 -30 15 -18 3 -30 12 -30 21 0 18 31 20 48 3 7 -7 30 -17 50 -23 33 -9
    37 -14 40 -47 2 -29 -1 -39 -17 -48 -17 -9 -39 -4 -119 28 -162 66 -314 93
    -537 98 -104 2 -184 1 -177 -2 6 -3 12 -14 12 -25 0 -23 8 -24 29 -5 10 9 42
    16 81 17 57 3 69 0 93 -21 15 -13 27 -29 27 -36 0 -19 17 -26 38 -15 22 12
    116 -24 178 -69 23 -16 51 -30 61 -30 10 0 54 -16 98 -36 44 -20 114 -50 155
    -68 92 -39 100 -44 100 -62 0 -21 -32 -17 -105 12 -35 14 -70 24 -77 22 -7 -3
    13 -15 45 -28 60 -25 74 -41 52 -60 -10 -9 -28 -5 -77 15 -59 25 -166 66 -248
    95 -19 7 -63 16 -97 21 -65 8 -109 26 -138 56 -14 13 -21 14 -36 5 -16 -10
    -28 -9 -64 8 -50 23 -55 24 -55 11 0 -13 94 -47 210 -77 152 -39 177 -51 201
    -92 28 -46 47 -62 75 -62 13 0 36 -11 51 -25 23 -20 25 -26 14 -34 -16 -10
    -23 -8 -148 46 -45 19 -83 39 -83 44 0 4 7 12 16 17 14 8 13 10 -5 15 -14 3
    -21 0 -21 -9 0 -22 -27 -17 -33 6 -3 14 -14 20 -31 20 -15 0 -52 9 -84 19
    -116 39 -362 82 -506 89 -87 4 -141 11 -143 18 -2 6 4 21 14 33 18 22 21 22
    122 12 57 -6 126 -11 155 -11 81 1 33 17 -74 25 -52 4 -126 12 -165 18 -62 11
    -70 15 -73 36 -6 40 7 68 37 81 43 17 67 10 63 -20 -2 -25 -2 -24 25 7 16 17
    35 32 43 33 64 9 91 -20 65 -71 -22 -41 -9 -51 19 -16 25 31 38 34 57 11 15
    -18 89 -58 95 -51 3 2 -20 23 -49 45 -61 47 -121 118 -112 132 3 5 27 12 53
    15 88 12 152 26 158 36 4 6 -21 8 -68 3 -60 -5 -76 -4 -87 9 -36 44 13 77 114
    77 73 0 111 12 80 24 -9 3 -43 6 -76 6 -64 0 -84 15 -59 45 15 18 14 20 -22
    29 -34 8 -43 -6 -17 -27 16 -14 17 -21 9 -38 -14 -25 -45 -37 -114 -45 -59 -7
    -88 10 -79 46 4 14 0 20 -11 20 -25 0 -22 84 4 110 27 27 75 26 94 -1 14 -21
    14 -21 25 -1 17 31 43 36 63 12 l17 -21 12 23 c15 29 28 38 56 38 16 0 22 -7
    25 -27 l3 -28 15 30 c12 24 23 31 52 33 29 3 38 -1 43 -17 9 -29 19 -26 32 9
    9 24 17 30 42 30 25 0 34 -6 42 -27 l10 -27 19 32 c34 56 72 33 43 -26 -17
    -36 -42 -46 -171 -72 -100 -19 -139 -37 -60 -27 70 10 78 4 78 -58 0 -30 -4
    -65 -10 -79 -11 -31 4 -73 29 -80 9 -2 52 -7 96 -11 56 -4 76 -3 65 4 -8 6
    -34 11 -57 11 -23 0 -54 5 -68 10 -35 13 -29 43 10 51 l30 6 -30 4 c-27 4 -31
    8 -38 54 -15 87 -15 87 24 100 84 30 270 48 429 41 97 -4 161 -2 170 4 11 7
    -12 10 -76 10 -50 0 -116 5 -148 11 -41 7 -83 7 -148 -1 -104 -12 -109 -10
    -101 51 5 35 3 39 -21 45 -35 8 -138 -1 -386 -36 -341 -49 -774 -136 -970
    -195 -123 -38 -443 -117 -855 -211 -88 -20 -214 -53 -280 -75 -66 -21 -196
    -52 -289 -69 -96 -17 -220 -48 -286 -70 -129 -43 -206 -63 -440 -110 -85 -17
    -222 -49 -305 -70 -82 -22 -238 -55 -345 -75 -161 -29 -482 -101 -652 -146
    -47 -12 -52 -34 -5 -25 17 4 56 10 85 13 47 5 52 4 52 -14 0 -25 -19 -30 -149
    -39 l-94 -7 7 34 c18 92 18 129 2 169 -16 39 -15 42 9 100 36 84 40 147 17
    267 -22 118 -19 127 43 138 51 9 173 60 203 85 29 24 75 172 68 218 -13 88
    -101 214 -176 252 -19 10 -55 21 -79 25 -50 8 -86 41 -96 87 -10 42 -72 68
    -192 78 -56 5 -103 15 -118 24 -39 25 -60 19 -100 -29z m234 -31 c11 -4 9 -9
    -7 -25 -24 -22 -29 -58 -10 -77 10 -10 10 -17 0 -33 -12 -19 -11 -19 8 -9 15
    8 19 17 14 28 -19 48 -16 57 28 75 56 22 64 22 93 -8 35 -34 34 -86 -2 -115
    -16 -13 -35 -19 -48 -16 -12 3 -35 -3 -53 -14 -26 -16 -32 -26 -32 -54 0 -19
    -9 -50 -20 -70 l-21 -34 21 -20 c12 -11 20 -28 18 -38 -3 -15 -17 -17 -125
    -18 -109 -1 -124 -3 -152 -23 -59 -44 -64 -29 -21 57 22 44 26 60 16 60 -7 0
    -20 -10 -28 -22 -8 -12 -19 -18 -26 -14 -18 11 12 63 48 81 27 14 30 20 30 63
    0 26 -8 69 -17 96 l-18 48 53 49 52 48 92 -5 c51 -3 99 -8 107 -10z m-368 -64
    c11 -6 19 -21 19 -36 0 -14 9 -33 20 -42 19 -16 19 -19 4 -62 -8 -25 -22 -52
    -30 -61 -8 -8 -14 -21 -14 -27 0 -7 -11 -12 -25 -12 -23 0 -25 -4 -25 -42 0
    -24 -4 -49 -9 -57 -10 -16 -31 -6 -31 15 0 17 -16 19 -26 3 -3 -6 -15 -9 -25
    -6 -10 3 -21 2 -23 -2 -3 -4 3 -40 11 -80 14 -62 14 -74 2 -81 -16 -10 -70 17
    -77 39 -4 11 2 12 24 7 l29 -8 -23 25 c-13 13 -27 41 -33 61 -13 48 -28 46
    -22 -4 6 -45 -7 -52 -30 -17 -29 45 -39 104 -27 162 13 61 73 167 110 192 50
    35 162 53 201 33z m674 -117 c14 -13 16 -28 11 -71 -4 -30 -11 -63 -17 -74 -6
    -10 -9 -24 -7 -30 2 -5 16 13 32 42 30 55 71 84 86 60 5 -8 -5 -37 -28 -79
    -46 -86 -68 -109 -113 -121 -51 -14 -55 -24 -19 -50 20 -14 30 -30 30 -47 0
    -22 -3 -24 -27 -19 -14 4 -39 2 -55 -5 -38 -16 -55 -1 -63 60 -8 61 11 204 35
    258 36 82 96 116 135 76z m-235 -43 c0 -23 -18 -36 -32 -22 -7 7 -6 17 2 31
    13 24 30 19 30 -9z m368 -144 c-3 -33 -34 -49 -49 -25 -10 16 0 61 15 71 18
    12 37 -14 34 -46z m-6483 -14 c11 0 29 0 40 0 41 0 252 -23 308 -33 62 -13 74
    -31 33 -50 -19 -9 -46 -7 -120 10 -58 13 -127 20 -174 20 l-77 -2 55 -9 c105
    -19 130 -28 130 -46 0 -26 -20 -42 -55 -43 -26 0 -27 -2 -10 -9 42 -18 64 -11
    79 24 8 18 19 37 25 41 19 11 92 -6 109 -25 14 -18 17 -16 57 24 47 49 89 65
    114 42 11 -10 29 -13 59 -9 34 5 42 3 42 -11 0 -20 17 -21 37 0 22 22 59 15
    55 -11 -5 -33 -32 -45 -101 -45 -35 0 -62 -3 -58 -6 3 -3 86 -25 184 -49 98
    -24 229 -60 291 -79 63 -20 126 -36 140 -36 15 0 44 -9 64 -20 21 -11 56 -23
    79 -26 23 -4 51 -16 62 -27 17 -17 22 -17 43 -7 45 25 136 -35 120 -77 -7 -18
    -42 -14 -136 12 -30 9 -81 18 -113 22 l-59 6 4 -39 3 -39 -61 -3 c-45 -2 -64
    1 -74 12 -18 22 -6 43 32 59 35 15 65 44 55 53 -3 3 -22 1 -42 -6 -34 -11 -39
    -10 -89 23 -125 83 -221 112 -426 128 -135 11 -223 34 -255 66 -12 11 -19 12
    -29 4 -8 -7 -33 -15 -57 -20 l-44 -8 70 -7 c93 -10 140 -27 140 -51 0 -14 -10
    -21 -40 -28 -42 -9 -72 -6 -226 20 -92 15 -144 13 -123 -6 9 -9 408 -42 474
    -40 l35 1 -32 10 c-40 13 -43 34 -7 41 36 6 245 -10 297 -24 100 -26 217 -89
    217 -116 0 -18 -1 -18 -158 26 -62 17 -116 31 -121 31 -5 0 -8 -14 -7 -32 1
    -26 -3 -32 -28 -39 -69 -19 -126 21 -85 62 25 25 22 29 -32 36 l-42 6 22 -22
    c48 -48 1 -51 -254 -20 -120 14 -212 20 -310 17 l-140 -3 2 23 c3 24 1 25 -48
    15 -32 -6 -33 -7 -9 -13 63 -15 -1 -58 -88 -59 -45 -1 -69 22 -41 40 11 7 9 9
    -6 9 -30 0 -218 -68 -235 -85 -24 -25 5 -18 67 15 65 35 103 39 103 11 0 -13
    -17 -26 -57 -44 -50 -22 -53 -25 -23 -20 43 6 65 -14 56 -52 -8 -31 -97 -79
    -128 -69 -28 8 -65 95 -74 170 -7 65 2 83 32 66 16 -9 61 2 156 40 55 21 195
    38 324 38 l90 0 20 44 20 44 -50 10 c-85 18 -117 22 -112 13 3 -5 23 -11 45
    -15 71 -11 90 -58 29 -71 -43 -10 -96 3 -111 25 -15 26 -37 26 -37 1 0 -26
    -10 -31 -87 -42 -36 -5 -106 -23 -155 -39 -103 -35 -113 -35 -162 -15 -51 22
    -43 41 29 71 70 28 100 31 91 9 -8 -22 11 -18 89 19 l70 32 -95 -4 c-73 -3
    -107 -9 -145 -27 -59 -28 -79 -19 -49 22 12 16 31 33 44 40 13 6 29 25 36 41
    11 26 21 32 81 45 60 14 138 29 213 41 14 2 66 2 115 1 50 -2 99 -3 110 -3z
    m6095 -12 c0 -5 -2 -10 -4 -10 -3 0 -8 5 -11 10 -3 6 -1 10 4 10 6 0 11 -4 11
    -10z m4404 -6 c21 -8 20 -27 -4 -73 -19 -39 -36 -51 -70 -51 -22 0 -30 18 -23
    56 10 53 54 84 97 68z m-4921 -70 c-3 -8 -9 -14 -14 -14 -14 0 -22 27 -14 48
    6 16 7 16 20 -1 8 -11 11 -25 8 -33z m4799 14 c13 -38 -8 -77 -57 -106 -45
    -26 -45 -26 97 4 72 15 89 16 102 5 15 -13 15 -16 0 -38 l-16 -25 44 7 c23 3
    57 9 74 11 38 7 57 -13 52 -57 -3 -29 -8 -33 -53 -46 -93 -27 -111 -27 -134
    -2 -26 28 -27 64 -3 78 25 16 -58 4 -140 -20 -86 -25 -95 -24 -162 10 l-57 29
    -23 -23 c-14 -14 -41 -25 -72 -29 -27 -4 -68 -16 -90 -26 -23 -10 -57 -21 -75
    -25 -19 -4 -51 -17 -71 -29 -33 -19 -38 -19 -55 -5 -10 9 -26 19 -35 22 -19 7
    -34 82 -23 117 8 26 73 56 87 42 7 -7 23 -2 45 14 20 13 42 24 49 24 21 0 32
    -30 26 -78 -7 -64 15 -46 24 19 11 86 38 101 199 113 22 2 53 8 69 15 38 15
    56 0 57 -48 l1 -36 10 35 c15 54 46 82 87 78 27 -2 36 -9 43 -30z m-4716 1
    c10 -17 -13 -36 -27 -22 -12 12 -4 33 11 33 5 0 12 -5 16 -11z m812 -6 c-2
    -10 -10 -18 -18 -18 -8 0 -16 8 -18 18 -2 12 3 17 18 17 15 0 20 -5 18 -17z
    m60 -19 c-5 -28 -28 -29 -28 -1 0 13 3 27 7 31 10 10 25 -10 21 -30z m-524 5
    c33 -16 28 -33 -10 -37 -35 -3 -126 30 -132 48 -6 16 101 7 142 -11z m96 -8
    c14 -27 13 -31 -9 -31 -22 0 -45 25 -36 40 10 16 33 12 45 -9z m255 -11 c0 -8
    -10 -16 -22 -18 -22 -3 -32 16 -16 32 12 11 38 2 38 -14z m-465 -35 c27 -14
    56 -25 65 -25 22 0 30 -27 14 -48 -13 -16 -12 -16 7 1 18 15 44 23 44 13 0 -2
    -7 -23 -15 -46 -17 -47 -20 -137 -5 -160 8 -12 10 -12 16 3 9 24 34 21 34 -3
    0 -22 -41 -70 -60 -70 -18 0 -10 -28 10 -33 26 -7 26 -34 0 -42 -27 -9 -59 11
    -66 40 -9 37 -22 30 -31 -17 l-9 -43 -81 0 c-67 0 -85 -3 -100 -19 -17 -18
    -17 -18 8 -12 16 3 33 0 45 -9 11 -8 42 -15 74 -15 74 0 102 -9 98 -29 -3 -13
    -20 -16 -108 -17 -59 -1 -139 -9 -183 -19 -71 -16 -79 -16 -102 -1 -57 38 -57
    87 0 286 43 150 66 199 115 251 36 38 38 39 109 39 57 0 82 -5 121 -25z m560
    10 c0 -27 -71 -48 -85 -26 -3 5 2 17 11 25 20 21 74 21 74 1z m-855 -14 c7
    -12 -12 -24 -25 -16 -11 7 -4 25 10 25 5 0 11 -4 15 -9z m-4406 -12 c36 -13
    39 -28 11 -54 -11 -10 -22 -26 -25 -36 -11 -33 -95 -14 -95 22 0 13 61 79 74
    79 2 0 17 -5 35 -11z m111 -48 c0 -27 -65 -92 -84 -85 -20 8 -20 27 0 65 23
    46 84 60 84 20z m4825 0 c9 -15 -94 -116 -106 -104 -15 15 4 55 41 86 33 28
    55 34 65 18z m-4695 -20 c0 -11 -4 -31 -10 -45 -12 -34 -9 -33 33 9 38 38 79
    46 112 21 18 -13 18 -15 1 -41 -28 -42 -8 -44 27 -2 36 42 67 49 67 15 -1 -13
    -7 -34 -15 -48 -17 -29 -18 -40 -6 -40 4 0 20 18 35 40 49 74 114 41 81 -42
    -20 -52 1 -48 32 7 12 21 28 42 36 47 20 11 47 0 47 -19 0 -17 -27 -72 -48
    -95 -19 -22 -70 -24 -79 -2 -3 8 -11 13 -18 10 -16 -6 -269 50 -310 69 -16 7
    -43 16 -60 20 -16 3 -41 13 -53 21 -23 15 -23 16 -5 36 45 49 133 75 133 39z
    m4830 -17 c14 -36 13 -44 -10 -44 -12 0 -20 7 -20 16 0 12 -7 14 -30 9 -25 -6
    -30 -4 -30 13 0 26 8 32 47 32 27 0 35 -5 43 -26z m3388 -32 c4 -63 -4 -74
    -59 -92 -51 -17 -59 -8 -59 71 0 68 12 81 70 77 l45 -3 3 -53z m1843 39 c81
    -23 109 -37 109 -56 0 -23 -29 -32 -126 -39 -68 -5 -94 -3 -101 6 -18 24 -35
    78 -29 93 8 21 66 19 147 -4z m496 -13 c33 -31 31 -52 -4 -43 -34 8 -68 39
    -59 54 11 17 38 13 63 -11z m-148 -13 c25 -14 65 -30 89 -35 43 -11 112 -62
    112 -84 0 -15 -90 -145 -114 -165 -15 -12 -23 -13 -49 -2 -18 7 -59 23 -92 35
    -63 22 -67 29 -50 84 7 19 1 25 -48 46 -67 30 -74 39 -52 73 14 21 23 24 48
    20 55 -9 143 -46 207 -88 34 -22 64 -38 67 -36 10 11 -85 78 -153 108 -53 23
    -74 38 -74 51 0 27 52 23 109 -7z m-5459 5 c0 -5 -2 -10 -4 -10 -3 0 -8 5 -11
    10 -3 6 -1 10 4 10 6 0 11 -4 11 -10z m3118 -39 c5 -70 -3 -89 -46 -100 -20
    -6 -54 -11 -74 -11 -37 0 -38 1 -38 39 0 22 4 51 10 66 12 31 62 56 110 52 34
    -2 35 -3 38 -46z m681 18 c17 -6 31 -17 31 -24 0 -14 -79 -84 -117 -104 -12
    -6 -32 -11 -45 -11 -13 0 -41 -9 -63 -20 -64 -33 -75 -28 -75 30 0 64 18 83
    107 109 119 34 120 34 162 20z m261 -14 c34 -36 18 -57 -56 -73 -111 -23 -109
    -23 -93 -33 7 -5 31 -9 52 -9 30 0 40 -5 49 -25 9 -21 9 -29 -3 -40 -12 -12
    -30 -13 -104 -5 -50 6 -105 13 -122 16 -53 10 -38 43 20 45 22 0 22 0 -1 11
    -13 6 -22 18 -20 26 6 29 76 74 144 92 93 25 107 24 134 -5z m-4325 -6 c11
    -17 -4 -59 -21 -59 -20 0 -28 24 -14 49 12 23 25 27 35 10z m3197 -59 c-2 -30
    -10 -61 -17 -69 -15 -15 -133 -43 -147 -35 -4 3 -7 22 -7 42 3 100 27 124 119
    120 l55 -3 -3 -55z m-9187 20 c14 -5 28 -18 32 -27 3 -10 11 -24 17 -32 9 -11
    12 -8 16 15 5 27 9 29 54 32 66 4 247 -15 259 -27 14 -14 -23 -27 -102 -35
    -35 -3 -107 -20 -159 -36 -52 -17 -101 -29 -109 -26 -7 3 -13 19 -13 36 0 20
    -5 30 -15 30 -13 0 -15 -7 -10 -34 9 -48 -17 -72 -89 -81 -44 -6 -61 -4 -81 9
    -26 17 -34 59 -14 72 12 7 -53 34 -84 34 -15 0 -16 -3 -7 -20 6 -11 7 -20 3
    -20 -4 -1 5 -8 20 -16 22 -12 28 -21 25 -42 -3 -24 -12 -30 -98 -58 -145 -47
    -222 -93 -97 -57 57 16 58 16 82 -7 24 -23 50 -23 85 -1 22 15 5 24 -20 11
    -18 -10 -25 -9 -38 4 -14 14 -14 18 -2 30 24 22 156 49 179 37 32 -18 53 -13
    136 29 43 22 88 40 99 40 12 0 53 12 91 25 89 31 131 33 140 4 9 -27 -3 -39
    -62 -58 -36 -12 -49 -22 -53 -41 -6 -27 -9 -28 -155 -56 -49 -9 -107 -24 -128
    -32 -24 -9 -54 -12 -81 -9 -37 5 -45 3 -49 -12 -3 -12 -37 -35 -88 -60 -46
    -22 -96 -48 -111 -58 -26 -16 -28 -16 -49 2 -48 43 -139 157 -139 173 0 24 60
    57 179 99 l96 34 -57 -6 c-31 -3 -64 -2 -72 1 -24 9 -20 51 7 68 39 24 253 63
    272 48 6 -4 18 -19 28 -34 10 -16 24 -28 32 -28 18 0 19 5 3 29 -27 43 58 77
    127 51z m1842 -6 c3 -8 1 -26 -5 -39 -17 -38 -1 -38 25 0 24 36 58 46 80 24
    14 -14 -11 -86 -36 -107 -25 -21 -181 6 -181 31 0 7 14 33 30 60 23 36 36 47
    55 47 14 0 28 -7 32 -16z m7140 -2 c16 -10 27 -96 15 -119 -7 -12 -34 -26 -71
    -36 -82 -23 -100 -22 -111 7 -11 29 6 99 29 120 29 26 114 44 138 28z m776
    -32 c8 -33 -8 -74 -34 -87 -29 -15 -95 -17 -104 -3 -10 16 -33 11 -40 -8 -7
    -25 -40 -39 -122 -53 -37 -6 -85 -20 -107 -31 -59 -30 -124 -48 -203 -54 l-71
    -7 -21 41 c-19 37 -19 42 -5 56 21 21 57 30 124 31 l55 0 -1 -32 c-1 -22 3
    -33 12 -33 9 0 14 11 14 33 0 46 27 67 97 77 142 20 249 45 313 74 50 22 86
    21 93 -4z m-8964 -10 c49 -11 101 -25 115 -31 25 -12 35 -42 17 -53 -4 -3 -11
    -19 -14 -36 -5 -22 -14 -31 -34 -36 -15 -3 -39 -14 -53 -23 -21 -13 -55 -16
    -205 -16 -177 0 -180 0 -183 22 -5 35 25 44 110 33 103 -13 184 -12 196 3 5 6
    11 21 14 32 2 13 13 21 31 23 36 4 30 26 -9 30 -55 5 -114 32 -114 53 0 24 17
    24 129 -1z m1280 9 c38 -13 41 -42 8 -90 -21 -30 -28 -34 -66 -33 -58 1 -77
    22 -62 65 23 66 54 81 120 58z m7461 1 c0 -5 -4 -10 -10 -10 -5 0 -10 5 -10
    10 0 6 5 10 10 10 6 0 10 -4 10 -10z m-762 -22 c14 -14 16 -87 3 -121 -11 -29
    -25 -35 -96 -43 -47 -6 -54 -4 -64 15 -16 29 -4 86 24 113 40 39 111 58 133
    36z m2362 1 c24 -5 50 -15 57 -21 8 -6 40 -12 72 -12 62 -2 91 -17 91 -46 0
    -10 9 -28 21 -41 l20 -24 -6 28 c-8 37 9 42 83 23 33 -9 76 -16 95 -16 20 0
    39 -5 43 -12 13 -21 -28 -38 -95 -38 l-66 -1 30 -15 c30 -16 55 -41 55 -56 0
    -20 -53 -1 -250 92 -116 55 -213 100 -216 100 -19 0 -74 32 -69 40 8 13 77 13
    135 -1z m-10690 -8 c0 -4 39 -11 86 -15 97 -7 172 -22 191 -38 21 -17 15 -48
    -11 -59 -15 -7 -46 -9 -82 -4 -46 5 -63 13 -85 36 -27 29 -28 29 -39 9 -8 -16
    -21 -20 -58 -20 -71 0 -122 17 -122 40 0 24 28 40 69 40 17 0 31 5 31 10 0 6
    5 10 10 10 6 0 10 -4 10 -9z m1808 -7 c13 -4 22 -14 22 -26 0 -29 -37 -96 -57
    -102 -28 -9 -105 8 -116 25 -13 21 -3 59 23 87 21 22 76 29 128 16z m-723 -31
    c8 -24 -22 -63 -49 -63 -32 0 -63 36 -50 58 20 32 87 35 99 5z m4461 16 c10
    -17 -13 -36 -27 -22 -12 12 -4 33 11 33 5 0 12 -5 16 -11z m94 -15 c0 -8 -5
    -12 -10 -9 -6 4 -8 11 -5 16 9 14 15 11 15 -7z m-4857 -13 c16 -6 31 -20 34
    -31 6 -24 16 -25 33 -5 7 8 19 15 26 15 29 0 204 -74 204 -86 0 -22 -17 -25
    -62 -9 -24 9 -97 20 -163 25 -66 5 -133 13 -150 18 -36 10 -45 44 -19 74 19
    20 41 20 97 -1z m1204 -7 c7 -10 11 -24 8 -32 -3 -9 1 -9 17 3 32 21 94 19
    206 -9 53 -14 144 -34 202 -47 58 -12 111 -26 118 -31 6 -6 12 -22 12 -36 l0
    -25 23 21 c25 24 84 30 117 12 10 -5 22 -24 25 -42 7 -28 8 -29 17 -12 18 34
    37 43 71 33 18 -5 44 -9 60 -9 20 0 32 -8 44 -29 l17 -29 26 20 c25 18 32 19
    108 7 45 -7 87 -16 93 -20 16 -10 4 -54 -23 -81 -22 -22 -13 -22 -230 1 -47 5
    -149 23 -225 40 -76 17 -175 35 -218 40 -44 5 -177 28 -295 51 -118 22 -238
    44 -265 49 -28 4 -57 11 -64 15 -18 12 -8 68 20 107 21 29 25 31 72 26 33 -3
    55 -11 64 -23z m6157 2 c7 -29 -4 -115 -16 -122 -20 -13 -152 -45 -165 -40
    -15 6 -18 102 -3 126 9 14 126 57 161 59 10 1 19 -9 23 -23z m-6946 -12 c18
    -12 22 -23 22 -69 0 -47 -3 -55 -19 -55 -23 0 -111 48 -117 65 -3 7 5 29 17
    49 19 32 25 37 48 31 14 -3 36 -13 49 -21z m8272 -44 c5 -50 6 -53 18 -33 6
    12 12 28 12 35 0 8 6 22 13 31 11 16 20 16 81 8 38 -6 73 -14 78 -19 5 -5 2
    -21 -7 -38 -8 -16 -15 -43 -15 -59 0 -17 -5 -36 -12 -43 -13 -13 -154 -16
    -257 -6 l-62 7 2 38 c4 54 -5 56 -25 6 l-17 -44 -102 -12 c-56 -7 -153 -15
    -214 -18 -99 -5 -113 -4 -119 11 -9 23 11 43 70 73 51 26 127 45 361 89 72 13
    135 26 140 29 6 2 19 3 30 2 17 -2 21 -11 25 -57z m-8131 29 c19 -7 33 -20 37
    -35 8 -31 -24 -95 -58 -114 -24 -13 -29 -13 -47 4 -16 14 -21 31 -21 68 0 84
    20 101 89 77z m6575 -26 c15 -52 17 -110 4 -120 -18 -15 -146 -45 -179 -41
    -14 1 -33 -5 -42 -14 -18 -18 -138 -41 -184 -36 -32 3 -39 26 -28 85 5 30 14
    38 68 64 78 37 126 47 138 28 5 -8 9 -32 10 -54 l0 -40 15 46 c16 53 26 64 80
    83 57 21 111 20 118 -1z m1909 1 c40 -15 25 -67 -25 -88 -26 -11 -10 -14 140
    -20 198 -8 314 -24 470 -66 139 -36 167 -49 167 -75 0 -14 -12 -24 -41 -34
    -38 -13 -45 -13 -93 7 -28 13 -99 29 -158 37 -60 9 -130 22 -158 30 -74 21
    -208 44 -310 54 -49 5 -103 14 -119 20 -27 11 -28 14 -23 54 3 24 11 56 17 72
    10 27 12 28 64 21 30 -3 61 -9 69 -12z m-9204 -14 c82 -12 111 -24 111 -46 0
    -28 -43 -37 -134 -26 -47 5 -93 15 -101 22 -31 26 -9 73 29 65 12 -2 54 -9 95
    -15z m918 -1 c23 -8 24 -13 18 -52 -10 -65 -25 -107 -39 -107 -25 0 -121 32
    -134 45 -12 10 -11 18 2 43 9 17 16 39 16 50 0 32 21 44 69 37 24 -4 55 -11
    68 -16z m-1568 -7 c7 -14 6 -25 -4 -39 -13 -18 -12 -21 11 -32 20 -9 57 -9
    157 0 72 6 187 9 255 7 106 -4 127 -8 139 -23 17 -25 17 -31 -5 -53 -16 -16
    -49 -20 -238 -30 -313 -17 -290 -19 -314 28 -18 34 -25 40 -53 40 -19 0 -55
    -7 -82 -16 -47 -17 -48 -17 -65 6 -18 23 -40 20 -40 -5 0 -20 -34 -39 -108
    -60 l-62 -18 -30 28 c-17 16 -30 35 -30 42 0 17 63 43 89 36 12 -3 38 2 59 10
    21 8 60 18 87 22 108 13 119 16 104 26 -8 5 -24 9 -36 9 -27 0 -31 26 -5 33 9
    3 49 5 89 6 61 1 74 -2 82 -17z m5686 -18 c0 -10 -8 -20 -17 -22 -18 -3 -26
    27 -11 42 12 11 28 0 28 -20z m2907 9 c28 -32 31 -60 9 -82 -12 -12 -29 -21
    -38 -21 -10 0 -55 -10 -101 -21 -78 -20 -84 -20 -101 -4 -11 9 -25 30 -32 47
    -11 27 -10 32 6 44 10 7 38 16 64 19 25 4 66 13 91 20 63 18 85 18 102 -2z
    m2706 -4 c46 -16 47 -35 4 -63 -20 -13 -46 -33 -56 -45 -24 -27 -56 -27 -90 0
    -35 27 -34 57 2 65 48 10 52 13 52 34 0 23 36 27 88 9z m-9593 -13 c39 -17 42
    -24 19 -67 -26 -52 -10 -54 30 -6 42 52 67 58 90 25 20 -29 22 -143 3 -151 -7
    -3 -35 -1 -63 4 -27 4 -70 11 -97 14 -28 4 -58 16 -74 29 -26 22 -26 24 -15
    81 18 88 36 100 107 71z m-722 -22 c29 -16 37 -51 13 -60 -19 -7 -197 23 -210
    36 -13 13 10 38 42 43 41 7 124 -4 155 -19z m4427 5 c0 -24 -23 -21 -28 4 -2
    10 3 17 12 17 10 0 16 -9 16 -21z m2911 -66 l20 -48 -21 -17 c-12 -10 -30 -18
    -39 -18 -23 0 -121 -49 -121 -61 0 -13 1 -12 85 21 107 42 300 100 336 100 40
    0 50 -27 19 -52 -31 -25 -177 -63 -440 -115 -34 -6 -75 27 -105 88 -27 53 -31
    84 -13 95 21 13 182 51 221 53 36 1 39 -1 58 -46z m-7150 21 c74 -17 93 -34
    66 -61 -19 -20 -61 -19 -131 1 -58 17 -82 37 -72 61 7 19 49 19 137 -1z m-427
    -9 c82 -13 136 -34 136 -53 0 -5 -6 -17 -14 -27 -13 -18 -19 -18 -92 -7 -44 7
    -95 12 -114 12 -19 0 -40 4 -46 8 -16 11 -25 42 -19 63 8 23 30 24 149 4z
    m1270 9 c22 -8 20 -32 -8 -97 -29 -65 -37 -71 -76 -62 -45 10 -61 30 -50 61 6
    14 10 40 10 58 0 18 3 36 7 39 8 9 96 9 117 1z m5484 -38 c6 -73 -1 -82 -75
    -100 -67 -17 -68 -17 -85 4 -23 29 -23 82 0 103 21 19 85 36 127 34 27 -2 30
    -5 33 -41z m1340 16 c4 -29 -30 -49 -103 -60 -68 -11 -85 -7 -85 18 0 28 25
    42 98 55 81 15 86 14 90 -13z m-6672 -23 c20 -16 17 -63 -4 -82 -21 -19 -114
    -40 -137 -31 -20 8 -19 17 5 63 30 60 48 74 88 68 18 -4 40 -11 48 -18z
    m-2641 -29 c15 -16 17 -25 9 -38 -15 -23 -71 -28 -93 -8 -16 14 -18 13 -29
    -18 -9 -25 -24 -38 -62 -56 -28 -13 -50 -27 -50 -32 0 -13 71 2 108 23 42 24
    49 24 57 0 9 -31 39 -34 94 -11 52 23 82 24 88 3 3 -8 -25 -26 -71 -47 -41
    -19 -95 -48 -120 -65 -47 -32 -96 -41 -96 -17 0 7 9 25 21 40 25 31 20 32 -29
    6 l-37 -20 -25 29 c-14 15 -46 38 -72 50 -51 24 -73 45 -63 61 9 14 144 77
    239 111 84 29 95 28 131 -11z m444 14 c42 -53 22 -78 -69 -85 -41 -4 -45 -2
    -48 19 -4 27 11 48 53 74 38 23 40 23 64 -8z m1051 -3 c54 -20 65 -51 26 -76
    -64 -42 -185 42 -134 93 12 12 37 9 108 -17z m382 17 c63 -13 75 -27 55 -66
    -15 -31 -28 -32 -127 -4 -70 19 -89 43 -54 69 22 16 51 16 126 1z m4077 1 c76
    -25 91 -32 91 -45 0 -24 -20 -25 -80 -3 -63 23 -75 32 -65 49 8 13 11 13 54
    -1z m4051 0 c36 -6 109 -10 162 -9 54 1 106 -1 118 -5 33 -11 24 -45 -26 -93
    l-46 -44 -72 7 c-109 11 -200 37 -204 58 -4 21 29 22 127 7 65 -11 83 -8 64
    11 -6 6 -60 12 -124 13 -123 3 -199 18 -199 41 0 7 6 16 13 18 22 9 120 7 187
    -4z m-2240 -18 c5 -11 10 -36 10 -56 0 -41 -23 -55 -90 -55 -37 0 -40 2 -50
    39 -12 47 -5 70 24 76 11 2 30 6 41 8 41 9 55 6 65 -12z m675 13 c9 -4 29 -32
    45 -63 15 -32 35 -63 44 -70 27 -22 18 -40 -21 -46 -21 -4 -92 -17 -158 -30
    -161 -31 -433 -61 -445 -49 -12 12 -1 108 14 129 13 17 241 79 261 71 9 -3 15
    -26 17 -68 2 -48 7 -63 18 -63 11 0 16 17 20 70 l5 70 80 27 c87 30 95 31 120
    22z m1340 -24 c9 -18 26 -32 43 -36 83 -18 98 -38 63 -83 -12 -16 -24 -22 -36
    -17 -13 5 -16 2 -10 -11 4 -10 9 -34 12 -53 3 -19 10 -42 14 -51 6 -11 3 -21
    -7 -30 -13 -10 -10 -15 23 -34 27 -15 38 -28 37 -43 -1 -25 9 -28 95 -35 62
    -5 87 -26 70 -59 -13 -24 -41 -20 -152 18 -39 14 -99 32 -132 40 -33 9 -65 20
    -71 25 -18 14 -5 48 27 71 l28 21 -30 28 c-42 39 -37 72 11 79 33 5 34 6 10
    13 -14 4 -37 7 -52 7 -25 0 -26 -3 -21 -33 8 -49 -11 -59 -78 -42 -42 11 -84
    12 -184 6 l-130 -8 103 -2 c98 -1 102 -2 102 -23 0 -12 10 -32 22 -45 29 -31
    12 -48 -47 -45 -39 1 -47 -2 -66 -29 -22 -31 -22 -31 -93 -24 -90 8 -106 13
    -106 31 0 19 41 34 91 34 21 0 39 5 39 10 0 6 -22 10 -49 10 -57 0 -66 9 -75
    73 -5 30 -12 47 -19 44 -17 -5 -30 -77 -16 -93 14 -17 3 -34 -20 -34 -21 0
    -143 59 -153 74 -4 6 -6 15 -5 20 5 16 231 85 304 92 71 6 95 16 73 29 -5 3
    -10 19 -10 36 0 38 -16 38 -23 -1 -5 -22 -14 -31 -34 -36 -15 -3 -59 -15 -97
    -26 -83 -24 -95 -17 -78 41 7 21 20 42 30 46 30 11 254 55 284 55 36 0 99 -25
    115 -46 9 -13 15 -13 31 -3 30 19 130 -13 142 -45 5 -14 19 -25 34 -28 14 -3
    26 -4 26 -2 0 2 -15 17 -32 34 -33 30 -79 51 -152 66 -22 5 -41 14 -43 21 -5
    14 23 20 109 22 65 1 68 0 83 -29z m-6898 -13 c14 -14 13 -20 -8 -59 -30 -53
    -51 -57 -124 -23 -60 29 -80 57 -63 89 9 17 19 18 95 13 57 -3 90 -10 100 -20z
    m-2622 -8 c0 -8 9 -22 20 -31 20 -18 20 -18 -8 -43 -15 -13 -46 -30 -68 -37
    -40 -11 -43 -11 -65 16 -38 43 -32 71 19 90 77 28 102 29 102 5z m3542 -2 c10
    -10 11 -20 4 -40 -14 -36 0 -34 28 4 23 31 24 31 90 24 36 -4 70 -11 75 -15
    11 -11 -32 -100 -52 -107 -19 -8 -180 15 -244 34 -27 8 -51 20 -54 28 -7 17
    21 71 43 85 23 13 91 6 110 -13z m6663 13 c25 -6 55 -12 68 -15 54 -13 3 -65
    -63 -64 -83 1 -144 39 -116 73 15 18 46 20 111 6z m948 -36 c45 -20 72 -39 72
    -48 0 -22 -36 -20 -85 4 -22 11 -47 19 -56 20 -27 0 -63 35 -56 53 7 20 29 15
    125 -29z m-9332 7 c22 -16 53 -24 117 -31 48 -5 91 -12 97 -15 13 -8 13 -35 0
    -35 -6 0 -15 -12 -21 -26 -9 -26 -11 -27 -79 -20 -38 3 -81 11 -97 17 l-28 12
    35 10 35 10 -65 14 c-90 19 -114 33 -118 67 -4 29 -3 29 45 24 29 -3 62 -14
    79 -27z m3752 12 c-1 -10 4 -28 13 -41 13 -18 14 -33 7 -78 -13 -81 -4 -88 26
    -21 23 52 46 68 46 33 0 -7 9 -21 20 -31 11 -10 20 -26 20 -37 0 -15 -5 -17
    -25 -12 -31 8 -34 -12 -2 -22 25 -7 57 -33 57 -46 0 -4 -11 -8 -25 -8 -18 0
    -32 -11 -49 -39 -24 -37 -25 -44 -16 -118 8 -76 8 -78 -17 -99 l-25 -20 26
    -18 c32 -20 43 -14 72 39 20 37 44 47 44 18 0 -10 -9 -38 -20 -62 -19 -42 -22
    -43 -55 -38 -19 3 -37 1 -40 -4 -4 -5 -33 -9 -66 -9 -39 0 -61 -4 -63 -12 -3
    -7 -7 -24 -10 -38 -10 -45 -106 -81 -120 -44 -9 24 -7 62 4 69 6 3 10 21 10
    40 0 19 -4 37 -10 40 -6 4 -10 -10 -10 -35 0 -35 -3 -40 -17 -36 -16 5 -18 -1
    -18 -51 0 -52 -3 -59 -27 -72 -15 -9 -30 -12 -35 -7 -4 4 -8 35 -8 69 0 52 5
    68 28 98 35 46 36 109 3 207 -23 67 -24 75 -10 107 16 39 19 85 5 85 -5 0 -14
    -13 -20 -30 -10 -31 -29 -38 -49 -18 -16 16 -15 43 3 58 8 7 15 22 15 34 0 11
    7 34 15 50 20 39 19 56 -5 56 -29 0 -24 16 9 29 44 19 118 29 224 30 88 1 98
    -1 95 -16z m1756 -2 c9 -10 19 -34 22 -53 5 -30 3 -35 -20 -46 -40 -18 -110
    -15 -134 6 -48 41 -32 90 34 102 64 12 80 11 98 -9z m-5905 -2 c65 -14 84 -35
    45 -49 -42 -16 -145 -9 -157 12 -8 12 -7 21 2 32 16 19 42 20 110 5z m1364 -4
    c50 -8 117 -21 147 -29 30 -8 74 -17 97 -21 58 -9 67 -23 47 -74 -21 -52 -42
    -58 -138 -37 -79 18 -90 26 -101 69 -9 35 -23 35 -27 0 -3 -27 -5 -28 -78 -33
    l-75 -6 52 -8 c69 -11 88 -25 79 -59 -11 -47 -33 -59 -90 -52 -28 4 -80 16
    -115 27 -52 16 -68 18 -87 8 -12 -7 -35 -10 -51 -7 -249 47 -394 77 -403 82
    -21 13 -9 37 30 54 45 20 84 16 175 -21 184 -75 213 -81 210 -47 -1 20 -8 22
    -67 23 -121 3 -155 57 -43 71 69 9 109 0 149 -36 20 -17 47 -30 67 -31 31 -3
    36 1 56 42 38 79 52 100 63 100 5 0 52 -7 103 -15z m2893 0 c41 -17 41 -41 -1
    -38 -33 2 -78 30 -70 43 9 14 30 12 71 -5z m-4887 -1 c31 -7 42 -28 19 -37 -7
    -3 -3 -6 8 -6 27 -1 69 -34 61 -48 -9 -15 -89 -35 -123 -31 -23 2 -29 8 -29
    28 0 16 9 29 25 38 22 12 13 13 -75 11 -127 -2 -125 -3 -125 20 0 11 6 22 13
    24 18 8 189 8 226 1z m-269 -20 c18 -21 -6 -44 -57 -53 -48 -9 -63 -5 -63 20
    0 38 94 65 120 33z m5316 5 c10 -17 -13 -36 -27 -22 -12 12 -4 33 11 33 5 0
    12 -5 16 -11z m3024 -23 c0 -11 -9 -39 -19 -61 -16 -34 -27 -43 -80 -64 -58
    -23 -68 -24 -137 -14 -92 13 -110 25 -88 58 18 28 57 43 136 55 32 5 81 19
    110 33 59 27 78 25 78 -7z m1550 5 c39 -28 38 -51 -2 -51 -57 0 -116 48 -91
    74 12 11 65 -2 93 -23z m-3280 -7 c14 -36 12 -70 -4 -83 -7 -6 -42 -12 -77
    -13 -54 -3 -64 0 -67 15 -7 32 20 79 52 93 51 22 85 18 96 -12z m-7325 -9 c0
    -28 -76 -55 -100 -35 -19 16 -8 30 38 47 43 16 62 12 62 -12z m1210 15 c3 -5
    -6 -17 -20 -26 -50 -33 -136 -12 -91 22 22 16 102 19 111 4z m2858 -9 c13 -13
    -1 -66 -24 -96 -14 -17 -30 -25 -50 -25 -28 0 -89 24 -89 35 0 15 57 88 75 96
    22 9 74 4 88 -10z m-3515 -12 c6 -35 -30 -58 -110 -71 -71 -11 -79 -10 -98 7
    -24 22 -36 15 -21 -13 6 -11 7 -22 4 -26 -3 -3 2 -15 11 -25 27 -30 13 -78
    -29 -98 -43 -21 -67 -12 -63 24 3 30 0 33 -33 33 -18 0 -19 -2 -9 -15 8 -9 10
    -28 6 -51 l-7 -36 33 7 c18 4 70 19 115 35 73 25 84 26 102 13 12 -8 21 -23
    21 -33 0 -18 -22 -29 -217 -102 -30 -11 -52 -22 -49 -25 3 -3 33 4 66 16 33
    12 65 19 70 16 15 -9 12 -38 -6 -63 -30 -43 -18 -41 116 13 36 15 69 31 73 35
    5 4 1 24 -7 45 -19 44 -13 59 19 51 18 -5 25 -1 30 13 3 11 12 22 20 25 48 18
    65 -45 24 -90 -23 -24 -24 -40 -4 -48 40 -15 -4 -62 -48 -50 -17 4 -26 1 -30
    -10 -3 -8 -28 -27 -56 -40 -27 -14 -52 -30 -55 -34 -9 -15 131 22 151 40 24
    21 90 48 117 48 28 0 69 -42 64 -66 -2 -10 -22 -24 -53 -34 -27 -9 -78 -31
    -112 -49 -34 -17 -71 -31 -81 -31 -11 0 -50 16 -88 36 -250 131 -334 178 -334
    190 0 10 -14 14 -45 14 -61 0 -113 50 -70 66 28 11 15 22 -17 15 -61 -14 -139
    26 -125 63 7 18 145 85 190 93 30 5 37 1 61 -29 26 -35 34 -68 16 -68 -16 0
    -50 -38 -50 -56 0 -11 16 -3 53 27 28 24 53 44 55 45 2 1 -7 13 -20 26 -68 72
    -71 92 -16 103 18 3 65 17 103 31 73 26 235 53 295 51 23 -1 36 -7 38 -18z
    m1302 5 c94 -17 116 -26 106 -43 -9 -14 -73 -13 -161 3 -79 14 -95 21 -95 42
    0 19 42 18 150 -2z m8561 -23 c64 -11 141 -28 170 -38 45 -15 54 -22 57 -44 4
    -31 -24 -63 -47 -55 -9 3 -43 14 -76 25 -115 39 -254 81 -267 81 -26 0 -49 24
    -42 44 8 21 15 20 205 -13z m691 19 c39 -11 56 -35 32 -44 -20 -8 -98 -8 -118
    0 -32 12 -10 54 29 54 11 0 36 -5 57 -10z m-10226 -26 c13 -51 -35 -98 -82
    -80 -26 10 -15 78 16 93 39 20 59 16 66 -13z m547 6 c4 -4 0 -21 -10 -38 -21
    -37 -8 -57 16 -24 50 70 39 65 126 54 44 -6 84 -17 90 -24 7 -9 37 -13 99 -13
    57 0 91 -4 93 -11 2 -6 -12 -31 -32 -55 -20 -24 -43 -52 -51 -61 -22 -28 -43
    -22 -86 25 -27 29 -38 49 -35 65 2 12 4 22 3 22 0 -1 -25 -9 -54 -19 l-53 -18
    32 -7 c40 -8 79 -42 79 -69 0 -17 -6 -19 -54 -15 -38 3 -67 13 -94 31 -43 31
    -81 38 -43 8 30 -23 20 -41 -23 -41 -38 0 -56 15 -56 46 0 26 -34 54 -66 54
    -36 0 -54 11 -70 42 -20 39 -13 56 28 61 43 5 151 -4 161 -13z m2798 3 c12
    -12 -28 -91 -53 -104 -22 -12 -84 -4 -93 12 -10 16 5 65 27 89 17 19 28 21 65
    17 25 -2 49 -9 54 -14z m5695 2 c27 -8 65 -17 85 -20 20 -3 44 -14 54 -25 14
    -16 21 -17 38 -9 19 11 160 5 194 -8 24 -9 35 -41 22 -64 -9 -18 -17 -20 -47
    -16 -21 3 -45 8 -55 12 -13 6 -20 -1 -32 -28 -8 -20 -19 -38 -25 -42 -5 -3
    -10 -13 -10 -20 0 -23 29 -6 46 28 15 29 18 29 69 24 30 -3 67 -12 82 -21 67
    -37 115 -57 126 -53 14 5 -47 45 -83 54 -36 8 -50 22 -50 49 0 37 28 45 96 28
    91 -24 94 -27 94 -89 0 -30 -4 -55 -10 -55 -5 0 -10 -7 -10 -15 0 -29 -38 -38
    -87 -21 -53 18 -77 20 -50 5 21 -12 156 -59 171 -59 6 0 5 5 -2 12 -7 7 -12
    21 -12 31 0 17 5 19 35 14 19 -3 47 -12 61 -19 31 -15 55 -48 39 -54 -5 -2
    -57 -34 -115 -70 l-104 -65 -87 40 c-48 23 -91 41 -95 41 -17 0 -44 35 -44 56
    0 37 16 37 83 0 68 -38 147 -69 147 -58 0 4 -39 27 -88 52 -80 42 -87 47 -85
    74 2 26 1 27 -16 12 -10 -10 -35 -16 -61 -16 l-44 0 22 -20 c28 -26 28 -44 1
    -71 l-22 -22 24 -18 c18 -14 35 -18 64 -14 28 4 56 -2 94 -17 61 -26 83 -50
    63 -70 -22 -22 -84 -12 -172 26 -145 62 -216 148 -164 200 14 15 14 18 -8 35
    -22 19 -23 20 -6 49 14 23 15 36 8 63 -18 64 -30 73 -111 77 -116 5 -122 7
    -113 45 6 29 19 46 35 47 4 0 29 -7 55 -15z m960 -8 c38 -20 51 -35 56 -67 2
    -20 10 -26 33 -28 l30 -3 -24 13 c-27 15 -34 28 -23 45 5 8 28 9 82 3 41 -5
    105 -9 142 -10 104 0 128 -18 61 -46 -24 -11 -51 -14 -77 -10 -35 6 -38 5 -26
    -9 19 -23 -1 -41 -28 -26 -17 9 -22 8 -27 -10 -7 -22 -33 -23 -80 -4 -18 8
    -18 7 -7 -8 14 -16 9 -37 -8 -37 -22 0 -78 62 -89 100 -16 54 -62 77 -119 59
    -64 -19 -115 3 -100 43 8 21 161 17 204 -5z m-7427 -1 c98 -18 103 -26 61
    -123 -28 -63 -51 -70 -145 -41 -43 13 -83 30 -88 39 -13 21 6 69 43 109 32 34
    29 34 129 16z m1947 -42 c-4 -20 -13 -34 -21 -34 -20 0 -19 24 2 63 19 37 28
    23 19 -29z m1747 20 c23 -47 13 -59 -60 -75 -51 -12 -57 -11 -69 6 -21 29 -17
    72 8 89 12 9 41 16 63 16 38 0 43 -3 58 -36z m-2810 9 c13 -8 7 -81 -9 -97
    -27 -27 -104 -14 -104 18 0 18 31 79 44 88 10 7 50 1 69 -9z m-3595 -5 c7 -7
    12 -25 12 -40 0 -21 -6 -31 -26 -38 -41 -16 -130 -12 -149 6 -29 29 -14 47 55
    65 81 21 93 22 108 7z m5285 -13 c32 -33 41 -69 25 -103 -18 -37 -45 -40 -60
    -7 -11 24 -10 29 6 41 18 12 18 15 2 39 -9 14 -21 25 -26 25 -6 0 -10 7 -10
    15 0 23 35 18 63 -10z m1743 -10 c17 -42 18 -79 2 -93 -7 -5 -71 -15 -143 -21
    -71 -6 -165 -16 -209 -23 -73 -11 -79 -11 -92 7 -21 28 -18 72 6 85 11 6 98
    24 192 41 95 17 174 32 177 35 2 2 15 4 28 4 18 0 28 -9 39 -35z m-6568 13
    c14 -14 16 -64 4 -72 -5 -3 -49 -10 -98 -16 -99 -12 -136 -30 -62 -30 74 0
    107 -53 46 -74 -20 -7 -37 -4 -74 15 -48 23 -49 25 -46 64 2 22 12 48 22 59
    14 14 106 46 191 65 3 0 10 -4 17 -11z m5755 -40 c5 -61 3 -63 -71 -79 -69
    -14 -84 -3 -80 60 3 44 5 46 43 57 22 7 54 13 71 13 31 1 32 0 37 -51z m-3257
    11 c11 -9 13 -29 8 -93 -12 -141 -20 -147 -125 -93 -74 37 -75 40 -29 141 l30
    69 51 -6 c28 -4 57 -12 65 -18z m809 12 c38 -8 45 -46 15 -84 -18 -23 -29 -27
    -68 -26 -98 2 -114 17 -87 82 15 36 17 37 63 36 26 -1 61 -4 77 -8z m4195 -1
    c0 -5 -16 -14 -36 -19 -20 -6 -44 -16 -53 -24 -9 -9 -63 -19 -135 -26 -65 -7
    -137 -19 -160 -28 -22 -8 -70 -19 -106 -24 -35 -5 -69 -14 -74 -19 -15 -15 9
    -12 129 15 150 34 276 43 294 21 17 -21 8 -43 -21 -49 -21 -4 -21 -4 3 -6 37
    -2 52 -22 40 -54 -6 -14 -18 -28 -28 -30 -64 -18 -126 -28 -142 -24 -13 3 -21
    -1 -24 -13 -3 -14 -21 -18 -97 -23 -51 -4 -148 -7 -215 -7 -125 0 -145 6 -145
    42 0 10 -7 18 -15 18 -8 0 -15 -4 -15 -10 0 -5 -9 -19 -20 -30 -16 -16 -34
    -20 -82 -20 -35 0 -94 -5 -133 -10 -38 -5 -140 -12 -225 -15 -134 -6 -158 -5
    -175 9 -20 16 -20 16 0 31 35 27 94 38 118 22 19 -12 26 -12 62 4 22 9 59 20
    82 24 38 6 43 4 56 -21 l14 -28 24 37 24 37 96 0 c53 0 151 3 217 7 l122 6 0
    -26 c0 -37 14 -34 39 8 l20 35 -102 0 c-137 0 -207 9 -215 28 -10 28 33 49
    115 56 43 4 211 31 373 61 292 52 390 64 390 45z m-1935 -24 c9 -14 15 -39 13
    -58 -3 -33 -4 -33 -67 -41 -38 -5 -68 -4 -75 2 -7 6 -18 4 -30 -5 -26 -19 -91
    -18 -110 2 -20 20 -20 27 2 54 26 32 88 32 113 0 l19 -25 0 26 c0 60 103 94
    135 45z m4076 3 c14 -14 19 -30 17 -57 -4 -46 -24 -52 -79 -23 -41 22 -59 21
    -59 -4 0 -16 -35 -29 -50 -20 -16 10 -12 71 6 86 13 10 24 9 65 -5 28 -10 53
    -16 56 -12 3 3 -2 8 -11 12 -9 3 -16 15 -16 25 0 26 44 25 71 -2z m-6180 -11
    c8 -13 -5 -64 -22 -84 -15 -18 -63 -18 -78 0 -15 18 -5 58 21 86 15 16 27 20
    47 15 14 -4 29 -11 32 -17z m-4125 -13 c21 -31 3 -46 -72 -60 -78 -15 -97 -8
    -92 34 4 34 41 52 102 49 36 -2 52 -8 62 -23z m1390 -5 c38 -83 22 -113 -53
    -99 -62 12 -83 19 -83 27 0 4 19 29 41 55 46 54 76 59 95 17z m4024 15 c0 -16
    -27 -32 -37 -22 -3 4 -3 13 0 22 8 20 37 20 37 0z m-5012 -22 c4 -30 -42 -73
    -79 -73 -16 0 -29 5 -29 10 0 6 -4 10 -9 10 -6 0 -14 -19 -18 -42 -8 -40 -11
    -43 -44 -46 -19 -2 -48 2 -63 8 -23 9 -26 13 -16 25 7 8 19 15 26 15 8 0 14 5
    14 10 0 16 -126 12 -170 -6 -44 -18 -60 -13 -44 14 16 25 76 42 184 52 52 5
    120 18 150 29 68 25 94 23 98 -6z m1175 10 c4 -2 7 -22 7 -44 0 -50 13 -50 33
    1 l16 41 63 -3 63 -3 5 -50 c5 -51 12 -52 24 -3 16 67 86 33 86 -42 0 -34 -3
    -39 -29 -45 -34 -7 -251 19 -332 40 -30 8 -62 24 -71 36 -18 21 -24 70 -11 83
    7 7 131 -2 146 -11z m1762 -1 l50 -7 3 -97 c4 -126 -1 -131 -97 -112 -101 19
    -114 27 -107 72 3 20 8 60 12 87 8 64 19 77 58 70 17 -4 54 -9 81 -13z m938
    -4 c25 -13 21 -45 -9 -75 -21 -21 -32 -25 -65 -20 -57 7 -70 21 -57 58 19 55
    69 70 131 37z m5180 0 c63 -24 38 -158 -30 -158 -31 0 -93 26 -93 39 0 15 39
    34 55 27 8 -3 17 -1 19 3 3 5 -17 11 -44 13 -78 8 -122 66 -67 88 25 11 119 4
    160 -12z m-6807 -19 c38 -12 75 -26 82 -31 17 -14 15 -53 -3 -68 -17 -14 -122
    -9 -213 11 -43 9 -53 15 -59 37 -5 20 0 30 21 49 34 29 81 30 172 2z m4067 6
    c9 -8 19 -29 22 -47 9 -39 -12 -58 -63 -58 -25 0 -35 5 -39 20 -7 26 -15 25
    -41 -5 -29 -34 -72 -37 -104 -8 -22 19 -23 46 -4 62 12 10 160 47 203 50 6 1
    18 -6 26 -14z m1574 -11 c81 -19 113 -31 113 -44 0 -11 -246 -14 -300 -4 -42
    9 -50 32 -19 57 20 16 33 18 84 12 33 -3 88 -13 122 -21z m-3890 -6 c7 -6 13
    -17 13 -24 0 -20 13 -17 28 6 25 40 106 19 117 -31 12 -55 -6 -63 -125 -50
    -108 12 -140 22 -140 47 0 19 19 56 34 67 13 8 55 0 73 -15z m-3589 -14 c2
    -11 -7 -29 -19 -40 -29 -27 -166 -28 -183 -2 -23 38 44 68 144 65 47 -2 55 -5
    58 -23z m2812 6 c50 -13 32 -70 -51 -164 -25 -30 -38 -36 -69 -36 -60 0 -70
    17 -70 119 0 48 3 91 7 95 7 7 142 -3 183 -14z m2293 -2 c18 -28 -9 -50 -57
    -46 -54 4 -62 32 -14 53 39 17 57 16 71 -7z m3150 -11 c42 -18 49 -45 18 -76
    -17 -17 -26 -18 -53 -11 -43 13 -66 37 -74 79 l-7 34 39 -5 c21 -3 56 -13 77
    -21z m-7034 -8 c55 -11 64 -19 55 -43 -8 -20 -83 -56 -117 -56 -38 0 -67 33
    -67 75 0 34 1 35 40 35 21 0 62 -5 89 -11z m1806 -13 l50 -11 -4 -90 c-2 -50
    -8 -96 -13 -102 -6 -7 -22 -13 -37 -13 -45 1 -211 36 -223 48 -8 8 0 26 33 69
    25 32 53 70 62 86 20 31 46 33 132 13z m858 -3 c4 -2 7 -11 7 -19 0 -19 24
    -18 41 2 16 19 68 14 106 -11 20 -13 22 -19 12 -31 -9 -10 -38 -14 -118 -14
    -120 0 -156 12 -156 50 0 17 7 26 25 31 23 6 65 2 83 -8z m1734 -10 c3 -10 17
    -30 31 -45 30 -33 25 -42 -32 -57 -69 -17 -75 -15 -97 36 -23 53 -20 70 13 76
    53 10 79 7 85 -10z m3660 2 c3 -9 3 -18 0 -21 -7 -8 -47 15 -47 26 0 16 40 11
    47 -5z m-7860 -16 c17 -15 17 -73 -1 -88 -15 -12 -99 -6 -144 10 -29 11 -21
    26 33 69 41 33 79 36 112 9z m667 -12 c43 -18 76 -37 74 -42 -7 -22 -192 6
    -202 30 -6 16 18 45 37 45 7 0 48 -15 91 -33z m4344 6 c4 -30 -18 -39 -118
    -47 -47 -4 -126 -14 -176 -22 -108 -18 -158 -16 -162 8 -4 22 58 42 109 35 25
    -3 42 0 49 8 7 8 35 19 63 24 29 6 61 13 72 15 11 2 52 3 90 3 64 -2 70 -4 73
    -24z m3026 21 c23 -9 20 -32 -6 -40 l-21 -6 22 -12 c19 -11 20 -14 8 -24 -17
    -15 -50 -5 -43 13 2 7 -6 17 -20 24 -56 25 0 68 60 45z m124 -23 c-5 -23 -71
    -22 -76 1 -3 18 20 26 56 20 15 -3 22 -10 20 -21z m-9933 -12 c16 -16 -9 -30
    -77 -41 -70 -12 -101 -7 -92 16 14 37 138 56 169 25z m3710 -9 c31 -12 31 -22
    1 -86 -35 -75 -64 -94 -145 -94 -41 0 -75 5 -86 13 -17 13 -17 19 -5 96 10 66
    17 84 32 90 22 8 167 -5 203 -19z m4023 -7 c2 -17 10 -37 18 -43 20 -17 17
    -47 -5 -60 -24 -12 -264 -14 -257 -1 3 5 35 14 71 21 65 12 66 13 60 41 -9 40
    32 81 78 77 28 -3 32 -7 35 -35z m181 24 c38 -13 51 -34 27 -42 -9 -3 -23 -7
    -32 -10 -13 -4 -14 -8 -4 -20 19 -23 -5 -45 -51 -45 -29 0 -42 6 -53 23 -19
    29 -30 73 -22 92 7 18 85 20 135 2z m-7421 -6 c8 -5 12 -22 10 -42 l-3 -34
    -97 -3 c-109 -3 -138 6 -138 43 0 28 14 33 105 38 33 2 71 4 85 5 14 1 31 -2
    38 -7z m452 -5 c107 -8 203 -17 213 -21 10 -4 22 -16 28 -26 7 -14 21 -19 49
    -19 47 0 61 -18 49 -69 -11 -50 -41 -71 -101 -71 -61 0 -83 11 -96 50 -16 44
    -33 37 -30 -12 l3 -43 -90 -7 c-49 -3 -110 -11 -135 -17 -25 -6 -67 -11 -93
    -11 -41 0 -50 3 -54 20 -5 19 -8 18 -44 -15 -47 -42 -85 -46 -118 -11 -43 46
    -28 59 96 81 61 11 115 24 120 29 5 5 -9 6 -32 1 -37 -7 -137 -19 -265 -31
    -60 -7 -85 7 -78 43 3 15 13 18 58 16 30 -1 60 -2 65 -3 16 -2 266 29 310 39
    l40 9 -43 1 c-36 1 -44 5 -52 26 -11 30 -25 34 -17 5 7 -28 -20 -40 -92 -40
    -75 0 -91 6 -91 35 0 61 47 65 400 41z m996 0 c19 -14 19 -15 0 -51 -38 -71
    -98 -73 -116 -4 -6 23 -9 47 -6 55 7 19 96 19 122 0z m3894 -11 c17 -44 20
    -70 12 -82 -4 -7 -67 -33 -138 -58 l-131 -45 -69 18 c-38 9 -75 21 -82 25 -15
    10 -6 105 12 124 13 14 210 40 314 42 69 1 73 0 82 -24z m-917 3 c6 -19 -3
    -38 -19 -38 -15 0 -37 34 -27 44 11 11 41 7 46 -6z m3170 -6 c21 -6 41 -13 44
    -16 13 -13 -19 -58 -52 -72 -40 -16 -113 -18 -135 -4 -13 9 -12 13 8 29 12 11
    22 26 22 34 0 25 31 49 54 44 12 -3 38 -10 59 -15z m1603 -17 c42 -18 55 -29
    52 -42 -3 -13 -12 -17 -30 -16 -54 3 -146 62 -132 84 8 13 38 6 110 -26z
    m-7617 16 c16 -10 7 -64 -13 -81 -19 -15 -121 -18 -121 -3 0 6 17 30 37 52 36
    41 67 51 97 32z m-1845 -23 c8 -13 8 -23 0 -35 -16 -27 -53 -28 -86 -3 l-29
    22 3 -29 c2 -20 12 -32 37 -44 18 -8 38 -23 43 -32 14 -26 26 -20 30 16 3 30
    5 32 49 35 56 4 75 -13 62 -55 -8 -23 -21 -32 -74 -50 -35 -12 -79 -22 -97
    -23 -30 0 -35 4 -49 40 -9 22 -20 40 -24 40 -4 0 -9 -21 -11 -47 l-3 -47 -79
    -31 c-68 -26 -85 -38 -115 -78 -38 -50 -85 -87 -112 -87 -9 0 -22 -7 -29 -15
    -7 -8 -22 -15 -34 -15 -26 0 -66 26 -66 44 0 6 36 30 81 51 44 22 85 45 91 52
    17 21 -30 16 -60 -6 -47 -32 -131 -71 -155 -71 -13 0 -32 9 -42 20 -25 28 -14
    37 110 89 55 24 121 56 146 72 58 37 71 36 104 -3 l27 -33 -5 37 c-6 41 2 51
    62 80 l36 18 -47 -5 c-40 -5 -48 -3 -61 16 -31 43 -15 53 123 79 113 22 159
    21 174 -2z m3701 -3 c50 -9 100 -19 112 -21 30 -6 37 -39 27 -112 -9 -56 -10
    -57 -44 -60 -45 -5 -271 37 -288 53 -11 10 -8 26 22 90 31 68 39 77 58 72 13
    -2 64 -12 113 -22z m1453 -21 c2 -28 -3 -48 -16 -64 -17 -20 -31 -24 -133 -31
    -63 -4 -144 -11 -181 -14 -77 -6 -84 3 -49 61 42 68 126 93 306 90 l70 -1 3
    -41z m-5659 18 c47 -23 49 -38 5 -57 -77 -32 -113 -10 -74 45 25 35 24 35 69
    12z m6575 -5 c14 -23 -6 -37 -56 -37 -45 0 -68 8 -68 25 0 34 104 45 124 12z
    m2336 -3 c41 -9 91 -23 110 -32 42 -20 53 -57 20 -67 -32 -10 -157 24 -190 52
    -24 20 -33 22 -50 13 -20 -10 -73 -8 -122 6 -18 5 -24 34 -10 48 9 10 147 -1
    242 -20z m-6365 5 c116 -13 157 -26 153 -47 -5 -28 -68 -38 -124 -19 -31 10
    -53 12 -58 6 -11 -10 -89 -12 -123 -3 -27 7 -30 30 -6 56 19 21 36 22 158 7z
    m2715 2 c0 -6 -4 -13 -10 -16 -5 -3 -10 1 -10 9 0 9 5 16 10 16 6 0 10 -4 10
    -9z m-3507 -13 c16 -12 15 -17 -5 -71 -23 -62 -23 -62 -114 -71 -70 -7 -82 3
    -60 49 21 44 39 52 74 34 15 -7 30 -15 35 -17 4 -2 7 0 7 6 0 5 -22 21 -50 36
    -27 15 -50 31 -50 37 0 14 143 11 163 -3z m-1973 -39 c0 -12 -10 -21 -27 -25
    -16 -4 -41 -13 -57 -21 -17 -9 -32 -11 -37 -6 -13 13 19 73 45 82 30 12 76 -7
    76 -30z m4737 33 c6 -4 25 -36 42 -71 32 -69 29 -101 -9 -101 -42 0 -165 25
    -172 35 -8 10 0 122 9 138 5 9 114 9 130 -1z m197 -11 c25 -28 43 -125 27
    -145 -16 -19 -80 -21 -103 -3 -20 15 -59 123 -52 142 11 28 104 32 128 6z
    m-2779 -6 c74 -9 86 -20 55 -47 -20 -17 -21 -20 -5 -13 36 14 161 18 183 6 30
    -16 27 -39 -5 -48 -52 -15 -389 -1 -406 16 -28 28 55 105 103 97 14 -3 48 -8
    75 -11z m934 -20 c12 -12 12 -17 1 -31 -23 -27 -140 -5 -140 28 0 29 110 32
    139 3z m5709 15 c23 -6 95 -17 160 -25 190 -25 226 -42 169 -80 -21 -13 -31
    -12 -112 9 -50 14 -101 29 -115 34 -14 5 -34 6 -45 2 -26 -10 -23 -11 147 -54
    76 -20 155 -44 176 -55 40 -20 47 -36 55 -111 1 -19 8 -26 30 -28 l29 -3 -22
    29 c-46 63 -4 92 64 44 22 -16 80 -50 127 -75 84 -46 87 -47 125 -33 35 12 37
    14 17 20 -13 4 -32 4 -43 1 -28 -9 -110 32 -110 54 0 28 75 43 125 25 22 -8
    53 -19 69 -24 43 -14 19 7 -51 44 -39 21 -58 37 -58 50 0 14 -8 19 -31 21 -33
    3 -154 48 -191 71 -28 18 -29 40 -4 53 32 17 251 -68 251 -98 0 -11 21 -23 68
    -38 118 -37 184 -70 180 -90 -4 -20 -147 -106 -165 -99 -6 3 -19 -4 -28 -14
    -10 -11 -34 -25 -54 -31 -20 -7 -59 -25 -87 -41 l-52 -29 -82 43 c-62 32 -97
    58 -138 105 -57 64 -90 88 -77 56 12 -32 10 -38 -10 -34 -159 29 -230 48 -230
    61 0 9 -19 21 -44 30 -57 19 -72 42 -47 69 15 17 16 21 4 21 -8 0 -24 -13 -36
    -30 -41 -55 -81 -29 -66 43 9 42 9 42 59 47 l50 6 -70 12 c-79 15 -101 24 -91
    41 9 14 96 14 154 1z m-8413 -20 c25 -27 13 -68 -23 -76 -15 -4 -38 -14 -51
    -23 -22 -14 -25 -13 -58 22 -18 21 -31 42 -27 48 9 16 85 47 115 48 14 1 34
    -8 44 -19z m5005 5 c0 -8 -7 -15 -15 -15 -8 0 -15 7 -15 15 0 8 7 15 15 15 8
    0 15 -7 15 -15z m68 -2 c-5 -25 -28 -28 -28 -4 0 12 6 21 16 21 9 0 14 -7 12
    -17z m1070 -6 c9 -44 -40 -59 -103 -33 -46 20 -44 33 8 45 59 13 91 9 95 -12z
    m-3284 -13 c22 -21 21 -54 -2 -54 -10 0 -39 7 -65 16 -34 11 -47 21 -47 35 0
    16 7 19 49 19 32 0 55 -6 65 -16z m-636 -10 c16 -5 22 -13 20 -28 -3 -19 -10
    -21 -70 -24 -70 -3 -108 9 -108 33 0 7 8 16 18 18 26 7 114 7 140 1z m757 -6
    c31 -14 33 -46 2 -53 -48 -12 -110 34 -76 56 19 12 43 11 74 -3z m3345 -2 c0
    -20 -87 -33 -103 -17 -17 17 9 31 61 31 30 0 42 -4 42 -14z m-3887 -15 c19
    -19 -19 -41 -69 -41 -81 0 -123 34 -63 52 34 10 118 3 132 -11z m724 4 c23 -3
    54 -10 70 -16 26 -10 27 -12 8 -19 -23 -10 -137 -11 -179 -1 -16 3 -31 12 -34
    19 -5 15 35 31 68 26 14 -1 44 -6 67 -9z m4917 -12 c-1 -28 1 -28 40 -4 35 22
    114 36 145 26 18 -5 21 -14 21 -56 0 -62 -20 -83 -93 -99 -90 -18 -137 1 -137
    56 0 36 -10 43 -29 20 -9 -10 -4 -28 19 -77 16 -35 30 -72 30 -81 0 -23 -37
    -24 -62 -1 -16 14 -24 15 -52 5 -25 -9 -46 -10 -77 -3 -56 13 -69 13 -69 1 0
    -5 17 -12 38 -15 65 -11 72 -15 72 -40 0 -37 -30 -39 -190 -16 -159 24 -194
    26 -185 11 3 -5 21 -10 40 -10 95 0 205 -54 205 -101 0 -23 -16 -24 -65 -3
    -21 8 -98 24 -173 35 -142 21 -195 39 -190 66 5 29 34 39 71 25 18 -7 47 -12
    63 -11 l29 0 -35 16 c-59 26 -65 30 -63 39 2 5 75 10 163 12 127 2 160 5 160
    16 0 8 -12 21 -26 31 -21 13 -23 19 -13 31 14 17 62 44 78 44 5 0 26 -17 45
    -37 34 -36 65 -41 34 -6 -33 39 -39 61 -24 91 24 46 66 61 166 59 61 -2 65 -4
    64 -24z m-5401 1 c20 -4 37 -10 37 -15 0 -12 -102 -22 -175 -17 -67 4 -93 17
    -80 39 8 12 127 8 218 -7z m5164 0 c6 -17 -117 -94 -148 -94 -47 0 -78 43 -55
    76 22 29 194 45 203 18z m-1816 -14 c10 -6 19 -21 19 -34 0 -29 -20 -35 -110
    -37 l-65 -2 73 -8 c92 -11 105 -18 139 -79 38 -68 63 -67 27 1 -22 44 -4 63
    55 56 51 -6 71 -26 71 -71 0 -59 -24 -71 -173 -82 l-93 -6 -29 47 c-27 42 -59
    69 -166 138 -16 11 -29 25 -29 32 0 37 227 73 281 45z m1195 2 c7 -4 13 -38
    15 -77 l4 -70 -85 3 c-47 2 -89 7 -94 13 -6 5 -3 22 7 44 9 20 17 41 17 48 -1
    20 -40 -34 -40 -54 0 -34 -28 -33 -108 3 -42 20 -98 43 -124 53 -27 10 -48 24
    -48 31 0 11 41 14 223 14 122 0 227 -4 233 -8z m194 -34 c21 -46 26 -113 10
    -123 -6 -3 -31 -3 -57 1 -62 9 -103 48 -103 97 0 48 23 63 98 66 30 1 35 -3
    52 -41z m188 21 c2 -9 -13 -37 -32 -62 -38 -49 -34 -73 4 -32 31 33 49 31 93
    -7 55 -49 40 -63 -65 -62 -100 0 -124 11 -138 65 -17 62 -10 102 20 110 45 13
    114 6 118 -12z m1264 5 c31 -10 48 -22 51 -36 6 -22 -9 -62 -21 -56 -4 2 -31
    12 -60 23 -54 21 -73 45 -52 70 16 19 26 19 82 -1z m-3574 -13 c28 -6 57 -21
    80 -43 48 -45 86 -69 146 -90 26 -9 54 -22 62 -29 23 -19 16 -55 -21 -103 -19
    -26 -35 -48 -35 -51 0 -3 41 -4 92 -2 90 2 92 2 107 -25 13 -22 13 -30 3 -40
    -10 -10 -43 -8 -170 10 -160 23 -202 38 -202 71 0 58 32 66 75 21 40 -42 49
    -37 25 11 -20 39 -21 43 -5 81 9 22 14 42 11 45 -2 2 -17 -10 -34 -28 -29 -31
    -32 -32 -61 -19 -18 7 -38 22 -47 34 -11 17 -25 21 -65 21 -59 0 -82 20 -93
    80 -12 63 22 77 132 56z m223 -2 c104 -10 169 -29 169 -49 0 -18 -27 -64 -50
    -85 l-22 -20 -93 49 c-117 62 -140 79 -132 100 8 19 -1 19 128 5z m703 -5 c19
    -18 19 -20 6 -45 -12 -22 -58 -25 -108 -8 -35 12 -48 35 -31 55 16 20 113 18
    133 -2z m94 0 c26 -18 28 -36 7 -54 -23 -19 -10 -28 57 -41 66 -13 115 -46
    106 -71 -8 -19 -52 -28 -139 -28 -65 0 -70 2 -79 26 -11 28 -14 167 -3 177 10
    11 27 8 51 -9z m370 -21 c4 -44 -23 -57 -105 -50 -64 5 -103 25 -103 53 0 25
    35 34 120 31 l85 -2 3 -32z m-6097 -2 c46 -47 36 -66 -45 -87 -69 -18 -91 -13
    -105 27 -13 39 -5 58 33 75 50 22 84 17 117 -15z m5853 14 c23 -23 30 -56 15
    -66 -39 -24 -113 43 -82 74 12 12 51 7 67 -8z m-4004 -5 c5 0 19 -10 30 -22
    l21 -23 18 23 c15 20 24 23 76 20 35 -2 60 -8 62 -15 7 -21 -105 -64 -183 -70
    -84 -7 -118 6 -109 40 9 29 45 59 62 52 8 -3 19 -5 23 -5z m541 0 c54 0 68 -3
    73 -17 14 -35 -73 -111 -112 -99 -11 4 -26 24 -35 46 -16 42 -45 58 -32 18 18
    -58 13 -72 -35 -84 -97 -24 -137 -26 -155 -8 -22 23 -15 89 14 117 24 24 94
    37 166 31 28 -2 80 -4 116 -4z m2154 -17 c4 -16 12 -53 20 -83 7 -30 16 -76
    20 -103 7 -55 20 -54 29 2 6 41 19 51 65 51 63 0 85 -46 61 -132 -10 -35 -13
    -37 -63 -43 -29 -4 -62 -3 -73 2 -12 4 -50 39 -84 77 l-62 69 5 57 c3 32 13
    74 22 94 21 44 52 49 60 9z m-3011 7 c14 -5 33 -21 42 -36 17 -25 17 -27 -1
    -40 -11 -8 -43 -14 -77 -14 -49 0 -63 4 -83 25 -39 38 -32 53 35 66 51 10 56
    10 84 -1z m198 -6 c24 -15 -3 -94 -33 -94 -30 0 -79 31 -85 54 -12 48 0 59 58
    52 29 -4 55 -9 60 -12z m1194 -8 c3 -13 4 -35 2 -47 -3 -23 -7 -24 -90 -27
    -77 -2 -90 0 -108 18 -12 12 -20 31 -18 43 3 19 11 23 58 28 30 3 76 6 102 7
    43 2 48 -1 54 -22z m172 -24 l3 -43 29 31 c48 52 115 36 108 -27 l-3 -28 -115
    -3 c-63 -1 -121 2 -128 7 -18 11 -31 74 -20 95 8 13 21 16 66 14 l57 -3 3 -43z
    m3161 18 c113 -46 136 -74 54 -64 -116 14 -182 45 -169 79 8 22 32 19 115 -15z
    m2212 -2 c35 -18 64 -40 64 -48 0 -22 -91 -45 -121 -31 -28 12 -60 72 -51 95
    9 24 37 20 108 -16z m-7567 16 c44 -17 -22 -124 -75 -124 -15 0 -34 -13 -52
    -35 -26 -33 -75 -50 -63 -22 2 6 10 29 17 50 22 66 79 117 156 137 1 0 8 -3
    17 -6z m183 -6 c4 -7 6 -24 4 -37 -4 -30 14 -20 34 20 16 29 16 29 110 29 82
    0 98 -3 115 -20 35 -35 23 -89 -20 -88 -14 1 -54 -7 -89 -16 -48 -13 -78 -16
    -120 -10 -31 4 -69 9 -86 10 -56 5 -97 17 -102 30 -7 18 26 70 51 83 30 14 93
    13 103 -1z m1577 -4 c43 -42 6 -68 -97 -69 -93 0 -106 12 -63 58 22 24 33 27
    85 27 41 0 65 -5 75 -16z m-2843 -30 c28 -47 24 -73 -13 -88 -57 -23 -104 -28
    -117 -12 -10 12 -9 24 7 58 20 47 36 63 67 71 30 7 38 3 56 -29z m844 27 c7
    -12 -43 -51 -66 -51 -12 0 -19 -7 -19 -18 0 -51 -51 -54 -111 -8 -52 42 -83
    51 -121 35 -19 -8 -28 -19 -28 -35 0 -33 -41 -59 -70 -44 -17 9 -20 19 -18 48
    4 52 28 60 204 70 213 13 222 13 229 3z m88 -16 c-1 -11 -16 -50 -33 -87 -28
    -64 -32 -68 -63 -67 -45 1 -80 12 -84 26 -5 15 80 109 122 135 36 22 61 19 58
    -7z m2610 9 c9 -3 17 -11 17 -19 0 -17 -78 -87 -93 -82 -13 4 -22 80 -13 104
    6 14 30 13 89 -3z m457 -20 c16 -16 -6 -30 -80 -49 -36 -9 -80 -23 -97 -30
    -31 -13 -35 -12 -63 11 -29 25 -39 61 -22 78 11 12 250 2 262 -10z m-4149 -6
    c4 -50 -23 -128 -45 -128 -17 0 -76 66 -76 85 0 31 118 72 121 43z m3814 -40
    c42 -63 44 -82 8 -105 -16 -9 -48 -32 -72 -50 -34 -25 -54 -33 -87 -33 -23 0
    -46 5 -49 10 -6 10 144 230 157 230 4 0 23 -24 43 -52z m477 36 c4 -3 0 -17
    -8 -32 -8 -15 -14 -50 -14 -79 0 -29 -5 -55 -12 -59 -14 -9 -121 102 -115 120
    4 12 102 55 128 56 9 0 18 -3 21 -6z m1213 -5 c4 -5 18 -14 31 -19 13 -5 24
    -16 24 -24 0 -18 -47 -56 -69 -56 -25 0 -61 29 -61 48 0 43 57 81 75 51z
    m-4983 -16 c22 -20 23 -66 2 -88 -15 -15 -87 -55 -99 -55 -22 0 12 107 45 140
    24 24 28 25 52 3z m7636 -15 c29 -28 30 -90 3 -117 -17 -17 -25 -18 -60 -9
    -50 13 -81 49 -81 95 0 29 5 36 33 48 38 17 74 11 105 -17z m-5768 -23 c0 -40
    -36 -74 -106 -101 -45 -17 -47 -17 -61 2 -22 30 -27 64 -12 79 17 17 160 66
    171 59 4 -3 8 -20 8 -39z m4110 35 c128 -12 155 -23 165 -72 12 -53 20 -56 25
    -8 4 39 8 45 30 48 43 5 64 -19 61 -69 -2 -46 9 -46 33 2 6 12 19 27 29 33 38
    23 73 -56 47 -105 -14 -26 -43 -25 -212 11 -227 49 -218 45 -218 85 0 42 -17
    56 -22 18 -3 -27 -5 -28 -58 -28 -75 1 -107 11 -126 40 -38 58 7 66 246 45z
    m-6096 -35 c-1 -56 -27 -210 -37 -222 -6 -8 -33 -13 -68 -13 -72 0 -79 19 -18
    50 44 23 48 37 6 21 -37 -14 -49 5 -36 53 12 43 28 53 60 36 20 -11 20 -10 -5
    22 -40 53 -34 65 34 79 55 11 65 7 64 -26z m319 -43 c-10 -109 -20 -116 -59
    -40 l-27 52 34 28 c43 36 58 24 52 -40z m1457 64 c0 -3 -4 -8 -10 -11 -5 -3
    -10 -1 -10 4 0 6 5 11 10 11 6 0 10 -2 10 -4z m5810 -22 c6 -14 7 -37 4 -51
    -6 -24 -10 -25 -52 -19 -56 8 -92 30 -92 57 0 24 30 38 88 38 37 1 44 -2 52
    -25z m-8120 -22 c32 -28 42 -43 37 -56 -6 -15 -14 -17 -45 -11 -93 17 -122 46
    -85 87 24 27 46 22 93 -20z m2267 22 c5 -16 -54 -36 -63 -22 -8 13 25 40 45
    36 8 -2 16 -8 18 -14z m-1319 -27 c31 -29 28 -42 -18 -60 -47 -18 -65 -6 -54
    40 14 57 27 60 72 20z m1027 22 c16 -24 -6 -61 -48 -79 -45 -21 -132 -27 -142
    -10 -10 16 43 58 99 79 58 23 82 25 91 10z m133 5 c31 -9 28 -39 -5 -53 -98
    -40 -134 -28 -81 26 32 33 45 37 86 27z m1100 -10 c25 -17 29 -46 8 -63 -8 -7
    -59 -18 -113 -26 -54 -8 -106 -17 -115 -20 -28 -11 -31 15 -6 53 14 20 27 45
    31 55 5 14 19 17 89 17 59 0 90 -5 106 -16z m1642 6 c0 -5 -4 -10 -10 -10 -5
    0 -10 5 -10 10 0 6 5 10 10 10 6 0 10 -4 10 -10z m2195 0 c3 -5 1 -10 -4 -10
    -6 0 -11 5 -11 10 0 6 2 10 4 10 3 0 8 -4 11 -10z m-2777 -33 c25 -26 29 -36
    20 -45 -7 -7 -16 -12 -20 -12 -5 0 -35 -19 -67 -41 -33 -23 -64 -38 -70 -34
    -20 12 -62 86 -59 103 3 18 100 61 139 62 16 0 37 -12 57 -33z m2973 22 c34
    -18 10 -29 -61 -29 -77 0 -100 6 -100 26 0 17 130 20 161 3z m-5789 -56 c13
    -28 3 -67 -23 -92 -11 -10 -55 -30 -97 -44 -94 -31 -250 -95 -277 -113 -25
    -18 -66 -18 -90 0 -16 12 -18 18 -7 40 14 31 54 43 89 27 33 -15 41 -7 18 19
    -21 23 -11 41 36 66 41 21 74 18 87 -8 10 -21 11 -20 11 13 1 19 7 42 14 51
    20 26 88 68 111 68 12 0 30 7 40 15 17 13 23 12 49 -3 16 -9 34 -27 39 -39z
    m1504 42 c15 -37 -80 -138 -125 -133 -28 3 -71 66 -71 105 0 22 1 23 90 36 61
    10 101 7 106 -8z m457 -7 c21 -11 23 -56 2 -64 -19 -8 -135 12 -148 25 -5 5
    -7 21 -3 34 6 24 8 25 68 20 35 -3 71 -10 81 -15z m-3043 -6 c0 -37 -29 -62
    -72 -62 -31 0 -39 -3 -35 -15 9 -21 -7 -27 -98 -36 -85 -7 -138 -28 -193 -74
    -39 -33 -74 -32 -114 3 -18 16 -46 32 -63 36 -68 17 -73 49 -10 77 54 24 138
    30 157 11 14 -14 11 -17 -57 -65 -37 -27 -24 -32 22 -9 85 43 225 92 263 92
    27 0 40 4 40 14 0 14 85 43 133 45 20 1 27 -4 27 -17z m1420 9 c0 -5 -18 -25
    -40 -45 -41 -37 -76 -46 -98 -24 -9 9 -18 5 -37 -15 -29 -28 -73 -42 -105 -32
    -27 8 -27 54 0 83 18 19 32 22 98 23 42 1 88 5 102 9 35 11 80 12 80 1z m1807
    -3 c6 -8 7 -25 1 -45 -7 -27 -13 -33 -37 -33 -15 0 -42 5 -60 11 -61 21 -20
    78 55 79 17 0 36 -6 41 -12z m4799 -29 c32 -31 51 -42 85 -46 51 -6 128 -30
    146 -45 16 -13 17 -54 3 -63 -6 -4 -54 10 -108 30 -53 20 -117 44 -142 54 -40
    14 -45 21 -48 50 -4 35 3 61 15 61 4 0 26 -18 49 -41z m-6105 19 c8 -7 27 -27
    43 -45 35 -39 26 -58 -34 -68 -57 -10 -78 0 -91 45 -14 45 -3 66 34 73 12 2
    25 5 28 6 3 0 12 -5 20 -11z m1429 0 c0 -7 -18 -33 -39 -57 -45 -52 -67 -49
    -56 8 9 49 21 61 61 61 21 0 34 -5 34 -12z m1869 -14 c38 -31 39 -51 5 -64
    -35 -14 -114 -13 -114 1 0 24 45 89 61 89 10 0 31 -12 48 -26z m2940 11 c88
    -18 126 -34 181 -74 24 -17 48 -31 55 -31 6 0 29 -15 50 -33 43 -37 41 -57 -7
    -57 -17 0 -40 -7 -50 -16 -16 -15 -22 -15 -55 -2 -26 9 -38 20 -38 33 0 16 6
    19 30 17 l29 -4 -39 44 c-50 56 -53 58 -97 58 -66 0 -168 44 -168 72 0 12 29
    10 109 -7z m-5799 -47 c16 -22 30 -51 30 -64 0 -20 -10 -26 -68 -43 -38 -12
    -84 -24 -103 -28 -19 -3 -43 -12 -54 -19 -11 -7 -39 -16 -62 -20 l-43 -6 -20
    47 c-27 64 -26 83 8 92 15 3 41 15 57 25 60 36 84 18 66 -48 -7 -26 -7 -42 0
    -49 13 -13 26 9 34 60 13 81 25 93 92 94 27 1 38 -6 63 -41z m2984 23 c20 -22
    14 -41 -14 -41 -34 0 -50 12 -50 36 0 19 5 24 23 24 13 0 32 -9 41 -19z
    m-4941 -22 c30 -41 11 -64 -74 -89 -93 -28 -148 -30 -163 -7 -17 26 1 45 84
    89 85 45 123 47 153 7z m4036 20 c17 -6 31 -17 31 -25 0 -16 -5 -16 -71 -14
    -53 2 -74 -15 -30 -23 36 -8 42 -22 28 -80 -12 -56 -3 -71 60 -98 59 -25 54
    -48 -11 -63 l-30 -7 29 -23 c34 -28 26 -50 -15 -41 -37 8 -43 -5 -19 -41 22
    -34 24 -62 4 -88 -24 -32 -18 -56 15 -69 41 -15 38 -33 -7 -47 -21 -6 -44 -14
    -52 -16 -11 -3 -9 -10 9 -29 l23 -24 -24 -5 c-63 -13 -128 -14 -137 -3 -5 7
    -15 35 -21 62 -19 77 -100 333 -127 400 -28 69 -29 86 -10 123 22 43 46 58
    131 85 124 40 169 45 224 26z m983 -6 c23 -21 23 -33 0 -33 -21 0 -42 18 -42
    37 0 18 20 16 42 -4z m1389 7 c11 -7 21 -26 25 -49 l6 -38 81 -6 c86 -7 127
    -25 127 -57 0 -26 0 -26 -160 10 -195 43 -220 51 -220 67 0 21 28 70 42 76 23
    9 79 7 99 -3z m789 -8 c0 -16 7 -18 58 -14 103 7 282 -52 282 -94 0 -20 -24
    -28 -47 -16 -10 6 -107 23 -216 38 -108 15 -205 33 -215 40 -30 23 -3 48 59
    55 30 3 60 6 67 7 6 1 12 -6 12 -16z m-5784 -37 c18 -55 6 -67 -65 -63 -50 3
    -57 6 -65 30 -16 45 26 78 92 74 18 -1 27 -10 38 -41z m-1071 25 c38 -14 28
    -39 -25 -67 -60 -31 -84 -27 -88 13 -5 56 45 80 113 54z m5065 -29 c-14 -26
    -98 -101 -113 -101 -8 0 -46 16 -86 36 -97 48 -94 73 7 74 26 1 76 7 112 14
    71 13 96 6 80 -23z m251 30 c30 -5 76 -12 102 -16 64 -9 87 -32 87 -89 0 -76
    -23 -85 -105 -42 -16 9 -37 16 -46 16 -41 0 -80 24 -109 68 -49 74 -41 82 71
    63z m-2387 -32 c42 -50 36 -59 -41 -59 -75 0 -99 10 -90 34 8 19 66 56 89 56
    9 0 28 -14 42 -31z m894 -5 c23 -19 42 -44 42 -55 0 -25 -1 -24 -53 11 -45 30
    -62 54 -51 71 9 15 18 11 62 -27z m1371 -12 c35 -56 39 -89 13 -123 -10 -13
    -21 -32 -25 -41 -8 -22 -40 -23 -57 -3 -7 8 -30 25 -51 37 -22 12 -39 29 -39
    38 0 34 88 139 116 140 7 0 26 -22 43 -48z m-5329 9 c0 -42 -33 -77 -84 -90
    -69 -17 -78 -15 -74 16 4 35 91 103 131 103 23 0 27 -4 27 -29z m3366 10 c9
    -10 27 -31 40 -45 43 -48 36 -54 -92 -67 -94 -10 -124 -4 -124 22 0 20 119
    109 147 109 7 0 20 -8 29 -19z m-2326 -10 c28 -53 2 -81 -74 -81 -49 0 -76 24
    -76 66 0 26 14 31 87 33 42 1 54 -3 63 -18z m1370 -11 c5 -8 14 -37 21 -64 15
    -62 4 -72 -89 -82 -88 -9 -113 1 -128 52 -7 23 -18 52 -24 65 -11 19 -10 24 6
    36 27 20 201 14 214 -7z m-291 -4 c28 -15 59 -71 64 -116 2 -22 -3 -25 -43
    -32 -25 -3 -69 -7 -97 -7 -53 -1 -59 3 -53 39 1 8 5 35 9 60 9 64 59 87 120
    56z m450 0 c69 -15 83 -28 75 -66 -10 -41 -40 -60 -99 -60 -60 0 -68 7 -85 68
    -8 33 -8 47 1 58 14 17 26 17 108 0z m4275 -11 c59 -10 102 -23 127 -39 34
    -23 36 -23 32 -5 -5 16 0 19 30 19 20 0 48 -5 64 -11 15 -6 70 -17 121 -24 51
    -7 99 -19 107 -25 35 -29 1 -83 -59 -94 -25 -5 -52 2 -112 30 -43 19 -86 42
    -95 50 -14 13 -20 12 -45 -1 -22 -12 -46 -14 -99 -9 -69 6 -118 24 -182 67
    -53 35 -55 70 -5 62 15 -3 67 -12 116 -20z m-7474 -16 c0 -44 -14 -63 -65 -93
    -25 -15 -45 -29 -45 -31 0 -2 25 5 55 16 30 11 90 22 133 25 42 3 105 12 140
    21 49 12 66 13 75 4 9 -10 7 -16 -9 -29 -81 -67 -108 -92 -98 -92 6 0 38 24
    71 53 33 28 73 62 89 75 32 25 79 29 87 8 9 -22 -32 -75 -83 -111 -48 -34 -64
    -65 -33 -65 9 0 43 27 75 60 46 49 68 64 116 79 78 24 94 15 57 -33 -15 -20
    -31 -36 -35 -36 -3 0 -27 -20 -51 -43 -24 -24 -66 -54 -93 -66 -27 -11 -46
    -24 -43 -27 4 -4 30 3 58 15 68 30 81 18 50 -44 -20 -40 -26 -45 -55 -45 -19
    0 -53 9 -78 20 -24 10 -126 42 -227 70 -215 59 -245 72 -239 105 5 22 4 22
    -27 9 -22 -9 -43 -10 -69 -4 -55 12 -66 27 -38 50 20 16 46 26 182 69 33 10
    31 10 -18 5 -68 -6 -126 -29 -174 -65 -43 -34 -58 -36 -88 -11 -30 24 -22 36
    52 73 56 28 212 64 296 68 29 1 32 -1 32 -30z m1418 24 c-10 -2 -26 -2 -35 0
    -10 3 -2 5 17 5 19 0 27 -2 18 -5z m4194 -54 c63 -35 71 -47 59 -99 -7 -32
    -10 -35 -44 -34 -86 3 -127 45 -127 132 0 58 7 67 34 47 12 -8 47 -29 78 -46z
    m867 42 c11 -6 25 -28 31 -49 12 -44 13 -129 2 -136 -16 -9 -205 22 -214 36
    -10 16 -1 111 15 146 11 23 14 24 79 19 37 -3 76 -11 87 -16z m-5179 -4 c0
    -16 -233 -89 -255 -80 -37 14 4 46 80 63 28 7 64 16 80 20 49 13 95 12 95 -3z
    m1293 -11 c7 -18 -2 -84 -15 -108 -14 -29 -72 -24 -98 9 -34 44 -24 73 35 94
    63 22 72 22 78 5z m1933 0 c14 -11 16 -18 7 -26 -12 -13 -69 -5 -78 11 -18 28
    37 40 71 15z m904 -15 c31 -30 48 -77 34 -91 -12 -11 -123 7 -149 24 -21 14
    -48 80 -37 90 3 3 32 6 64 6 52 0 63 -4 88 -29z m2698 4 c119 -43 224 -94 219
    -108 -8 -25 -55 -32 -87 -13 -31 18 -41 8 -15 -14 14 -12 13 -16 -6 -36 -49
    -52 -123 -32 -202 55 -64 71 -46 91 52 55 69 -26 85 -29 76 -15 -3 5 -31 19
    -63 31 -79 29 -102 41 -102 57 0 20 51 16 128 -12z m-6637 5 c35 -19 21 -38
    -47 -60 -42 -14 -78 -20 -100 -17 -30 5 -36 3 -44 -17 -10 -28 -115 -75 -131
    -59 -18 18 -6 75 21 95 23 17 206 64 258 67 13 1 32 -4 43 -9z m5304 -37 c219
    -48 218 -47 244 -124 23 -68 26 -95 12 -103 -4 -3 -36 4 -70 15 -68 23 -82 40
    -91 107 -3 23 -9 44 -15 45 -14 3 -18 -56 -6 -100 15 -53 3 -60 -64 -37 -82
    27 -80 25 -77 101 3 75 -12 72 -24 -4 -3 -23 -11 -47 -18 -52 -16 -14 -100 6
    -121 29 -21 24 -31 119 -15 149 14 27 2 28 245 -26z m-4803 20 c28 -5 52 -50
    42 -78 -7 -18 -197 -80 -219 -72 -8 4 -15 13 -15 20 0 25 45 82 67 85 15 2 19
    8 16 22 -6 23 30 43 62 34 11 -3 32 -8 47 -11z m1486 -65 l3 -67 -84 -26
    c-109 -33 -121 -33 -113 1 4 15 20 55 36 90 30 67 41 73 125 70 30 -1 30 -1
    33 -68z m217 41 c86 -11 105 -17 105 -33 0 -7 -31 -16 -87 -23 -49 -6 -109
    -18 -135 -27 -43 -13 -49 -13 -63 0 -20 20 -19 54 1 83 15 21 22 23 63 16 25
    -3 77 -11 116 -16z m3527 11 c52 -15 79 -40 72 -67 -3 -12 -11 -23 -17 -26
    -20 -6 -168 43 -174 59 -16 42 36 57 119 34z m-5424 -37 c5 -31 -45 -122 -73
    -135 -13 -6 -31 -8 -40 -4 -32 12 5 126 40 126 8 0 20 9 27 20 16 26 42 22 46
    -7z m632 -5 c35 -56 25 -68 -67 -91 -92 -22 -107 -18 -118 35 -9 39 5 53 75
    71 80 22 88 21 110 -15z m2480 17 c22 -27 4 -45 -45 -45 -38 0 -45 3 -45 19 0
    12 11 23 28 29 38 15 48 14 62 -3z m-3905 -4 c7 -13 -19 -38 -66 -61 -69 -36
    -105 -18 -56 28 37 35 108 55 122 33z m3503 -7 c12 -8 22 -22 22 -30 0 -20
    -43 -18 -70 4 -42 34 3 58 48 26z m543 0 c63 -14 71 -19 83 -47 12 -32 13 -32
    25 -9 16 29 38 28 124 -7 40 -16 98 -32 130 -36 62 -7 81 -25 55 -51 -13 -14
    -29 -12 -137 10 -67 14 -126 26 -131 26 -5 0 2 -11 15 -25 29 -28 31 -47 9
    -70 -19 -19 -58 -13 -86 12 -23 21 -23 38 2 63 11 11 20 21 20 23 0 1 -33 13
    -72 26 -127 42 -128 42 -128 66 0 20 7 35 17 35 2 0 35 -7 74 -16z m1095 -15
    c67 -20 104 -42 92 -55 -4 -3 -61 -8 -127 -11 -110 -5 -121 -4 -127 12 -5 13
    2 26 24 47 39 34 50 34 138 7z m-4612 -10 c-3 -5 19 -9 49 -9 66 0 86 -17 69
    -55 -13 -28 -37 -33 -46 -10 -4 11 -20 15 -55 15 -37 0 -53 5 -60 17 -8 16
    -14 16 -58 4 -84 -24 -93 -24 -93 -8 0 17 33 32 115 50 60 14 90 12 79 -4z
    m3203 2 c21 -11 61 -23 88 -26 84 -11 114 -24 132 -58 l17 -32 6 25 c5 21 12
    25 44 24 51 -2 68 -22 74 -88 5 -57 -4 -70 -28 -41 -7 8 -17 15 -22 15 -5 0
    -67 23 -139 50 -71 28 -153 56 -180 62 -56 13 -67 27 -51 64 14 29 12 29 59 5z
    m2696 -3 c40 -16 73 -38 104 -71 79 -85 22 -86 -147 -4 -72 36 -91 57 -71 81
    18 22 45 20 114 -6z m-1611 -17 c44 -39 30 -53 -48 -49 -48 2 -59 6 -62 21 -5
    25 26 57 54 57 13 0 38 -13 56 -29z m-4698 3 c36 -35 7 -84 -63 -105 -50 -15
    -64 -9 -85 36 -22 46 -12 59 54 73 65 14 77 14 94 -4z m1091 -20 c49 -53 25
    -76 -115 -118 -66 -20 -71 -8 -29 67 47 81 99 99 144 51z m1019 17 c9 -13 -3
    -39 -20 -45 -8 -3 -44 -10 -79 -16 -35 -6 -79 -19 -97 -29 -75 -43 -129 -35
    -106 14 14 32 40 43 148 64 109 22 146 25 154 12z m822 -18 c34 -28 72 -112
    59 -133 -6 -10 -98 -40 -126 -40 -20 0 -34 29 -19 44 21 21 9 26 -45 20 -46
    -6 -55 -4 -55 9 0 21 30 37 72 38 18 0 42 4 53 9 15 7 9 9 -25 9 -49 1 -70 14
    -70 42 0 22 14 27 73 28 38 1 55 -5 83 -26z m542 5 c-2 -13 -11 -24 -21 -26
    -22 -4 -35 27 -16 39 25 16 41 10 37 -13z m2547 7 c54 -26 67 -82 24 -105 -25
    -14 -79 -12 -83 3 -2 6 -9 31 -16 53 -7 23 -9 47 -6 53 10 15 42 14 81 -4z
    m540 0 c33 -9 76 -27 95 -39 19 -13 46 -27 60 -31 55 -16 170 -77 170 -90 0
    -19 -35 -28 -78 -20 -37 7 -177 73 -224 106 -16 12 -43 19 -72 19 -50 0 -90
    27 -80 55 8 19 53 19 129 0z m-3827 -29 c4 -32 -10 -46 -49 -46 -35 0 -54 22
    -40 48 13 24 28 31 61 29 20 -2 26 -8 28 -31z m-3030 -1 c4 -29 -32 -58 -109
    -88 -75 -30 -179 -46 -179 -29 0 12 108 78 193 118 60 28 91 28 95 -1z m7227
    -22 c60 -42 69 -71 25 -86 -20 -7 -40 -2 -94 25 -39 18 -72 38 -74 45 -4 13
    54 53 76 53 7 0 38 -17 67 -37z m-6742 21 c9 -10 -4 -34 -19 -34 -8 0 -14 6
    -14 13 0 22 19 35 33 21z m737 -9 c0 -21 -35 -88 -54 -104 -41 -34 -52 54 -11
    94 27 28 65 33 65 10z m1683 -7 c20 -31 -9 -49 -72 -46 -71 4 -81 27 -24 51
    46 20 82 18 96 -5z m-3133 -3 c23 -28 -64 -87 -106 -71 -13 5 -10 13 16 46 34
    42 68 52 90 25z m355 -15 c25 -49 19 -68 -32 -100 -26 -17 -60 -30 -75 -30
    -26 0 -28 3 -28 41 0 35 6 48 39 80 47 47 75 50 96 9z m510 20 c3 -5 -8 -16
    -25 -25 -29 -15 -31 -19 -25 -54 7 -43 2 -50 -66 -74 -25 -10 -90 -49 -144
    -88 -70 -50 -106 -69 -124 -67 -43 5 -35 27 22 53 30 14 78 47 108 74 30 26
    68 53 86 60 17 7 39 21 48 31 15 16 14 18 -5 23 -23 6 -26 29 -6 46 31 26 119
    40 131 21z m1250 0 c8 -13 -18 -72 -43 -93 -32 -29 -56 -18 -60 25 -5 56 11
    78 58 78 21 0 41 -4 45 -10z m173 1 c8 -5 12 -21 10 -37 -4 -38 -39 -55 -108
    -52 -52 3 -55 4 -52 28 1 13 9 35 17 47 13 19 24 23 68 23 28 0 58 -4 65 -9z
    m4476 -49 c22 -26 77 -83 123 -127 46 -44 83 -83 83 -87 0 -22 -45 0 -130 63
    -52 39 -111 78 -132 86 -47 19 -88 66 -88 100 0 25 1 25 53 19 46 -6 56 -12
    91 -54z m-6109 38 c3 -5 1 -10 -4 -10 -6 0 -11 5 -11 10 0 6 2 10 4 10 3 0 8
    -4 11 -10z m1313 -2 c16 -16 15 -73 0 -86 -7 -5 -43 -13 -81 -17 -81 -8 -91 3
    -53 63 25 40 30 42 107 50 8 1 20 -3 27 -10z m3527 -23 c11 -13 53 -40 93 -61
    70 -35 93 -57 78 -71 -3 -4 -30 1 -59 10 -28 8 -87 21 -131 27 -43 7 -97 19
    -120 27 -22 9 -72 23 -111 32 -91 22 -95 43 -10 53 53 7 62 6 75 -12 17 -22
    79 -50 110 -50 34 0 13 18 -29 25 -47 8 -77 27 -67 43 5 8 29 10 79 6 57 -5
    76 -11 92 -29z m191 0 c64 -33 174 -121 174 -140 0 -19 -25 -22 -92 -10 -25 4
    -57 22 -93 55 -31 26 -73 56 -93 65 -78 37 -78 55 2 55 36 0 67 -8 102 -25z
    m160 0 c17 -7 44 -30 60 -51 15 -22 43 -59 61 -83 36 -48 35 -61 -3 -61 -18 0
    -46 21 -97 73 -40 41 -85 83 -101 94 -21 14 -27 25 -23 37 8 19 42 16 103 -9z
    m-4866 0 c37 -19 38 -33 3 -41 -16 -3 -47 -12 -71 -21 -23 -8 -49 -12 -57 -9
    -26 10 -17 45 18 66 39 24 68 25 107 5z m348 -13 c11 -75 -64 -122 -166 -106
    -46 7 -58 13 -60 30 -2 15 9 27 47 48 111 60 173 70 179 28z m1642 -6 c0 -28
    -105 -90 -143 -84 -44 6 -28 68 18 68 12 0 29 7 36 16 28 34 89 35 89 0z
    m-2379 4 c-27 -23 -61 -26 -61 -6 0 17 15 24 55 25 l30 0 -24 -19z m1219 7 c0
    -47 -125 -153 -211 -178 -34 -11 -42 -9 -81 14 -106 62 -111 83 -21 94 50 5
    52 5 67 -26 16 -31 46 -43 46 -18 0 7 -7 23 -16 36 -23 32 -7 45 86 69 90 24
    130 27 130 9z m787 -14 c6 -18 -46 -48 -59 -35 -7 7 -3 17 12 32 22 22 41 23
    47 3z m2399 1 c55 -18 90 -46 80 -63 -21 -34 -176 24 -176 66 0 18 36 17 96
    -3z m1061 -47 c38 -35 93 -80 124 -100 96 -60 92 -83 -8 -60 -100 23 -136 45
    -193 120 -59 78 -64 103 -20 103 23 0 45 -15 97 -63z m1136 10 c53 -25 97 -51
    97 -57 0 -15 -45 -30 -92 -30 -26 0 -61 11 -100 32 -65 35 -92 65 -82 93 10
    26 63 15 177 -38z m-6516 26 c8 -20 -31 -55 -52 -46 -21 7 -19 40 3 52 25 15
    42 13 49 -6z m3418 8 c3 -5 -6 -22 -19 -38 -20 -23 -28 -26 -43 -17 -27 17
    -28 43 -1 53 30 13 55 13 63 2z m167 -25 c62 -27 69 -38 55 -79 -12 -36 -35
    -47 -77 -38 -33 7 -35 10 -35 47 0 48 -15 53 -35 11 -17 -35 -43 -45 -66 -26
    -18 15 -13 59 12 97 14 21 21 23 53 18 21 -3 63 -17 93 -30z m2701 -22 c107
    -48 157 -79 157 -95 0 -12 -62 -39 -90 -39 -40 0 -220 145 -220 177 0 21 28
    13 153 -43z m-3723 11 c15 -26 22 -30 52 -27 26 2 37 -1 42 -14 4 -10 3 -21
    -2 -26 -15 -15 -136 -56 -149 -51 -18 7 -16 43 4 65 15 17 15 18 -18 12 -19
    -3 -40 -8 -47 -10 -24 -7 -52 16 -52 42 0 22 4 25 23 21 12 -3 31 1 42 9 33
    25 86 14 105 -21z m1519 24 c38 -13 56 -50 40 -80 -8 -16 -17 -19 -42 -14 -73
    16 -114 58 -87 90 15 18 45 19 89 4z m-4559 -31 c0 -33 -29 -77 -72 -108 -42
    -31 -72 -38 -83 -20 -7 12 65 111 102 140 28 22 53 16 53 -12z m2297 15 c8
    -21 -33 -55 -61 -51 -30 4 -27 39 4 55 34 17 49 16 57 -4z m3666 1 c31 -10 57
    -28 74 -51 15 -19 63 -56 106 -81 74 -43 97 -65 84 -79 -13 -12 -79 10 -124
    42 -26 19 -71 47 -99 64 -63 37 -128 97 -119 111 9 14 23 13 78 -6z m-5683
    -13 c0 -5 -15 -20 -32 -32 -18 -12 -58 -43 -88 -69 -75 -64 -80 -66 -152 -60
    -48 4 -64 9 -66 22 -4 19 17 32 66 43 26 5 32 3 32 -10 0 -10 7 -15 17 -13 10
    2 18 12 18 23 0 15 8 21 30 23 17 2 35 10 42 19 34 44 133 84 133 54z m108
    -32 c4 -45 -33 -89 -76 -89 -20 0 -38 -10 -61 -35 -50 -55 -111 -41 -83 20 6
    13 33 35 61 51 28 15 51 31 51 35 0 13 73 58 90 56 9 -1 16 -15 18 -38z m482
    32 c0 -13 -97 -71 -200 -119 -91 -43 -166 -100 -159 -121 3 -9 21 -1 54 25 62
    47 193 117 261 139 38 12 57 14 78 6 28 -11 27 -31 -2 -31 -28 0 -125 -49
    -157 -80 -16 -15 -55 -47 -85 -70 -48 -36 -60 -41 -93 -35 -21 3 -46 10 -55
    15 -9 5 -48 16 -87 23 -46 9 -70 18 -70 27 0 22 164 128 230 149 33 11 96 33
    140 50 79 30 145 40 145 22z m1972 -15 c16 -37 4 -53 -55 -72 -60 -19 -87 -14
    -87 14 0 21 21 42 65 65 43 23 64 21 77 -7z m-274 2 c18 -18 15 -46 -6 -57 -9
    -5 -46 -15 -80 -22 -54 -11 -64 -11 -72 1 -6 8 -10 18 -10 21 -1 42 136 89
    168 57z m2150 -8 c39 -24 42 -56 6 -72 -24 -11 -25 -12 -5 -19 11 -5 24 -16
    29 -26 13 -25 -3 -63 -26 -63 -28 0 -112 31 -112 41 0 5 -11 9 -24 9 -32 0
    -216 79 -216 93 0 14 119 2 163 -17 20 -8 45 -24 56 -35 20 -20 23 -20 44 -6
    12 8 31 15 42 16 l20 0 -20 9 c-36 14 -49 37 -37 65 14 30 36 31 80 5z m260
    14 c32 -7 45 -24 36 -49 -8 -21 -57 -19 -85 4 -20 16 -21 21 -10 35 15 18 17
    18 59 10z m1160 -20 c2 -16 32 -37 113 -80 60 -33 122 -69 137 -81 24 -19 25
    -22 9 -28 -35 -14 -85 7 -183 76 -122 87 -139 103 -130 124 9 24 50 15 54 -11z
    m-3963 -9 c0 -24 -50 -54 -65 -39 -7 7 -4 19 11 38 24 30 54 31 54 1z m-2315
    -3 c0 -10 -16 -33 -34 -51 -33 -32 -38 -34 -87 -28 -90 11 -85 42 11 76 73 26
    110 27 110 3z m5317 -3 c27 -10 30 -40 7 -63 -20 -20 -30 -20 -82 4 -44 20
    -58 39 -48 66 5 13 15 15 53 9 25 -4 57 -11 70 -16z m-3317 -2 c0 -15 -144
    -139 -187 -160 -15 -8 -49 -20 -76 -27 -26 -7 -50 -17 -53 -21 -9 -15 -34 -10
    -34 6 0 41 115 131 212 164 31 10 68 26 84 35 36 19 54 20 54 3z m130 8 c0 -2
    -18 -29 -41 -58 -35 -47 -49 -58 -103 -76 -34 -11 -68 -21 -74 -21 -28 0 -9
    30 38 60 27 17 68 47 92 66 36 28 88 46 88 29z m90 -2 c0 -15 -85 -93 -102
    -93 -33 0 -20 24 36 69 37 29 66 40 66 24z m-895 -67 c-6 -53 -1 -53 31 0 10
    17 12 17 49 -2 21 -11 41 -26 43 -32 8 -26 -108 -56 -123 -32 -5 8 -11 7 -21
    0 -7 -7 -19 -10 -26 -8 -6 2 -20 -4 -30 -14 -13 -13 -33 -18 -73 -18 -48 0
    -55 3 -55 19 0 28 40 86 74 107 38 22 107 43 124 36 10 -3 12 -18 7 -56z m502
    49 c2 -6 -16 -20 -39 -33 -68 -36 -149 -105 -173 -148 -20 -36 -28 -41 -94
    -58 -51 -14 -75 -16 -83 -8 -7 7 -5 15 8 26 81 66 132 105 167 128 22 15 53
    39 68 54 44 42 136 67 146 39z m2548 -11 c34 -36 32 -68 -5 -94 -35 -25 -63
    -20 -86 14 -11 18 -12 29 -4 52 24 61 55 71 95 28z m636 -4 c25 -25 28 -33 19
    -50 -15 -28 -55 -26 -85 5 -29 28 -31 38 -9 59 23 23 42 20 75 -14z m-2495 -7
    c9 -35 -7 -57 -44 -61 -38 -4 -52 27 -28 63 23 35 63 34 72 -2z m983 -27 c14
    -27 25 -67 25 -90 1 -39 -1 -41 -36 -50 -55 -14 -68 2 -68 80 0 74 -12 83 -26
    22 l-9 -43 -58 0 c-57 0 -58 0 -83 -42 -19 -32 -31 -43 -50 -43 -30 0 -111 71
    -100 88 14 24 100 54 139 49 30 -4 39 -1 48 15 16 29 137 72 184 64 6 -1 21
    -24 34 -50z m476 34 c9 -15 -22 -114 -44 -141 -18 -22 -20 -22 -26 -6 -9 21
    10 103 31 135 16 24 29 28 39 12z m1504 -1 c28 -10 32 -15 29 -43 -3 -27 -7
    -31 -34 -34 -44 -4 -104 22 -104 45 0 41 45 54 109 32z m-2675 -8 c18 -28 -31
    -61 -90 -61 -28 0 -35 4 -32 18 6 32 107 68 122 43z m289 -30 c14 -14 0 -29
    -43 -51 -47 -24 -73 -25 -90 -5 -19 23 -28 18 -26 -17 1 -33 1 -33 -76 -53
    -71 -18 -79 -18 -94 -3 -9 8 -17 30 -17 48 -2 32 -1 33 58 45 33 7 74 19 90
    25 69 29 175 34 198 11z m1425 -3 c6 -6 12 -18 12 -28 0 -21 -37 -70 -52 -70
    -22 0 -48 33 -48 61 0 52 45 71 88 37z m649 0 c27 -22 8 -68 -29 -68 -49 0
    -93 48 -73 81 9 13 82 4 102 -13z m521 1 c24 -8 32 -16 32 -34 0 -38 -43 -45
    -128 -20 -39 12 -52 21 -52 35 0 39 57 46 148 19z m-4569 2 c27 -18 -2 -59
    -51 -71 -85 -22 -106 -31 -168 -75 -70 -49 -90 -55 -90 -26 0 32 100 102 218
    152 77 33 72 32 91 20z m1269 -23 c3 -24 -2 -28 -55 -48 -32 -13 -72 -24 -89
    -25 -17 -1 -35 -4 -40 -7 -27 -16 -147 -49 -166 -46 -27 4 -36 39 -15 57 26
    21 124 36 157 24 26 -10 31 -8 45 14 26 39 75 64 120 61 35 -3 40 -6 43 -30z
    m1680 15 c31 -27 38 -69 14 -82 -21 -11 -98 -18 -107 -9 -4 3 1 23 10 44 28
    68 46 78 83 47z m137 -14 c57 -22 88 -49 80 -71 -8 -21 -83 -61 -101 -54 -17
    7 -64 107 -64 137 0 16 4 19 18 14 9 -4 39 -16 67 -26z m-1560 -9 c0 -20 -43
    -40 -88 -40 -53 0 -47 30 8 47 50 15 80 12 80 -7z m1213 2 c2 -7 -3 -12 -12
    -12 -9 0 -16 7 -16 16 0 17 22 14 28 -4z m777 -11 c39 -15 50 -24 50 -41 0
    -29 -49 -59 -73 -44 -24 16 -55 72 -48 89 7 19 11 19 71 -4z m729 -1 c38 -6
    78 -16 88 -21 23 -12 24 -57 1 -66 -9 -3 -67 6 -130 22 -92 23 -113 31 -113
    46 0 23 28 39 60 34 14 -3 56 -9 94 -15z m501 -3 c34 -8 51 -18 53 -30 3 -16
    -4 -18 -69 -15 -53 2 -75 7 -82 19 -16 25 -1 50 25 44 13 -3 45 -11 73 -18z
    m-856 -12 c53 -27 47 -75 -9 -75 -30 0 -80 34 -80 54 0 35 43 45 89 21z
    m-3479 -1 c0 -3 -37 -42 -82 -85 -75 -72 -90 -82 -161 -104 -81 -26 -137 -32
    -137 -15 0 5 28 24 63 41 34 18 87 48 117 67 114 74 200 115 200 96z m960 -15
    c0 -22 -122 -60 -134 -41 -9 15 26 41 70 50 41 9 64 6 64 -9z m3063 -1 c2 -7
    19 -13 38 -13 28 0 35 -5 43 -28 9 -24 7 -31 -9 -44 -34 -25 -125 5 -125 41 0
    15 29 56 40 56 4 0 10 -6 13 -12z m-2849 -20 c32 -46 16 -70 -55 -83 -26 -5
    -39 -2 -49 10 -28 33 19 94 72 95 9 0 24 -10 32 -22z m3371 8 c52 -15 53 -40
    3 -44 -72 -6 -138 25 -111 51 10 10 63 7 108 -7z m-1664 -6 c25 -14 24 -38 -3
    -67 -27 -28 -48 -29 -82 -2 -33 26 -33 45 2 63 32 18 56 20 83 6z m812 -21
    c20 -11 22 -42 3 -58 -10 -8 -27 -8 -65 0 -62 13 -97 39 -88 63 6 16 15 17 70
    11 34 -4 70 -11 80 -16z m-4149 1 c40 -15 31 -35 -29 -69 -59 -34 -131 -48
    -155 -32 -12 8 -11 14 9 35 25 26 115 76 137 76 7 0 24 -4 38 -10z m2288 -30
    c22 -44 24 -118 3 -126 -8 -4 -37 8 -65 26 -60 39 -65 66 -20 112 37 37 60 33
    82 -12z m765 16 c10 -13 26 -38 35 -55 18 -33 38 -41 38 -16 0 17 30 35 60 35
    22 0 110 -55 110 -68 0 -14 -31 -52 -49 -62 -14 -7 -37 -3 -87 14 -38 13 -88
    29 -112 36 -45 12 -62 35 -62 85 0 23 23 55 40 55 5 0 17 -11 27 -24z m442 -7
    c16 -30 8 -77 -15 -86 -9 -3 -27 5 -43 21 -33 31 -41 26 -34 -20 5 -27 1 -40
    -17 -59 -29 -31 -9 -33 39 -4 31 18 35 19 51 4 10 -9 23 -36 30 -61 7 -25 19
    -44 26 -44 8 0 33 14 56 30 50 36 63 37 84 5 21 -32 12 -53 -26 -66 -16 -6
    -30 -17 -30 -24 0 -11 8 -11 44 2 24 9 51 13 60 10 36 -14 49 -119 15 -125 -9
    -2 -52 19 -96 47 -91 56 -260 143 -315 160 -47 16 -49 38 -8 90 17 21 34 51
    39 67 5 20 19 35 43 46 20 10 39 22 43 28 11 18 38 7 54 -21z m181 11 c6 -12
    10 -38 8 -58 l-3 -37 -55 -3 c-38 -2 -61 2 -75 13 -20 15 -20 15 3 33 13 9 38
    29 55 44 38 33 53 35 67 8z m1078 9 c35 -12 50 -43 32 -64 -15 -18 -93 -20
    -139 -4 -39 14 -58 44 -40 65 14 17 102 19 147 3z m-3868 -9 c25 -16 -2 -43
    -61 -62 -69 -21 -88 -22 -96 -2 -8 23 19 45 74 60 59 16 64 16 83 4z m345 -10
    c0 -9 -16 -19 -40 -26 -22 -6 -48 -14 -58 -19 -23 -10 -46 10 -30 26 15 15 85
    39 108 36 11 -1 20 -9 20 -17z m245 1 c25 -47 -1 -88 -62 -97 -37 -7 -51 4
    -61 47 -11 43 17 65 85 68 18 1 31 -6 38 -18z m510 0 c0 -11 -9 -22 -20 -26
    -10 -3 -30 -19 -44 -36 -30 -35 -43 -37 -58 -5 -15 33 -5 54 34 71 49 21 88
    19 88 -4z m3241 2 c20 -20 -1 -33 -53 -33 l-51 0 27 -21 c53 -42 -16 -61 -116
    -33 -22 7 -23 40 -2 48 9 3 30 6 47 6 28 0 29 1 12 13 -11 9 -15 19 -10 27 9
    15 129 10 146 -7z m-1415 -13 c36 -23 49 -49 39 -79 -10 -32 -38 -33 -88 -5
    -41 22 -47 30 -47 58 0 18 3 36 7 39 13 13 56 7 89 -13z m-858 -27 c4 -44 -24
    -59 -73 -39 -19 8 -35 20 -35 26 0 22 44 50 75 47 26 -2 30 -6 33 -34z m1372
    8 c14 -10 25 -27 25 -37 0 -17 -7 -19 -59 -17 -70 3 -103 26 -91 63 6 20 12
    22 54 16 25 -3 57 -14 71 -25z m1154 13 c25 -10 19 -33 -10 -40 -36 -9 -158 2
    -185 17 -22 11 -22 12 -3 26 15 12 37 14 101 9 45 -3 88 -9 97 -12z m-520 -7
    c10 -7 17 -22 15 -33 -3 -15 -14 -20 -48 -22 -66 -5 -93 4 -89 30 5 34 87 50
    122 25z m-3669 -3 c26 -10 49 -63 34 -80 -35 -42 -95 9 -71 61 13 27 13 28 37
    19z m780 -16 c25 -12 45 -27 45 -33 0 -5 -16 -34 -36 -64 -29 -43 -40 -52 -57
    -48 -72 18 -99 26 -104 31 -3 3 6 19 21 36 14 17 26 38 26 45 0 11 45 55 56
    55 2 0 24 -10 49 -22z m393 -4 c35 -24 26 -57 -18 -65 -19 -3 -45 -11 -57 -17
    -12 -7 -31 -12 -42 -12 -17 0 -21 6 -21 34 0 63 83 99 138 60z m3216 10 c9 -3
    16 -14 16 -24 0 -22 -40 -30 -103 -21 -56 9 -80 27 -57 41 17 11 120 13 144 4z
    m-4998 -16 c11 -17 -29 -45 -90 -62 -70 -21 -86 -20 -86 2 0 38 157 92 176 60z
    m354 2 c0 -15 -29 -27 -119 -50 -59 -15 -87 -18 -94 -11 -16 16 2 30 69 51 63
    20 144 26 144 10z m789 -14 c23 -24 22 -46 -2 -46 -7 -1 -29 -16 -51 -35 -32
    -29 -38 -39 -33 -63 7 -36 1 -45 -50 -71 -50 -25 -76 -27 -93 -6 -15 18 3 43
    57 76 35 22 43 39 19 39 -16 0 -76 47 -76 60 0 17 32 40 56 40 17 0 30 -9 42
    -30 21 -38 32 -38 32 -1 0 48 9 61 44 61 21 0 40 -8 55 -24z m-609 0 c6 -8 10
    -25 8 -38 -2 -19 -9 -23 -38 -23 -29 0 -36 4 -38 23 -2 13 -1 30 2 38 7 18 50
    18 66 0z m3307 8 c28 -8 39 -40 22 -60 -10 -13 -24 -15 -63 -9 -65 8 -86 20
    -86 50 0 23 3 25 53 25 28 0 62 -3 74 -6z m-488 -33 c45 -8 58 -30 41 -70 -7
    -17 -18 -31 -25 -31 -14 0 -77 66 -94 98 -14 25 -4 34 23 20 11 -7 36 -14 55
    -17z m1806 15 c23 -7 40 -18 40 -26 0 -12 -13 -15 -62 -13 -66 1 -103 15 -103
    38 0 19 66 19 125 1z m-1099 -16 c27 -11 34 -54 10 -63 -21 -8 -135 10 -152
    24 -15 12 -19 41 -6 53 8 9 113 -1 148 -14z m589 7 c29 -22 9 -40 -34 -32 -58
    10 -71 16 -71 31 0 19 79 19 105 1z m178 -14 c19 -5 23 -28 6 -38 -15 -10 -93
    3 -114 19 -43 31 23 43 108 19z m-4735 -15 c2 -11 -10 -20 -45 -32 -68 -22
    -118 -25 -118 -6 0 10 24 23 65 37 73 25 93 25 98 1z m336 -4 c7 -19 -29 -41
    -89 -52 -27 -6 -64 -16 -81 -23 -37 -15 -64 -7 -64 19 0 28 30 50 85 61 101
    21 140 19 149 -5z m1620 20 c22 -8 20 -34 -1 -34 -26 0 -47 16 -39 29 8 12 17
    14 40 5z m2176 -7 c28 -14 38 -46 18 -58 -22 -15 -95 -10 -112 7 -19 19 -21
    50 -3 57 23 10 72 7 97 -6z m1161 -7 c31 -17 13 -30 -44 -31 -56 -1 -55 -2 11
    -19 31 -8 42 -16 42 -30 0 -23 -24 -26 -80 -10 -57 16 -67 26 -52 50 7 12 8
    20 2 20 -14 0 -12 27 3 34 17 8 94 -2 118 -14z m-5613 -2 c23 -23 12 -35 -53
    -57 -79 -25 -91 -26 -99 -4 -10 24 21 50 74 61 62 14 64 14 78 0z m1758 -19
    c60 -34 66 -49 30 -72 -61 -41 -126 -24 -126 31 0 26 24 72 37 72 3 0 30 -14
    59 -31z m1719 0 c15 -28 15 -32 0 -50 -10 -10 -33 -23 -52 -30 -35 -11 -35
    -12 -30 -56 4 -36 1 -49 -14 -64 -22 -22 -40 -24 -57 -7 -17 17 -15 73 3 88 8
    7 15 23 15 36 0 25 83 113 107 114 7 0 20 -14 28 -31z m1763 15 c42 -9 17 -29
    -39 -32 -60 -2 -85 8 -76 32 6 16 37 16 115 0z m-4201 -10 c2 -5 -26 -38 -62
    -74 -62 -62 -65 -63 -84 -46 -22 20 -47 74 -38 83 9 9 160 52 171 49 6 -1 11
    -7 13 -12z m2138 6 c14 -5 23 -15 20 -20 -10 -16 -82 -60 -98 -60 -12 0 -37
    52 -37 78 0 15 78 16 115 2z m129 -6 c16 -42 -2 -124 -28 -124 -13 0 -64 87
    -55 94 2 1 17 12 33 24 34 26 42 27 50 6z m1377 -5 c12 -19 11 -25 -7 -43 -18
    -18 -104 -22 -135 -6 -22 12 -25 40 -6 59 16 17 136 9 148 -10z m-2101 -14
    c119 -29 142 -41 160 -84 10 -26 10 -35 -4 -56 -30 -46 -75 -24 -117 58 -24
    46 -43 47 -69 5 -30 -49 -25 -67 8 -35 15 15 32 27 38 27 11 -1 64 -86 64
    -105 0 -8 -13 -21 -29 -30 -49 -25 -49 -38 -2 -30 40 7 42 6 56 -27 l14 -33 1
    45 c0 54 22 90 55 90 25 0 33 -19 50 -113 8 -48 -14 -87 -50 -87 -13 0 -49 -9
    -80 -21 -86 -32 -96 -27 -116 56 -20 88 -72 212 -115 277 -19 28 -34 59 -34
    69 0 26 40 25 170 -6z m1188 3 c15 -13 16 -131 2 -159 -11 -20 -45 -26 -55 -9
    -4 6 -24 22 -46 36 -43 27 -48 47 -23 97 28 54 35 59 73 52 20 -4 42 -11 49
    -17z m179 -15 c3 -8 -2 -21 -10 -31 -8 -9 -25 -41 -37 -71 -27 -70 -57 -111
    -79 -111 -25 0 -32 10 -21 30 5 9 14 57 20 106 6 48 15 93 21 100 12 15 99 -4
    106 -23z m1803 26 c63 -14 62 -35 -2 -32 -50 1 -92 19 -83 34 8 12 23 11 85
    -2z m-3420 -24 c0 -8 -5 -17 -11 -21 -16 -9 -30 18 -17 33 12 15 28 8 28 -12z
    m2491 15 c23 -13 25 -55 3 -64 -46 -18 -114 8 -98 37 23 39 55 48 95 27z
    m-5016 -40 c0 -20 -7 -26 -45 -37 -60 -18 -114 -13 -118 10 -5 24 71 58 123
    55 35 -3 40 -6 40 -28z m292 6 c-4 -13 -105 -51 -164 -61 -36 -6 -43 -4 -43 9
    0 9 8 19 18 22 9 3 25 10 34 15 10 5 28 9 40 10 13 0 39 6 58 13 38 14 63 10
    57 -8z m288 14 c23 -37 -46 -80 -142 -88 -62 -5 -63 -4 -63 21 0 31 7 36 85
    58 69 20 111 23 120 9z m751 -4 c17 -14 18 -17 4 -41 -8 -15 -27 -34 -42 -43
    -27 -16 -29 -15 -49 5 -23 23 -18 43 11 43 11 0 20 10 24 25 7 28 23 32 52 11z
    m299 -10 c15 -22 15 -27 1 -54 -15 -28 -60 -72 -75 -72 -10 0 -41 67 -41 87 0
    9 10 27 22 40 29 31 73 30 93 -1z m785 18 c36 -8 48 -28 32 -54 -8 -13 -8 -66
    0 -191 9 -157 13 -176 31 -191 21 -16 21 -17 3 -60 -29 -70 -31 -72 -72 -80
    -23 -5 -48 -19 -61 -35 -26 -32 -49 -25 -56 19 -20 110 -45 567 -33 587 8 12
    104 15 156 5z m2817 -11 c20 -8 16 -31 -8 -44 -32 -17 -119 -6 -136 17 -22 31
    9 47 76 39 30 -4 60 -9 68 -12z m360 11 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6
    11 1 17 -2 13 -5z m-3437 -16 c0 -7 -11 -40 -24 -73 -19 -46 -30 -61 -48 -63
    -31 -4 -57 17 -64 53 -5 29 -2 32 58 62 72 36 78 38 78 21z m2072 -5 c7 -29
    -10 -200 -22 -222 -6 -12 -18 -21 -28 -21 -28 0 -91 20 -97 31 -6 8 81 184
    108 217 14 17 34 15 39 -5z m1172 11 c22 -8 20 -41 -3 -54 -27 -14 -94 -13
    -109 2 -19 19 -14 38 11 48 26 10 79 13 101 4z m744 -6 c-6 -18 -28 -21 -28
    -4 0 9 7 16 16 16 9 0 14 -5 12 -12z m-1676 -16 c6 -6 13 -69 16 -146 4 -121
    3 -136 -12 -142 -21 -8 -102 14 -117 32 -12 15 2 71 42 161 12 29 20 56 16 59
    -14 15 -37 -21 -63 -99 -32 -98 -40 -109 -73 -105 -34 4 -38 39 -17 149 21
    110 23 112 119 107 43 -3 83 -10 89 -16z m1914 7 c10 -17 -16 -29 -61 -28 -52
    1 -87 11 -93 27 -5 16 144 17 154 1z m-6588 -31 c4 -37 -5 -40 -236 -79 -140
    -23 -196 -29 -204 -21 -33 33 52 71 182 79 47 3 91 10 98 16 16 13 111 36 137
    34 14 -1 21 -11 23 -29z m1192 22 c11 -6 33 -30 50 -55 24 -35 29 -49 21 -63
    -15 -28 -59 -54 -81 -47 -22 7 -102 123 -97 139 5 14 47 36 70 36 10 0 27 -5
    37 -10z m4598 -13 c15 -16 15 -18 0 -33 -13 -13 -26 -15 -61 -10 -56 9 -83 27
    -73 51 5 15 15 17 62 13 33 -3 62 -11 72 -21z m379 12 c21 -21 2 -39 -42 -39
    -43 0 -73 19 -60 40 8 14 88 13 102 -1z m569 0 c8 -14 -14 -29 -44 -29 -30 0
    -64 18 -57 31 9 13 92 11 101 -2z m-3978 -29 c3 -37 -12 -57 -32 -41 -13 11
    -14 6 -9 -43 4 -39 2 -60 -8 -72 -12 -14 -14 -14 -26 2 -15 21 -17 121 -3 159
    8 22 15 26 42 23 27 -2 33 -8 36 -28z m-695 -8 c26 -23 21 -38 -18 -56 -44
    -21 -56 -14 -48 27 11 58 24 64 66 29z m1881 7 c44 -35 31 -66 -42 -103 -18
    -10 -41 -14 -52 -11 -23 7 -38 79 -20 100 10 12 52 30 81 34 4 1 18 -8 33 -20z
    m980 7 c35 -15 48 -39 62 -119 6 -33 3 -42 -22 -69 -45 -48 -105 -88 -131 -88
    -31 0 -30 31 2 133 28 88 31 117 11 117 -9 0 -19 -28 -31 -87 -9 -49 -20 -104
    -24 -123 -5 -29 -11 -35 -31 -35 -31 0 -37 25 -39 157 -1 122 4 128 100 128
    38 0 85 -6 103 -14z m1385 5 c20 -13 4 -50 -25 -57 -29 -7 -64 19 -64 48 0 14
    8 18 38 18 20 0 43 -4 51 -9z m-5779 -30 c0 -27 -4 -30 -82 -56 l-83 -26 -14
    21 c-14 21 -14 21 -27 -8 -9 -23 -24 -34 -66 -47 -29 -10 -66 -24 -82 -32 -24
    -13 -31 -13 -42 -1 -11 11 -12 21 -3 46 9 26 19 34 52 42 23 6 55 15 71 20 16
    6 42 10 58 10 16 0 31 6 34 15 4 8 16 15 28 16 11 0 41 6 66 13 76 22 90 20
    90 -13z m1420 10 c15 -30 12 -66 -9 -92 l-18 -23 -46 30 c-26 16 -46 33 -47
    38 0 6 12 23 27 38 32 33 77 38 93 9z m4050 3 c48 -8 93 -20 100 -25 47 -30
    -104 -34 -219 -5 -30 7 -47 17 -49 29 -3 14 4 17 40 17 24 0 81 -7 128 -16z
    m467 -11 c24 -32 -12 -60 -61 -47 -29 7 -49 34 -38 51 18 26 77 24 99 -4z
    m482 18 c7 -5 10 -14 7 -20 -10 -16 -43 -14 -49 3 -10 25 14 34 42 17z m-6720
    -10 c24 -15 -3 -37 -72 -60 -83 -28 -136 -31 -150 -9 -6 9 -8 20 -4 24 6 6
    178 50 207 53 3 0 11 -3 19 -8z m815 -18 c8 -16 33 -49 56 -76 24 -27 40 -54
    37 -62 -7 -17 -197 -79 -208 -68 -15 15 13 195 33 215 27 27 65 23 82 -9z
    m2218 5 c33 -12 63 -28 66 -36 6 -17 -61 -82 -84 -82 -16 0 -64 90 -64 120 0
    25 9 25 82 -2z m3788 6 c0 -10 -7 -14 -22 -12 -32 5 -35 28 -4 28 17 0 26 -5
    26 -16z m-1916 0 c24 -9 19 -53 -13 -109 -33 -58 -58 -82 -70 -69 -12 13 -48
    157 -43 172 4 13 97 17 126 6z m1591 -3 c26 -5 30 -10 30 -41 0 -28 -5 -36
    -26 -44 -41 -14 -79 0 -91 35 l-10 30 -24 -26 c-27 -29 -41 -31 -72 -9 -25 17
    -28 34 -10 52 13 13 149 15 203 3z m-5824 -28 c13 -32 1 -116 -25 -177 -13
    -32 -19 -37 -43 -34 -22 2 -33 13 -52 52 -15 30 -25 68 -25 95 -1 48 6 55 79
    79 47 16 55 14 66 -15z m4434 13 c18 -13 17 -17 -24 -110 -33 -71 -49 -96 -62
    -96 -12 0 -19 7 -19 20 0 12 -7 34 -15 49 -26 50 -30 109 -10 131 22 24 101
    28 130 6z m1821 3 c8 -14 -14 -29 -33 -22 -7 3 -13 11 -13 19 0 17 36 19 46 3z
    m101 -5 c9 -25 -11 -38 -36 -22 -11 7 -21 18 -21 25 0 19 50 16 57 -3z m89
    -60 c5 -45 3 -59 -10 -72 -19 -19 -62 -8 -80 21 -9 15 -6 22 17 42 15 13 27
    30 27 38 0 16 21 38 31 31 4 -2 11 -29 15 -60z m-5906 36 c22 -22 26 -51 10
    -81 -15 -27 -29 -24 -67 13 -39 38 -41 51 -11 72 30 21 44 20 68 -4z m750 8
    c0 -7 -13 -44 -28 -83 -26 -62 -32 -70 -58 -73 -37 -3 -94 31 -94 57 0 13 24
    33 78 64 82 48 102 55 102 35z m3385 2 c4 -6 2 -17 -4 -24 -6 -7 -12 -71 -13
    -147 -3 -134 -3 -134 -28 -137 -13 -2 -41 1 -62 7 -46 14 -47 22 -14 128 14
    43 29 96 35 119 13 49 68 83 86 54z m1335 -9 c22 -42 -21 -72 -76 -54 -67 22
    -52 73 22 73 33 0 46 -5 54 -19z m540 4 c17 -20 4 -35 -30 -35 -32 0 -45 13
    -36 35 7 19 50 19 66 0z m111 5 c38 -21 12 -79 -31 -65 -11 3 -25 16 -31 27
    -9 18 -8 24 7 35 22 16 29 16 55 3z m-5846 -10 c15 -24 -8 -72 -47 -100 -44
    -32 -58 -31 -58 3 1 32 22 65 56 88 33 22 40 23 49 9z m3739 -6 c7 -17 -27
    -179 -49 -230 -13 -32 -17 -34 -63 -34 -80 0 -82 11 -16 142 31 62 61 119 66
    126 15 17 55 15 62 -4z m1589 7 c58 -22 33 -71 -37 -71 -67 0 -89 47 -34 70
    30 12 42 12 71 1z m-1303 -17 c5 -5 -15 -63 -45 -129 -30 -66 -55 -126 -55
    -132 0 -36 26 -1 75 100 31 63 65 124 77 137 19 20 22 21 33 7 12 -17 30 -272
    19 -288 -7 -12 -160 -11 -206 1 -47 14 -52 35 -43 197 l8 126 64 -6 c36 -3 69
    -9 73 -13z m-6240 -9 c19 -23 -2 -41 -67 -54 -81 -16 -103 -15 -103 7 0 19 24
    45 50 55 32 12 108 7 120 -8z m466 4 c14 -23 -24 -42 -95 -47 -66 -4 -71 -3
    -71 15 0 11 10 25 23 31 29 14 134 15 143 1z m760 -89 c21 -64 29 -100 23
    -112 -13 -23 -87 -34 -106 -15 -16 16 -42 122 -43 175 0 36 24 53 70 49 22 -2
    28 -13 56 -97z m3325 90 c25 -14 24 -32 -5 -59 -33 -31 -70 -25 -74 12 -6 49
    32 72 79 47z m3156 -11 c7 -6 13 -22 13 -34 0 -27 -32 -38 -75 -27 -34 9 -45
    43 -24 68 14 17 61 13 86 -7z m472 7 c15 -18 4 -46 -19 -46 -23 0 -44 26 -36
    45 7 19 40 20 55 1z m-1683 -10 c8 -20 -35 -277 -48 -293 -19 -23 -39 -14 -55
    25 -21 49 -24 241 -4 265 17 22 99 24 107 3z m118 6 c6 -10 -19 -162 -35 -209
    -5 -17 -17 -37 -26 -44 -8 -7 -19 -23 -24 -36 -12 -31 -39 -30 -39 1 0 42 49
    267 61 282 12 15 55 19 63 6z m129 1 c21 -3 41 -12 44 -20 11 -27 -63 -163
    -88 -163 -4 0 -11 10 -15 23 -4 12 -15 33 -25 46 -19 23 -27 100 -12 114 8 9
    46 9 96 0z m-4362 -39 c17 -21 -12 -49 -68 -65 -42 -11 -47 -11 -59 6 -26 35
    -17 62 23 78 40 16 81 8 104 -19z m5893 25 c49 -23 34 -66 -19 -53 -29 7 -40
    25 -31 49 7 18 17 19 50 4z m-8479 -40 c0 -19 -8 -26 -45 -36 -25 -8 -63 -12
    -85 -11 -33 3 -41 7 -43 25 -4 25 20 39 93 52 53 10 80 0 80 -30z m456 25 c11
    -14 10 -19 -10 -35 -12 -10 -39 -21 -59 -24 -20 -3 -54 -11 -75 -17 -42 -13
    -70 -4 -75 25 -4 21 26 36 106 52 90 18 97 18 113 -1z m2514 2 c41 -17 44 -41
    20 -124 -27 -90 -58 -80 -43 15 5 31 7 57 5 60 -6 5 -38 -85 -44 -125 -6 -39
    -28 -51 -51 -29 -14 15 -14 23 8 93 21 67 52 124 66 124 3 0 20 -7 39 -14z
    m1218 -10 c30 -13 57 -28 61 -34 6 -10 -62 -120 -89 -142 -23 -19 -32 -5 -39
    62 -4 35 -10 80 -13 101 -7 45 3 47 80 13z m2889 -17 c26 -53 22 -69 -37 -143
    -30 -38 -55 -70 -55 -72 0 -14 25 4 74 54 l57 57 19 -23 c25 -30 19 -41 -54
    -110 -70 -66 -92 -66 -123 -2 -27 54 -29 77 -7 82 11 2 22 22 31 57 20 78 51
    143 65 139 7 -3 21 -20 30 -39z m159 30 c26 -13 12 -32 -45 -61 l-40 -20 -18
    22 c-18 23 -23 51 -11 63 10 11 92 8 114 -4z m-5972 -17 c5 -10 16 -52 24 -95
    12 -63 12 -79 1 -95 -16 -23 -121 -49 -136 -34 -8 8 -8 43 -1 113 8 80 14 105
    29 116 26 19 71 16 83 -5z m1011 -3 c14 -24 6 -65 -13 -72 -20 -8 -77 20 -77
    38 0 53 67 78 90 34z m1806 -13 c7 -42 10 -104 3 -109 -8 -7 -116 -57 -122
    -57 -3 0 -11 17 -17 39 -14 54 2 95 54 131 55 39 74 38 82 -4z m3232 -7 c13
    -98 28 -112 87 -84 l30 15 -37 -5 c-34 -5 -37 -4 -43 24 -11 51 1 71 44 71 49
    0 66 -20 81 -93 17 -82 13 -87 -65 -87 -52 0 -69 4 -85 20 -11 11 -25 20 -30
    20 -13 0 -50 60 -50 81 0 22 39 71 54 66 6 -2 12 -14 14 -28z m1316 21 c44
    -17 58 -80 17 -80 -23 0 -80 37 -88 56 -11 29 26 41 71 24z m-7830 -16 c13
    -33 -13 -45 -88 -42 -55 2 -71 7 -74 19 -4 23 34 38 99 38 44 1 58 -3 63 -15z
    m320 0 c3 -9 6 -58 6 -109 0 -51 -3 -100 -6 -109 -8 -21 -27 -20 -46 2 -22 25
    -80 171 -73 182 9 14 77 49 96 50 9 0 20 -7 23 -16z m940 -3 c10 -11 20 -38
    23 -60 5 -33 2 -42 -13 -48 -13 -5 -23 1 -38 22 -12 15 -31 39 -43 53 -13 14
    -23 28 -23 32 0 27 70 27 94 1z m2486 0 c5 -11 10 -38 10 -61 0 -85 -37 -104
    -89 -45 -47 54 -41 104 14 118 40 9 54 7 65 -12z m104 -6 c22 -33 20 -62 -4
    -75 -33 -18 -60 4 -60 49 0 21 3 41 7 44 14 15 41 6 57 -18z m3561 15 c4 -6
    -1 -22 -10 -37 -14 -21 -22 -24 -48 -19 -39 8 -62 29 -54 50 7 19 101 23 112
    6z m-8427 -33 c3 -23 -2 -30 -30 -41 -43 -18 -176 -41 -185 -33 -3 4 2 23 13
    42 19 36 49 46 71 24 9 -9 20 -5 44 15 42 36 83 33 87 -7z m5065 22 c12 -7 37
    -25 55 -40 22 -20 44 -29 67 -29 41 0 44 -9 13 -37 -50 -45 -90 -54 -120 -26
    -19 17 -25 53 -8 53 6 0 10 5 10 10 0 16 -18 12 -61 -16 -46 -29 -69 -21 -69
    24 0 55 62 88 113 61z m2755 -1 c28 -28 1 -78 -44 -78 -24 0 -64 31 -64 49 0
    34 81 56 108 29z m736 2 c20 -7 26 -17 26 -39 0 -36 -20 -45 -71 -31 -56 15
    -72 56 -29 73 23 9 46 8 74 -3z m-8155 -9 c26 -17 2 -40 -65 -60 -78 -25 -88
    -25 -102 -8 -19 22 4 39 75 58 84 21 75 20 92 10z m5723 -65 c39 -95 38 -96
    -26 -96 -102 0 -141 37 -93 88 13 15 32 40 42 55 10 15 25 27 33 25 9 -2 28
    -34 44 -72z m2843 58 c9 -9 15 -28 13 -43 -4 -35 -37 -35 -57 0 -26 47 7 79
    44 43z m-8165 -9 c20 -24 -1 -38 -66 -43 -50 -4 -56 -3 -52 14 7 38 93 59 118
    29z m2080 -7 c0 -24 -26 -58 -45 -58 -17 0 -35 24 -27 36 9 12 54 43 65 43 4
    1 7 -9 7 -21z m5099 8 c15 -18 -4 -63 -31 -72 -23 -7 -75 4 -84 17 -10 17 5
    57 24 62 36 10 80 6 91 -7z m-5808 -28 c6 -13 23 -36 38 -51 l26 -29 -28 -24
    c-51 -43 -107 -25 -107 34 0 32 29 92 45 92 8 0 20 -10 26 -22z m5949 9 c32
    -16 48 -60 30 -81 -13 -16 -74 -21 -117 -10 -19 5 -23 13 -23 48 0 24 3 46 7
    49 11 11 76 8 103 -6z m618 2 c62 -15 69 -23 52 -55 -13 -24 -19 -26 -57 -20
    -73 10 -113 31 -113 60 0 23 4 26 36 26 19 0 56 -5 82 -11z m-8988 -13 c0 -19
    -27 -46 -46 -46 -17 0 -19 31 -2 48 17 17 48 15 48 -2z m888 -8 c7 -35 -104
    -65 -115 -31 -6 17 57 54 87 51 14 -2 26 -10 28 -20z m545 4 c19 -21 67 -144
    67 -171 0 -24 -23 -33 -43 -18 -41 34 -113 168 -103 193 8 20 60 17 79 -4z
    m1466 4 c15 -18 -9 -70 -39 -86 -52 -28 -82 41 -34 79 31 24 57 27 73 7z
    m1884 -29 c21 -41 33 -174 19 -196 -6 -8 -17 -11 -26 -8 -18 7 -59 67 -80 117
    -14 34 -13 37 17 83 17 26 36 46 41 44 6 -2 19 -20 29 -40z m4549 -15 c11 -30
    16 -58 11 -63 -7 -7 -183 11 -250 26 -26 6 -31 36 -8 55 12 10 23 9 55 -4 22
    -9 61 -16 85 -16 40 0 45 2 45 23 0 59 37 46 62 -21z m-8905 33 c9 -25 -26
    -54 -84 -71 -53 -15 -83 -14 -83 5 0 23 40 54 85 66 66 18 75 18 82 0z m2227
    -7 c27 -38 19 -108 -12 -108 -25 0 -62 41 -62 68 0 28 26 62 46 62 7 0 20 -10
    28 -22z m5050 -9 c33 -38 33 -57 1 -65 -22 -5 -25 -12 -25 -48 0 -79 -11 -116
    -35 -122 -27 -7 -85 21 -85 39 0 7 13 26 30 42 45 43 62 86 49 124 -22 64 20
    84 65 30z m882 11 c28 -11 31 -35 7 -49 -10 -5 -15 -12 -12 -15 3 -4 27 5 53
    20 70 39 119 19 96 -40 -13 -36 -45 -49 -99 -41 -90 13 -166 36 -183 57 -18
    21 -24 68 -10 82 8 9 113 -1 148 -14z m-7848 -16 c3 -24 -21 -37 -102 -54 -39
    -9 -52 -8 -63 3 -20 20 14 47 79 63 67 16 82 14 86 -12z m624 -74 c44 -70 57
    -99 50 -110 -5 -8 -38 -23 -72 -34 -58 -17 -64 -17 -75 -3 -10 14 -34 138 -39
    201 -1 21 38 48 63 43 7 -1 40 -45 73 -97z m1882 71 c16 -9 31 -22 34 -29 5
    -17 -44 -34 -92 -30 -47 3 -57 24 -31 64 18 27 35 26 89 -5z m2950 -2 c16 -47
    3 -59 -64 -59 -72 0 -77 13 -24 60 43 37 75 37 88 -1z m-6291 7 c8 -20 -8 -31
    -82 -55 -76 -25 -110 -27 -117 -6 -11 28 16 47 57 40 23 -4 40 -2 44 5 17 28
    89 39 98 16z m3982 -16 c0 -13 -6 -25 -12 -27 -16 -6 -27 21 -19 43 9 23 31
    11 31 -16z m1785 -2 c97 -25 122 -41 118 -76 -4 -34 -9 -34 -143 23 -118 49
    -131 57 -121 74 8 12 39 7 146 -21z m3756 -15 c14 -32 34 -37 34 -8 0 39 35
    27 110 -40 28 -25 56 -45 62 -45 19 0 78 -50 78 -67 0 -12 -7 -14 -37 -10 -47
    8 -35 -5 53 -52 75 -40 98 -74 109 -151 9 -74 -6 -82 -62 -32 -26 23 -74 61
    -106 84 -51 38 -57 45 -52 69 4 15 1 30 -4 34 -18 10 -13 53 7 57 28 6 -56 45
    -136 63 -38 9 -76 24 -84 33 -18 22 -41 89 -34 101 12 18 49 -3 62 -36z
    m-6652 -14 c14 -21 26 -42 26 -47 0 -15 -56 -62 -73 -62 -29 0 -43 113 -18
    144 17 21 35 11 65 -35z m4579 -29 c21 -44 35 -85 32 -90 -8 -13 -86 -13 -119
    0 l-26 10 20 37 c11 21 20 45 20 55 0 23 18 68 27 68 5 0 25 -36 46 -80z
    m-6169 51 c9 -10 23 -49 31 -87 9 -38 18 -82 22 -98 7 -31 -7 -46 -44 -46 -31
    0 -49 32 -75 132 -19 72 -20 88 -9 102 18 21 54 20 75 -3z m-960 3 c9 -3 16
    -12 16 -20 0 -22 -42 -43 -103 -50 -65 -8 -70 -1 -35 46 18 25 29 30 64 30 23
    0 49 -3 58 -6z m812 -11 c3 -10 22 -50 41 -89 39 -80 52 -144 32 -160 -8 -6
    -36 -17 -62 -24 -69 -18 -72 -12 -72 129 0 103 3 122 19 140 23 26 35 27 42 4z
    m1144 7 c0 -15 -37 -35 -125 -70 -44 -18 -86 -36 -92 -42 -18 -14 -43 -2 -43
    20 0 28 16 37 100 60 41 11 86 25 100 31 33 13 60 13 60 1z m820 0 c0 -24 -51
    -110 -65 -110 -24 0 -19 69 7 97 22 23 58 31 58 13z m90 -10 c10 -18 7 -63 -7
    -112 -5 -20 -34 -23 -64 -8 -31 17 -23 75 19 123 20 23 39 22 52 -3z m1832
    -33 c12 -23 -4 -67 -34 -94 -19 -17 -20 -17 -34 2 -14 19 -20 126 -8 138 9 9
    64 -24 76 -46z m247 43 c21 -11 55 -86 46 -101 -10 -14 -45 -10 -115 14 -40
    14 -65 29 -65 37 0 15 78 60 103 60 7 0 21 -4 31 -10z m2885 -9 c18 -20 10
    -33 -30 -45 -26 -8 -57 24 -48 48 8 22 57 21 78 -3z m-7533 -14 c-13 -13 -26
    -3 -16 12 3 6 11 8 17 5 6 -4 6 -10 -1 -17z m4790 -29 c9 -37 9 -44 -8 -55
    -10 -8 -29 -13 -43 -11 -37 4 -40 58 -6 93 32 32 42 27 57 -27z m3610 27 c31
    -16 39 -51 17 -73 -13 -13 -107 -15 -148 -3 -20 6 -25 13 -24 39 3 61 9 65 70
    58 31 -3 69 -13 85 -21z m-9245 1 c18 -14 18 -15 -9 -25 -36 -14 -84 -14 -92
    -1 -21 33 62 54 101 26z m362 -7 c5 -27 -31 -59 -83 -72 -39 -10 -50 -17 -55
    -37 -4 -17 -15 -27 -35 -32 -73 -17 -204 -38 -240 -38 -35 1 -38 2 -23 14 10
    7 66 25 125 40 129 32 153 46 153 86 0 26 5 30 43 40 23 6 47 13 52 15 22 9
    60 -1 63 -16z m895 -39 c4 -30 6 -93 5 -140 -3 -71 -6 -85 -20 -88 -14 -3 -28
    19 -63 95 -56 118 -56 150 -5 176 58 29 74 21 83 -43z m4587 45 c18 -21 -13
    -83 -48 -96 -33 -13 -102 5 -102 26 0 16 96 83 121 84 9 1 22 -6 29 -14z
    m2684 9 c29 -11 5 -24 -45 -24 -68 0 -65 27 3 29 14 1 33 -2 42 -5z m-5890
    -26 c24 -33 20 -57 -11 -69 -38 -14 -58 -7 -58 20 0 14 -6 26 -13 29 -16 5
    -16 29 1 35 30 13 67 6 81 -15z m-1869 -8 c0 -16 -28 -25 -52 -16 -12 5 -13 9
    -3 22 16 18 55 15 55 -6z m3481 -16 c8 -43 -3 -205 -15 -217 -4 -4 -13 -1 -20
    7 -9 10 -9 30 -1 77 5 35 10 88 10 117 0 60 16 70 26 16z m621 28 c17 -11 26
    -93 13 -127 -13 -35 -26 -45 -62 -45 -22 0 -29 7 -42 43 -32 90 -32 92 24 119
    40 19 50 21 67 10z m-5017 -10 c0 -15 -24 -32 -47 -32 -24 0 -32 25 -10 33 20
    9 57 8 57 -1z m6407 -14 c28 -31 37 -73 18 -88 -11 -9 -25 -8 -63 4 -66 22
    -89 48 -74 81 10 21 18 25 55 25 32 0 49 -6 64 -22z m3153 16 c38 -8 47 -27
    30 -60 -11 -19 -21 -24 -54 -24 -54 0 -86 22 -86 61 0 27 3 29 39 29 21 0 53
    -3 71 -6z m-9681 -18 c17 -20 -25 -47 -84 -54 -36 -4 -46 -1 -51 12 -9 22 6
    36 48 46 52 12 75 11 87 -4z m438 -3 c8 -19 -29 -53 -58 -53 -30 0 -36 30 -10
    52 29 22 60 23 68 1z m492 8 c8 -5 11 -16 8 -24 -9 -24 -197 -51 -197 -27 0
    14 39 33 100 46 69 15 72 16 89 5z m2232 -1 c23 -13 26 -62 3 -81 -13 -11 -21
    -10 -50 6 -38 20 -52 49 -34 70 14 17 53 19 81 5z m1819 -5 c6 -8 14 -31 17
    -53 5 -34 2 -39 -21 -50 -44 -20 -63 -15 -75 19 -15 44 -14 56 9 79 24 24 53
    26 70 5z m1226 0 c8 -21 -15 -75 -32 -75 -7 0 -21 11 -29 24 -13 19 -14 29 -5
    45 13 25 58 28 66 6z m2768 -6 c8 -12 12 -28 9 -35 -8 -22 21 -16 35 6 25 41
    93 20 117 -37 22 -53 21 -55 -42 -48 -210 24 -258 49 -223 116 15 28 84 27
    104 -2z m-7644 -38 c0 -51 -19 -111 -36 -118 -30 -11 -111 88 -98 121 8 20 94
    47 122 38 6 -2 12 -20 12 -41z m2147 -32 c-7 -78 -20 -109 -46 -109 -24 0 -39
    19 -47 56 -5 24 2 39 37 81 23 29 46 50 52 46 6 -3 7 -34 4 -74z m3258 61 c22
    -18 19 -28 -19 -66 -34 -34 -75 -44 -104 -25 -17 10 -41 81 -34 99 6 18 134
    11 157 -8z m1643 -3 c5 -23 -35 -67 -60 -67 -14 0 -18 8 -18 38 0 47 6 54 45
    50 20 -2 31 -9 33 -21z m1457 -12 c0 -23 -7 -33 -28 -43 -36 -18 -77 -8 -77
    17 0 27 48 63 79 59 21 -2 26 -8 26 -33z m-10000 15 c9 -15 -21 -59 -50 -72
    -48 -22 -76 36 -33 66 26 18 74 21 83 6z m486 -8 c31 -26 19 -48 -31 -62 -56
    -15 -74 -10 -78 22 -6 50 64 76 109 40z m839 8 c0 -13 -46 -24 -67 -16 -15 6
    -15 8 -3 16 20 13 70 13 70 0z m1615 -14 c14 -14 22 -31 19 -40 -7 -18 -65
    -39 -96 -34 -51 7 -21 98 32 98 12 0 32 -11 45 -24z m1055 7 c0 -32 -44 -98
    -68 -101 -23 -4 -29 -16 -12 -27 16 -10 12 -42 -10 -86 -18 -34 -23 -38 -40
    -29 -42 23 -51 74 -21 124 10 17 22 48 25 68 9 52 29 68 82 68 35 0 44 -3 44
    -17z m1439 -36 c13 -38 8 -58 -27 -104 -40 -53 -52 -44 -52 40 0 85 18 124 50
    107 10 -5 23 -25 29 -43z m1572 42 c11 -6 30 -31 42 -57 l21 -47 5 40 6 40 50
    0 50 0 3 -38 c4 -43 25 -46 30 -4 5 44 23 50 104 37 131 -21 145 -27 157 -63
    5 -17 11 -41 12 -52 4 -48 4 -48 -92 -43 -117 7 -128 18 -69 68 64 55 43 60
    -31 9 l-62 -44 -90 2 c-94 2 -232 27 -243 44 -3 6 1 18 10 27 8 10 22 34 31
    55 16 38 32 45 66 26z m1677 -15 c16 -10 22 -24 22 -49 0 -48 18 -82 57 -105
    18 -10 33 -24 33 -30 0 -17 -62 -10 -120 14 -59 24 -59 23 -45 101 9 51 -8 38
    -27 -20 -13 -40 -14 -40 -67 -43 -100 -6 -131 15 -63 43 20 9 58 38 85 66 50
    55 70 58 125 23z m300 14 c17 -17 15 -36 -6 -47 -20 -10 -135 9 -169 28 -16 9
    -16 11 7 20 36 14 153 14 168 -1z m1155 -18 c8 0 25 -8 37 -18 20 -16 21 -21
    11 -41 -12 -21 -17 -22 -84 -15 -95 9 -100 13 -65 69 20 31 30 35 59 19 16 -8
    34 -14 42 -14z m-7496 -2 c13 -12 23 -27 23 -34 0 -15 -154 -94 -183 -94 -26
    0 -87 57 -87 81 0 41 76 25 86 -18 4 -13 10 -23 15 -23 16 0 22 30 9 45 -20
    24 -4 43 42 53 64 15 70 14 95 -10z m1531 -3 c16 -35 15 -77 -2 -100 -12 -17
    -17 -18 -41 -7 -25 12 -27 16 -21 54 13 77 42 102 64 53z m-4305 1 c8 -21 -17
    -61 -41 -64 -28 -4 -39 21 -24 54 13 27 56 34 65 10z m473 -1 c13 -34 -6 -65
    -57 -91 -59 -29 -79 -26 -79 13 0 34 24 71 54 83 34 14 76 11 82 -5z m3732 3
    c16 -16 15 -61 -2 -103 -16 -39 -47 -46 -81 -21 -19 14 -19 15 4 63 38 76 52
    88 79 61z m959 0 c6 -7 13 -38 17 -70 3 -31 8 -63 11 -70 4 -10 -12 -26 -45
    -46 -80 -50 -82 -48 -95 70 -8 74 0 97 38 113 40 18 62 18 74 3z m782 -12 c12
    -12 13 -21 5 -33 -21 -33 -42 -39 -74 -19 -42 24 -48 14 -13 -18 37 -35 73
    -44 85 -22 16 28 52 65 67 68 12 2 15 -12 17 -69 2 -65 0 -74 -19 -88 -53 -37
    -127 -26 -127 19 0 12 -3 25 -6 29 -4 3 -33 -8 -66 -24 -33 -17 -66 -28 -74
    -25 -21 8 -17 69 6 98 10 14 33 31 50 38 16 7 30 20 30 29 0 9 6 23 13 30 16
    16 84 8 106 -13z m-4931 -3 c6 -19 -43 -34 -117 -36 -60 -2 -66 0 -66 18 0 17
    9 21 50 26 74 9 128 6 133 -8z m5588 3 c10 -26 -45 -106 -73 -106 -19 0 -17
    70 3 98 17 25 62 30 70 8z m2938 -2 c10 -4 16 -18 16 -36 0 -16 5 -38 10 -49
    14 -25 -11 -36 -48 -23 -29 10 -59 72 -49 99 6 15 42 20 71 9z m145 -5 c34
    -12 41 -38 16 -59 -18 -15 -20 -30 -3 -30 7 0 28 19 48 41 29 34 40 40 58 35
    19 -6 21 -12 15 -51 -5 -40 -3 -45 18 -53 75 -29 92 -31 139 -20 43 10 56 8
    151 -25 123 -42 201 -74 250 -103 20 -12 51 -25 68 -29 34 -7 71 -47 71 -76 0
    -24 18 -33 35 -19 12 10 18 10 30 0 24 -20 17 -40 -20 -56 -48 -20 -69 -18
    -116 12 -38 24 -40 27 -25 43 18 20 21 41 6 41 -5 0 -13 -7 -18 -16 -7 -13
    -17 -15 -46 -10 -44 8 -53 26 -32 58 15 23 13 38 -4 38 -4 0 -12 -11 -18 -25
    -15 -32 -48 -33 -93 -2 -26 18 -34 30 -32 50 2 27 -10 36 -22 17 -10 -16 -45
    -12 -104 11 -30 11 -139 40 -242 64 -104 24 -198 49 -210 56 l-23 12 21 16
    c18 15 19 19 5 39 -30 45 7 65 77 41z m-9801 -21 c-2 -13 -19 -33 -40 -47 -21
    -13 -36 -26 -34 -28 6 -6 222 33 353 64 95 22 114 24 128 13 19 -16 14 -68 -8
    -82 -25 -16 -83 -9 -103 13 l-19 21 -22 -28 c-19 -25 -30 -28 -105 -35 -187
    -17 -392 -30 -405 -25 -23 9 -15 56 16 87 45 45 106 37 81 -11 -14 -26 -6 -40
    21 -33 12 3 18 11 15 19 -15 40 39 93 97 94 24 0 28 -4 25 -22z m1542 -11 c0
    -44 -59 -161 -83 -165 -19 -4 -37 13 -63 61 -14 27 -14 31 13 72 31 49 53 63
    101 64 30 1 32 -1 32 -32z m1504 -14 c-1 -69 -46 -98 -78 -51 -24 34 -19 56
    17 78 47 29 62 23 61 -27z m347 37 c10 -6 19 -18 19 -26 0 -24 -29 -74 -44
    -74 -20 0 -108 70 -103 83 3 10 38 19 95 26 7 0 22 -4 33 -9z m300 0 c29 -16
    24 -25 -31 -59 -72 -44 -96 -40 -69 12 29 55 58 69 100 47z m5401 -17 c10 -9
    16 -23 13 -30 -3 -7 -8 -20 -11 -28 -11 -26 26 -17 38 9 13 30 31 38 63 30 32
    -8 38 -29 19 -66 -23 -45 -10 -45 27 1 48 60 79 53 79 -20 0 -34 -26 -50 -111
    -69 -48 -11 -60 -10 -88 4 -17 10 -34 23 -37 31 -4 8 -28 31 -55 50 -56 40
    -64 54 -55 91 7 25 9 26 53 20 26 -3 55 -14 65 -23z m-7707 6 c9 -14 -24 -49
    -47 -49 -22 0 -23 18 -1 42 18 20 38 23 48 7z m2125 -9 c48 -24 64 -65 34 -87
    -30 -22 -123 -48 -134 -37 -12 12 39 144 56 144 3 0 23 -9 44 -20z m2889 10
    c19 -5 45 -20 58 -32 l24 -23 18 24 c22 28 50 23 81 -16 32 -41 27 -63 -15
    -63 -29 0 -248 79 -264 96 -8 8 21 24 44 24 11 0 35 -4 54 -10z m4129 -6 c27
    -19 55 -71 48 -90 -8 -21 -49 -17 -87 9 -41 28 -47 49 -20 76 25 25 30 26 59
    5z m-6506 -10 c26 -14 30 -20 25 -47 -8 -49 -68 -147 -94 -153 -27 -7 -73 19
    -73 42 0 16 28 64 45 76 5 5 22 5 38 2 34 -7 35 8 2 26 -29 16 -31 27 -8 52
    20 22 26 22 65 2z m2776 -27 c3 -34 0 -39 -30 -52 l-33 -14 40 0 c54 1 94 13
    77 23 -18 11 -15 46 6 47 24 2 53 -1 80 -7 17 -3 22 -11 20 -27 -2 -18 -10
    -23 -45 -25 l-42 -3 32 -29 c60 -53 7 -66 -138 -33 -78 17 -105 29 -105 44 0
    19 103 120 119 117 11 -2 17 -16 19 -41z m3256 11 c23 -37 -20 -62 -65 -38
    -24 13 -25 57 -1 62 23 6 54 -6 66 -24z m-8774 -2 c0 -23 -51 -57 -79 -54 -29
    3 -42 45 -19 59 23 15 98 11 98 -5z m522 -3 c28 -33 79 -133 73 -143 -3 -5
    -22 -14 -42 -19 -44 -13 -74 3 -98 49 -15 28 -14 33 10 80 28 55 35 59 57 33z
    m818 -18 c30 -31 32 -37 19 -50 -8 -8 -33 -16 -54 -18 -35 -2 -40 1 -43 21 -4
    30 16 82 32 82 7 0 27 -16 46 -35z m3662 14 c39 -21 3 -89 -47 -89 -30 0 -45
    26 -45 75 l0 37 37 -7 c21 -4 46 -11 55 -16z m1583 11 c7 -11 -7 -36 -49 -85
    -25 -29 -26 -29 -41 -11 -8 11 -15 39 -15 63 l0 43 49 0 c28 0 53 -5 56 -10z
    m302 -11 c19 -7 21 -15 20 -76 l-2 -68 -72 0 c-77 0 -106 13 -84 38 6 8 30 18
    54 22 l42 7 -34 15 c-19 8 -46 23 -60 34 -27 22 -56 10 -33 -13 17 -17 15 -35
    -8 -58 -24 -24 -96 -27 -125 -6 -18 13 -18 14 4 44 12 17 36 43 54 57 31 25
    35 25 127 19 52 -4 105 -10 117 -15z m2116 0 c85 -12 102 -26 72 -59 -26 -28
    -71 -34 -129 -17 -28 9 -66 20 -85 24 -43 10 -60 35 -41 58 15 18 13 18 183
    -6z m-9163 -14 c17 -21 4 -35 -35 -35 -36 0 -50 12 -41 35 7 19 60 19 76 0z
    m2150 -3 c50 -40 -9 -121 -102 -142 -74 -17 -104 -8 -125 35 -16 33 -16 37 -1
    51 15 15 21 14 71 -15 30 -17 56 -31 58 -31 7 0 37 64 43 93 7 32 25 34 56 9z
    m5066 6 c11 -18 -26 -38 -73 -38 -35 0 -43 3 -43 18 0 10 3 22 7 25 11 12 101
    8 109 -5z m-8647 -7 c39 -25 -2 -101 -66 -122 -44 -14 -63 -6 -63 28 0 37 25
    72 64 89 37 16 46 17 65 5z m1309 -13 c2 -12 -5 -19 -23 -24 -34 -8 -53 9 -35
    31 17 20 54 16 58 -7z m629 1 c40 -25 103 -104 103 -130 0 -50 -111 -15 -155
    49 -29 43 -30 50 -9 80 19 27 19 27 61 1z m875 -19 c-2 -19 -8 -43 -13 -52
    -12 -22 -55 -23 -63 -2 -18 48 10 97 53 92 23 -3 26 -7 23 -38z m652 30 c19
    -7 26 -17 26 -36 0 -25 -2 -26 -32 -20 -18 4 -42 16 -53 27 -17 17 -18 21 -5
    29 19 12 33 12 64 0z m2268 -7 c9 -10 21 -35 28 -56 10 -33 9 -41 -9 -71 -27
    -44 -74 -62 -97 -38 -16 16 -17 12 -11 -63 8 -92 2 -125 -22 -125 -10 0 -27
    10 -38 23 -32 34 -83 119 -83 138 0 22 75 89 100 89 10 0 23 -7 28 -16 6 -12
    11 0 15 42 6 59 29 94 62 94 6 0 19 -8 27 -17z m3019 1 c14 -12 52 -19 146
    -25 180 -13 197 -18 201 -55 4 -42 -14 -84 -35 -84 -29 0 -83 38 -95 68 -10
    24 -12 25 -16 7 -2 -11 -9 -23 -15 -27 -6 -4 -2 -16 11 -33 25 -31 19 -55 -14
    -55 -29 0 -52 40 -61 105 l-6 45 -47 0 c-26 0 -74 -3 -108 -6 l-61 -7 -3 -36
    c-2 -29 -7 -37 -27 -39 -40 -6 -70 7 -77 33 -8 33 9 52 55 65 21 5 48 21 61
    35 27 29 65 32 91 9z m987 4 c19 -19 14 -28 -20 -42 -40 -17 -58 -11 -58 19 0
    33 52 49 78 23z m-6500 -10 c32 -32 -12 -103 -60 -96 -18 2 -24 10 -26 36 -6
    56 51 95 86 60z m816 -39 c-1 -72 -11 -99 -38 -99 -25 0 -76 50 -76 74 0 15
    90 77 105 72 6 -2 10 -23 9 -47z m2049 19 l21 -28 -21 -27 c-23 -32 -52 -41
    -64 -21 -11 16 -12 92 -2 102 14 13 46 1 66 -26z m-4907 11 c9 -16 -20 -41
    -39 -33 -17 6 -22 25 -10 37 10 11 41 8 49 -4z m5519 -12 c45 -26 55 -50 29
    -78 -21 -23 -91 -26 -120 -5 -19 14 -18 15 3 60 13 25 28 46 35 46 7 0 31 -11
    53 -23z m655 -10 c19 -33 5 -76 -32 -96 -22 -13 -29 -13 -42 -2 -25 21 -20 74
    9 105 29 32 44 30 65 -7z m-6270 8 c25 -30 -19 -83 -59 -70 -27 8 -34 34 -16
    61 17 27 56 32 75 9z m4782 3 c7 -19 -10 -99 -24 -115 -21 -26 -52 -11 -59 28
    -7 46 1 68 32 85 30 17 46 17 51 2z m1603 2 c34 -13 28 -32 -13 -42 -39 -10
    -72 5 -72 32 0 15 7 20 29 20 16 0 42 -5 56 -10z m2403 -20 c34 -16 62 -36 62
    -43 0 -15 -71 -39 -115 -39 -30 0 -75 38 -75 63 0 18 35 49 55 49 5 0 38 -13
    73 -30z m-8233 11 c3 -5 -7 -19 -21 -30 -32 -25 -94 -29 -94 -6 0 28 100 59
    115 36z m1054 -34 c12 -34 12 -40 -1 -53 -8 -9 -34 -18 -56 -21 -53 -7 -61 9
    -33 72 18 41 24 46 48 43 21 -2 30 -11 42 -41z m8069 31 c18 -18 15 -52 -6
    -78 l-19 -23 -41 23 c-49 28 -53 49 -14 72 32 21 63 23 80 6z m-10934 -31 c17
    -47 -8 -78 -83 -102 -66 -22 -86 -42 -76 -76 7 -20 8 -19 25 9 26 42 40 44 78
    9 l32 -31 -6 31 c-6 28 -3 34 27 52 19 12 42 21 51 21 23 0 53 -69 40 -90 -9
    -14 -77 -44 -137 -59 -17 -4 -41 -13 -54 -20 -18 -10 -29 -10 -52 -1 -44 19
    -74 11 -269 -64 -8 -3 -44 -22 -79 -41 -71 -40 -94 -39 -89 2 2 20 15 33 53
    54 28 15 60 28 71 28 12 1 28 8 35 18 16 19 86 52 111 53 9 0 28 11 42 25 14
    14 32 25 41 25 17 0 20 16 5 25 -15 9 -12 58 5 82 17 25 81 41 97 25 7 -7 6
    -17 -2 -32 -24 -45 -1 -29 34 24 20 30 42 57 48 59 25 11 43 1 52 -26z m1018
    9 l36 -24 11 24 c6 13 19 24 29 24 25 0 55 -34 50 -57 -4 -20 -53 -31 -141
    -32 -45 -1 -49 1 -58 29 -13 35 -35 42 -25 8 15 -50 14 -52 -59 -64 -114 -20
    -122 -19 -135 21 -14 43 -30 37 -30 -11 0 -31 -4 -37 -36 -50 -51 -21 -98 -15
    -102 13 -2 14 4 26 18 33 19 10 19 12 5 27 -26 25 -12 38 41 38 27 0 68 6 91
    14 49 16 70 10 83 -24 13 -34 27 -32 35 6 8 36 31 48 101 48 38 1 60 -5 86
    -23z m1715 -51 c-10 -43 -16 -50 -38 -53 -19 -2 -33 5 -53 28 -14 17 -26 37
    -26 44 0 8 24 22 53 34 69 27 82 17 64 -53z m517 69 c10 -4 16 -18 16 -41 l0
    -34 -55 6 c-38 5 -55 4 -55 -4 0 -6 16 -11 35 -11 19 0 35 -4 35 -8 0 -32 -25
    -125 -35 -128 -7 -3 -33 9 -59 27 -34 23 -46 36 -41 48 4 9 10 35 15 59 4 24
    10 45 12 48 3 2 29 13 59 23 30 11 55 20 56 20 1 1 8 -2 17 -5z m1626 -9 c9
    -11 8 -26 -4 -68 -19 -64 -35 -74 -71 -45 -24 19 -26 26 -21 62 4 22 12 46 18
    53 14 17 63 17 78 -2z m-3400 -13 c26 -21 20 -42 -11 -42 -45 0 -79 40 -46 53
    22 10 35 7 57 -11z m163 5 c42 0 30 -29 -16 -40 -45 -11 -86 -2 -94 19 -8 23
    17 36 52 28 17 -4 43 -7 58 -7z m2182 -12 c0 -21 -31 -33 -46 -18 -5 5 -7 17
    -3 27 9 24 49 17 49 -9z m3999 12 c15 -11 17 -21 11 -55 -16 -96 -73 -107
    -126 -25 -16 26 -28 52 -26 58 4 13 63 34 98 34 14 1 33 -5 43 -12z m2375 2
    c35 -12 53 -44 44 -78 -6 -25 -11 -26 -43 -4 -97 64 -98 115 -1 82z m-5455
    -15 c11 -10 14 -24 9 -42 -14 -57 -30 -96 -45 -105 -23 -15 -67 1 -80 29 -10
    21 -8 33 15 80 23 47 31 54 56 54 16 0 37 -7 45 -16z m-434 -9 c10 -12 8 -21
    -14 -50 -33 -43 -46 -44 -46 -4 0 58 32 88 60 54z m2704 -1 c18 -17 22 -99 6
    -109 -22 -14 -80 46 -80 84 0 14 29 41 45 41 7 0 21 -7 29 -16z m951 -9 c35
    -34 34 -87 0 -103 -37 -17 -102 -15 -108 2 -6 15 8 78 24 109 14 25 56 21 84
    -8z m-6587 -3 c3 -9 -3 -13 -19 -10 -12 1 -24 9 -27 16 -3 9 3 13 19 10 12 -1
    24 -9 27 -16z m2115 -23 c15 -22 27 -45 27 -50 0 -13 -63 -39 -93 -39 -55 0
    -65 63 -16 104 17 14 36 26 43 26 7 0 24 -18 39 -41z m568 31 c52 -28 -11
    -114 -80 -108 -29 2 -37 8 -39 26 -8 58 67 109 119 82z m5357 -9 c92 -26 122
    -39 122 -51 0 -18 -27 -64 -49 -84 -25 -23 -27 -36 -6 -36 24 0 29 -27 11 -55
    -21 -33 -3 -32 22 0 11 14 25 25 31 25 14 0 31 -33 31 -59 0 -26 12 -27 27 -2
    7 11 22 21 35 23 18 2 24 12 29 43 4 22 12 53 18 69 10 24 9 27 -2 18 -8 -7
    -19 -29 -25 -51 -7 -21 -18 -41 -26 -44 -18 -7 -95 29 -102 48 -9 22 25 95 45
    96 42 4 97 -4 111 -16 8 -7 26 -15 40 -17 21 -3 25 -9 28 -44 2 -22 -4 -60
    -12 -85 -8 -24 -13 -45 -11 -47 2 -2 19 5 37 16 18 10 45 22 60 26 19 4 28 14
    33 37 7 29 9 31 41 26 36 -6 154 -72 154 -86 0 -5 17 -11 38 -15 49 -7 120
    -58 128 -91 5 -20 11 -24 29 -19 17 4 41 -6 86 -35 55 -36 89 -50 89 -37 0 2
    -16 13 -35 25 -39 22 -47 59 -19 82 19 16 43 3 61 -32 7 -14 25 -27 43 -30
    l31 -7 -20 22 c-12 12 -21 25 -21 29 0 22 132 -11 174 -44 64 -50 19 -65 -272
    -95 l-63 -6 -72 68 c-41 40 -103 85 -143 107 -74 38 -97 46 -76 25 7 -7 12
    -27 12 -45 0 -41 29 -90 69 -114 42 -25 39 -15 -10 38 -43 47 -46 66 -10 71
    27 4 71 -33 71 -60 0 -12 7 -18 24 -18 32 0 81 -42 73 -62 -6 -18 -127 -43
    -158 -33 -11 4 -26 0 -35 -9 -8 -9 -32 -16 -52 -16 -38 0 -61 12 -126 63 -41
    33 -64 33 -41 0 8 -12 29 -24 45 -28 33 -7 40 -29 13 -39 -9 -4 -77 -16 -150
    -26 -74 -11 -144 -25 -155 -31 -11 -6 -29 -8 -40 -5 -11 2 -27 -2 -35 -10 -21
    -21 -63 -17 -90 8 -29 27 -30 54 -1 62 22 5 22 6 4 19 -12 9 -17 20 -13 31 9
    23 18 21 76 -19 56 -39 84 -46 56 -15 -11 12 -15 28 -12 42 6 22 -7 48 -24 48
    -5 0 -8 -10 -6 -22 3 -36 -30 -35 -51 1 -11 21 -22 29 -32 24 -29 -13 -62 -5
    -90 22 -16 16 -30 22 -34 16 -4 -5 12 -28 34 -50 45 -44 55 -91 21 -91 -11 0
    -23 9 -26 20 -4 13 -15 20 -33 20 -14 0 -36 10 -48 21 -27 25 -51 20 -56 -13
    -5 -35 -31 -28 -44 12 -16 50 -30 47 -26 -5 4 -48 -3 -54 -38 -33 -15 9 -25
    10 -37 2 -28 -18 -26 -31 6 -26 25 3 32 -1 45 -25 17 -33 96 -73 96 -48 0 8
    -4 17 -10 20 -30 19 8 75 51 75 63 0 77 -25 32 -59 l-28 -20 28 -1 c15 0 39 7
    53 16 23 16 26 15 63 -11 74 -51 61 -68 -59 -79 -41 -4 -93 -16 -115 -26 -22
    -11 -59 -22 -82 -26 -36 -5 -44 -4 -50 12 -3 9 -28 45 -53 79 -59 78 -68 109
    -42 145 27 37 36 86 22 120 -11 26 -10 33 13 60 14 16 31 54 37 84 8 38 17 57
    29 61 19 6 206 -49 229 -67 6 -6 12 -29 12 -52 0 -23 7 -51 15 -62 13 -18 14
    -16 15 28 0 26 4 50 10 53 10 6 220 -101 233 -119 4 -6 5 -21 2 -34 -6 -23 22
    -82 37 -82 13 0 9 23 -7 44 -21 28 -18 46 7 46 13 0 42 -21 75 -55 52 -54 83
    -69 83 -41 0 7 -7 19 -15 26 -11 9 -14 22 -10 40 5 23 1 29 -42 52 -35 19 -53
    24 -65 17 -25 -14 -31 6 -13 42 11 21 13 35 7 41 -7 7 -12 3 -17 -11 -12 -39
    -38 -43 -107 -17 -35 13 -92 40 -128 61 -36 20 -90 47 -120 59 -41 17 -56 28
    -58 45 -6 40 7 69 30 73 18 2 24 12 30 46 4 23 10 47 13 52 9 15 48 12 123 -9z
    m916 13 c23 -9 20 -41 -4 -49 -25 -8 -26 -22 -1 -30 24 -7 37 -43 23 -57 -14
    -14 -69 8 -83 34 -11 20 -3 75 13 96 11 13 28 15 52 6z m706 -14 c6 -12 10
    -35 8 -53 -2 -24 -8 -33 -25 -35 -26 -4 -63 30 -63 57 0 45 60 68 80 31z
    m-10504 -11 c18 -20 18 -21 -6 -39 -23 -17 -23 -20 -9 -37 9 -10 14 -24 12
    -31 -12 -31 -113 -57 -128 -32 -4 6 -18 -2 -34 -19 -46 -49 -97 -52 -125 -8
    -8 12 -7 23 2 38 13 21 13 21 -25 15 -21 -4 -45 -9 -54 -12 -20 -6 -61 42 -57
    65 5 22 67 61 99 61 21 0 29 -6 38 -32 12 -33 26 -30 33 7 8 45 108 46 108 1
    0 -29 -15 -42 -77 -67 l-48 -20 45 6 c24 3 64 15 87 25 39 17 43 22 37 45 -4
    15 -1 31 6 40 18 22 73 19 96 -6z m1325 2 c32 -26 19 -38 -62 -57 -97 -24
    -133 -23 -137 1 -4 34 11 45 84 59 93 18 89 19 115 -3z m3504 9 c30 -11 29
    -37 -1 -32 -81 12 -108 19 -112 30 -5 15 74 17 113 2z m1079 -3 c24 -17 12
    -82 -20 -114 -26 -26 -91 -32 -112 -11 -32 32 3 94 71 123 40 18 39 18 61 2z
    m2552 -9 c8 -8 15 -32 17 -53 2 -36 -1 -40 -23 -43 -59 -9 -161 55 -147 92 11
    28 126 31 153 4z m899 6 c30 -20 85 -101 85 -126 0 -23 -9 -23 -89 6 -178 65
    -221 98 -133 104 35 3 46 -1 67 -24 30 -32 41 -26 27 15 -15 44 0 53 43 25z
    m-7848 -27 c20 -19 33 -39 29 -45 -3 -6 -27 -14 -51 -18 -46 -6 -75 5 -75 31
    0 16 38 65 51 65 5 0 26 -15 46 -33z m1025 8 c9 -19 8 -33 -5 -65 l-15 -40 29
    0 c22 0 32 -7 41 -25 7 -16 8 -29 2 -34 -5 -5 -94 -32 -199 -59 -104 -27 -273
    -80 -375 -117 -102 -37 -193 -69 -203 -72 -12 -4 -31 7 -58 33 -33 33 -39 35
    -39 18 0 -12 9 -29 20 -39 11 -10 20 -22 20 -26 0 -15 -100 -60 -120 -54 -10
    3 -30 21 -45 40 -16 22 -34 35 -48 35 -19 -1 -16 -6 23 -41 l45 -40 -30 -24
    c-32 -26 -78 -41 -95 -30 -5 3 -10 19 -10 35 0 16 -11 42 -25 58 -30 36 -30
    37 -6 71 10 14 24 46 31 69 13 49 43 67 125 79 51 7 53 2 31 -62 -16 -46 -35
    -54 -61 -25 -21 24 -35 26 -35 5 0 -16 71 -65 94 -65 10 0 15 9 14 28 -1 15 6
    51 14 80 11 40 21 56 42 67 32 17 74 19 96 5 11 -7 19 -4 31 12 9 11 34 27 55
    35 54 20 206 51 222 46 18 -8 15 -50 -7 -72 -10 -10 -39 -21 -65 -25 -44 -7
    -56 -26 -16 -26 10 0 28 -12 39 -26 22 -28 41 -25 41 6 0 28 36 43 83 36 37
    -6 44 -4 79 31 l38 37 36 -17 c36 -17 36 -17 61 7 14 14 34 28 44 31 23 8 24
    28 3 60 -12 18 -13 28 -5 44 25 46 85 55 103 16z m3082 -10 c23 -34 20 -62 -9
    -91 -53 -53 -101 -1 -69 75 24 56 48 61 78 16z m571 29 c20 -8 45 -56 45 -88
    0 -39 -68 -84 -85 -57 -3 6 -10 35 -16 66 -13 74 4 99 56 79z m415 -9 c9 -11
    11 -33 7 -72 -11 -106 -77 -95 -77 13 0 65 39 97 70 59z m514 -6 c48 -37 28
    -63 -41 -52 -77 12 -94 35 -40 58 43 19 50 18 81 -6z m516 11 c25 -16 -2 -44
    -52 -54 -62 -12 -98 -2 -98 28 0 12 3 26 7 29 10 11 126 8 143 -3z m-5555 -25
    c32 -31 32 -53 -1 -65 -34 -13 -94 -13 -94 0 0 23 41 90 56 90 8 0 26 -11 39
    -25z m1282 8 c-24 -74 -47 -127 -59 -140 -13 -13 -21 -11 -62 17 -41 28 -47
    36 -44 64 3 29 8 33 68 53 83 27 104 29 97 6z m4417 11 c21 -8 22 -64 1 -64
    -29 0 -85 29 -85 44 0 22 48 34 84 20z m2148 -4 c21 -6 40 -15 43 -20 9 -14
    -65 -90 -86 -90 -33 0 -53 82 -27 108 15 15 23 15 70 2z m-5913 -26 c25 -32
    27 -71 5 -102 l-15 -22 -42 24 c-48 26 -51 48 -16 97 25 36 42 37 68 3z
    m-3219 6 c0 -10 -58 -50 -73 -50 -18 0 -19 34 -2 46 22 16 75 19 75 4z m1180
    -9 c0 -30 -29 -55 -46 -40 -15 12 -19 41 -7 52 3 4 17 7 30 7 16 0 23 -6 23
    -19z m4123 -39 c10 -60 5 -82 -18 -82 -17 0 -125 78 -125 90 0 20 74 50 115
    47 16 -2 22 -13 28 -55z m611 42 c3 -9 6 -31 6 -50 0 -62 -51 -55 -68 10 -5
    17 -7 37 -4 44 6 18 59 15 66 -4z m1254 6 c35 0 38 -27 6 -61 -33 -34 -42 -35
    -94 -9 -66 34 -45 86 30 75 19 -2 45 -5 58 -5z m1634 -30 c9 -40 0 -119 -14
    -137 -16 -20 -35 -15 -72 18 -38 32 -57 90 -39 117 11 19 70 42 98 39 13 -1
    22 -13 27 -37z m988 25 c16 -9 37 -29 45 -45 9 -17 22 -30 29 -30 26 0 77 -51
    74 -74 -4 -29 -56 -47 -69 -23 -5 9 -30 31 -55 48 -49 33 -79 87 -69 120 8 23
    8 23 45 4z m-9922 -7 c34 -34 1 -68 -66 -68 -46 0 -72 22 -55 48 17 29 99 42
    121 20z m248 4 c20 -13 26 -49 9 -65 -15 -16 -121 -32 -166 -25 -46 6 -26 32
    51 65 80 35 89 37 106 25z m184 -7 c6 -8 9 -23 5 -35 -5 -17 -15 -20 -64 -20
    -74 0 -99 21 -62 51 28 23 103 26 121 4z m1707 -20 c29 -29 33 -38 23 -50 -7
    -8 -25 -15 -41 -15 -15 0 -31 -4 -34 -10 -7 -12 -42 -13 -49 -2 -7 12 23 95
    37 104 20 13 28 9 64 -27z m3993 25 c38 -20 54 -122 21 -139 -14 -8 -25 -4
    -50 16 -26 21 -31 33 -31 67 0 58 20 77 60 56z m3244 -12 c22 -31 20 -65 -5
    -78 -39 -22 -65 31 -39 81 14 25 25 24 44 -3z m-10856 0 c7 -7 12 -25 12 -40
    0 -22 -7 -31 -27 -40 -74 -29 -200 -91 -215 -105 -23 -21 -48 -10 -48 21 0 35
    66 88 102 83 19 -2 28 2 31 14 5 20 92 79 117 79 9 0 21 -5 28 -12z m3220 -30
    c3 -30 -1 -40 -23 -54 -33 -21 -71 -7 -81 30 -8 32 0 44 39 55 51 15 62 10 65
    -31z m2433 32 c20 -11 26 -60 13 -107 -9 -35 -22 -28 -34 18 -8 29 -15 38 -22
    31 -19 -19 -27 -94 -28 -242 0 -80 -7 -190 -15 -244 -21 -138 -20 -144 12
    -148 36 -4 41 -26 9 -38 -17 -6 -26 -17 -26 -31 0 -13 -7 -31 -16 -41 -19 -20
    -12 -25 40 -30 51 -5 41 -25 -16 -33 -29 -3 -74 -11 -100 -17 -26 -7 -51 -8
    -55 -4 -4 4 -9 170 -11 369 -5 382 3 491 35 514 21 16 186 18 214 3z m889 -9
    c23 -43 9 -101 -24 -101 -48 0 -61 49 -25 94 24 31 35 33 49 7z m-5236 -4 c11
    -8 17 -23 14 -38 -2 -20 -11 -26 -51 -33 -55 -11 -80 -1 -85 32 -6 42 80 70
    122 39z m3364 -3 c25 -18 28 -42 7 -70 -14 -19 -15 -19 -55 4 -48 27 -51 19
    -8 -25 l33 -34 -23 -42 c-12 -23 -41 -63 -63 -89 -44 -51 -69 -59 -107 -32
    -19 13 -20 19 -11 37 21 41 52 67 80 67 15 0 31 5 34 10 3 6 2 10 -4 10 -5 0
    -16 7 -25 15 -17 18 -8 55 22 88 9 10 17 25 18 33 7 43 60 58 102 28z m2547
    -9 c28 -27 34 -85 11 -104 -28 -23 -96 26 -96 69 0 23 29 60 46 60 8 0 26 -11
    39 -25z m545 10 c12 -14 10 -48 -6 -102 -6 -21 -3 -23 31 -23 37 0 37 -1 31
    -31 -3 -17 -15 -43 -27 -57 -11 -15 -17 -27 -12 -28 4 -1 20 -5 36 -8 17 -4
    27 -13 27 -24 0 -20 -66 -66 -85 -58 -8 3 -16 26 -19 53 -7 58 -22 140 -38
    209 -6 28 -8 58 -5 67 8 21 50 22 67 2z m1230 1 c0 -37 -104 -81 -139 -59 -24
    15 -19 46 9 60 36 18 130 17 130 -1z m-6292 -12 c39 -27 23 -58 -35 -70 -37
    -7 -47 11 -32 56 12 34 33 38 67 14z m1270 -27 c4 -46 -9 -64 -53 -73 -51 -9
    -56 0 -33 54 23 53 34 63 63 60 15 -2 21 -12 23 -41z m503 33 c44 -24 9 -60
    -59 -60 -48 0 -68 19 -52 49 8 16 21 21 51 21 22 0 49 -5 60 -10z m-2274 -15
    c3 -9 4 -18 1 -20 -8 -9 -126 -36 -180 -42 -49 -5 -59 -3 -64 12 -9 21 11 35
    52 35 18 0 47 7 65 15 46 20 118 20 126 0z m4032 -2 c5 -10 12 -39 16 -65 7
    -44 6 -47 -17 -53 -14 -4 -44 -5 -69 -3 -33 2 -45 7 -47 21 -7 36 9 67 45 92
    44 30 59 31 72 8z m2209 5 c14 -14 15 -47 3 -67 -8 -12 -18 -13 -68 -2 -86 18
    -93 21 -93 36 0 8 21 18 58 25 31 7 62 14 67 15 18 6 21 5 33 -7z m1034 -43
    c-12 -27 -31 -31 -62 -15 -24 13 -16 36 19 55 22 12 28 12 40 0 12 -11 12 -19
    3 -40z m1026 43 c7 -7 41 -26 75 -43 68 -33 81 -59 32 -62 -34 -3 -133 43
    -148 68 -21 34 14 65 41 37z m489 -23 c18 -22 37 -35 51 -35 29 0 240 -96 266
    -120 42 -41 -23 -78 -78 -45 -17 10 -85 49 -151 87 -132 76 -165 102 -165 130
    0 32 46 22 77 -17z m-9843 3 c23 -38 -43 -78 -80 -47 -17 14 -19 55 -1 63 24
    10 70 1 81 -16z m1451 -18 c0 -44 -22 -50 -61 -17 -38 33 -28 59 23 55 36 -3
    38 -5 38 -38z m478 2 c-2 -44 -22 -92 -38 -92 -25 0 -75 51 -75 76 0 28 47 55
    90 51 22 -2 25 -7 23 -35z m2009 21 c30 -27 21 -51 -45 -119 -100 -102 -114
    -84 -41 51 25 47 51 85 57 85 6 0 19 -7 29 -17z m1232 -5 c18 -28 41 -142 33
    -163 -10 -25 -43 -18 -56 13 -15 37 -30 111 -31 145 0 34 33 37 54 5z m1579
    11 c66 -18 58 -69 -12 -69 -74 0 -102 21 -81 61 12 21 37 24 93 8z m664 -4
    c28 -20 34 -51 14 -76 -14 -18 -20 -19 -46 -9 -16 6 -33 17 -37 23 -10 15 -10
    61 -1 70 11 12 48 8 70 -8z m598 -5 c11 -9 15 -27 13 -59 l-3 -46 -47 -9 c-58
    -11 -81 5 -100 67 -11 35 -10 41 8 54 23 17 105 13 129 -7z m-6701 4 c9 -3 16
    -10 16 -14 0 -16 -81 -110 -94 -110 -15 0 -50 72 -44 92 3 7 27 18 54 25 27 6
    50 12 51 12 1 1 8 -2 17 -5z m-1441 -45 c29 -36 21 -55 -39 -90 -63 -35 -79
    -33 -102 15 -19 39 -7 75 31 92 40 18 87 10 110 -17z m2807 4 c-1 -16 -9 -50
    -19 -78 -12 -36 -23 -50 -36 -50 -24 0 -45 39 -45 82 0 36 38 73 76 73 20 0
    24 -5 24 -27z m4259 13 c9 -11 4 -20 -27 -44 -36 -29 -40 -30 -60 -16 -21 14
    -30 53 -15 67 12 13 90 7 102 -7z m615 -7 c21 -16 26 -28 24 -53 -2 -25 -8
    -32 -30 -34 -24 -3 -88 21 -88 34 0 2 7 20 14 39 17 41 41 45 80 14z m-6785 2
    c21 -13 5 -41 -23 -41 -33 0 -44 20 -21 37 22 15 25 16 44 4z m2305 -13 c15
    -57 3 -78 -45 -78 -24 0 -25 29 -4 70 18 36 40 39 49 8z m121 2 c36 -22 51
    -48 37 -62 -5 -5 -31 -8 -58 -6 -40 2 -51 7 -61 27 -15 31 -1 61 29 61 11 0
    35 -9 53 -20z m605 5 c17 -9 30 -21 30 -27 0 -19 -49 -95 -65 -102 -42 -16
    -72 28 -54 82 21 66 37 74 89 47z m1872 -12 c15 -16 28 -35 29 -43 6 -29 -12
    -88 -28 -94 -21 -9 -59 18 -83 57 -24 39 -25 65 -3 89 23 26 55 22 85 -9z
    m302 11 c5 -14 -8 -54 -19 -54 -28 0 -48 44 -28 63 12 13 41 7 47 -9z m222
    -20 c19 -45 12 -64 -21 -64 -37 0 -54 40 -31 75 22 34 34 32 52 -11z m1986 15
    c20 -11 20 -11 -1 -33 -12 -13 -21 -36 -21 -54 0 -38 -14 -41 -41 -9 -24 28
    -25 5 -1 -35 l17 -29 -35 -30 c-19 -16 -42 -28 -50 -26 -16 3 -17 9 -5 151 l8
    88 55 -6 c30 -4 63 -11 74 -17z m796 -10 c3 -29 -20 -54 -43 -45 -15 5 -21 57
    -8 70 16 16 48 1 51 -25z m663 7 c7 -14 22 -27 35 -30 29 -8 32 -36 4 -36 -24
    0 -95 34 -105 50 -9 15 14 40 36 40 11 0 24 -11 30 -24z m-9265 -21 c-4 -22
    -3 -35 4 -35 5 0 10 5 10 10 0 27 41 50 90 50 45 0 50 -2 56 -25 3 -14 1 -31
    -5 -39 -15 -18 -80 -34 -169 -42 l-72 -7 -41 41 c-22 23 -39 47 -37 54 6 16
    46 25 117 27 l53 1 -6 -35z m6705 25 c52 -15 66 -33 48 -68 -7 -15 -15 -30
    -17 -35 -2 -4 4 -4 12 -1 24 9 49 -15 35 -32 -16 -19 -48 -17 -56 3 -4 10 -31
    40 -62 68 -72 68 -57 92 40 65z m-6434 -16 c9 -24 -10 -49 -38 -49 -24 0 -36
    23 -25 51 7 19 55 18 63 -2z m512 -13 c31 -44 27 -59 -25 -81 -60 -26 -80 -25
    -100 5 -19 29 -12 57 23 85 38 29 77 26 102 -9z m1381 14 c20 -24 4 -84 -26
    -95 -36 -14 -49 -12 -74 8 -30 24 -20 52 28 80 44 26 56 27 72 7z m1119 -11
    c47 -15 -126 -284 -183 -284 -12 0 -33 11 -45 24 l-23 25 36 50 c44 60 54 64
    84 38 26 -24 28 -14 6 38 -12 31 -13 43 -3 67 21 51 58 64 128 42z m2671 -27
    c0 -36 -34 -117 -49 -117 -16 0 -21 15 -23 65 -2 41 2 51 26 71 33 29 46 24
    46 -19z m1357 16 c9 -16 26 -38 37 -51 31 -36 9 -49 -51 -30 -40 13 -49 20
    -51 43 -3 25 21 65 39 65 5 0 16 -12 26 -27z m2097 12 c15 -12 17 -20 9 -52
    -11 -46 -40 -51 -62 -11 -12 21 -13 31 -3 52 13 29 28 32 56 11z m-10427 -17
    c33 -31 29 -45 -16 -59 -44 -13 -76 -2 -86 31 -15 49 59 69 102 28z m350 -33
    c17 -68 17 -74 -11 -86 -20 -10 -30 -8 -55 10 -38 27 -39 45 -5 94 34 51 54
    45 71 -18z m1291 43 c-3 -7 -21 -24 -42 -38 l-39 -25 38 -6 c69 -11 79 -59 17
    -74 -45 -11 -154 -55 -200 -82 -45 -26 -71 -21 -59 11 10 26 88 76 129 82 41
    7 46 18 23 52 l-16 22 -30 -35 c-17 -19 -40 -35 -51 -35 -16 0 -19 6 -16 41 3
    40 4 41 58 59 54 17 137 36 173 39 11 0 17 -4 15 -11z m372 -2 c0 -15 -37 -32
    -47 -22 -3 3 -3 12 0 21 8 19 47 20 47 1z m1965 4 c9 -14 -22 -80 -38 -80 -26
    0 -37 56 -15 78 14 14 44 16 53 2z m1953 -40 c4 -52 -13 -74 -34 -46 -17 24
    -18 68 -2 84 20 20 33 8 36 -38z m216 44 c36 -14 -1 -80 -41 -72 -22 4 -29 43
    -13 64 13 15 29 18 54 8z m2334 -14 c38 -24 43 -64 12 -98 -34 -36 -50 -30
    -93 35 -32 50 -33 59 -9 72 26 16 54 13 90 -9z m-7758 -3 c0 -7 -7 -23 -16
    -35 -27 -39 -7 -37 28 2 18 20 41 36 53 36 29 0 103 -65 90 -79 -12 -12 -142
    -41 -185 -41 -33 0 -84 57 -78 87 6 33 108 62 108 30z m2820 -7 c0 -27 -30
    -88 -47 -94 -18 -7 -53 33 -53 61 0 25 40 52 78 53 15 0 22 -6 22 -20z m4078
    -29 c-3 -20 -8 -45 -13 -56 -8 -18 -6 -18 17 3 13 12 28 22 34 22 5 0 34 -23
    64 -50 53 -48 54 -50 36 -65 -27 -21 -104 -19 -146 4 -19 10 -48 39 -64 65
    -27 42 -28 49 -15 72 15 29 57 54 77 46 9 -3 12 -16 10 -41z m-7378 23 c0 -22
    -54 -74 -77 -74 -11 0 -28 6 -39 14 -25 19 -10 45 37 62 49 18 79 17 79 -2z
    m6325 -10 c14 -9 25 -22 25 -29 0 -18 -79 -87 -93 -82 -16 5 -31 79 -23 112 6
    24 11 27 36 21 17 -3 41 -13 55 -22z m1305 13 c0 -19 -21 -37 -42 -37 -22 0
    -23 13 -2 34 19 19 44 21 44 3z m75 3 c4 -6 2 -17 -4 -24 -6 -7 -17 -31 -25
    -52 -15 -44 -40 -52 -44 -14 -4 39 25 100 48 100 10 0 22 -5 25 -10z m2134
    -18 c55 -40 72 -121 27 -130 -25 -5 -45 15 -52 54 -7 36 -24 57 -24 29 0 -23
    -24 -28 -57 -11 -45 23 -57 41 -43 67 11 19 18 21 68 16 31 -3 67 -14 81 -25z
    m-10199 -23 c15 -29 18 -44 11 -53 -15 -17 -85 -38 -105 -30 -40 15 2 124 49
    124 19 0 29 -10 45 -41z m6164 9 c13 -36 -16 -70 -53 -66 -21 2 -27 9 -29 36
    -5 51 3 64 40 60 25 -2 35 -9 42 -30z m393 2 c16 -32 17 -132 1 -148 -26 -26
    -40 -14 -33 28 6 38 6 40 -19 40 -21 0 -26 5 -26 25 0 38 28 87 48 83 9 -2 22
    -14 29 -28z m637 -2 c12 -35 -6 -58 -45 -58 -22 0 -30 6 -35 24 -15 61 59 93
    80 34z m350 22 c34 -13 34 -49 0 -89 -29 -35 -45 -38 -68 -15 -18 18 -20 51
    -6 88 10 28 32 32 74 16z m2841 -23 c22 -10 47 -25 55 -31 8 -7 35 -18 60 -25
    70 -20 164 -68 178 -91 10 -17 10 -25 1 -36 -22 -26 -71 -16 -127 26 -29 21
    -70 42 -90 46 -20 4 -53 14 -72 24 -19 9 -48 20 -65 24 -37 9 -65 33 -65 57 0
    41 49 44 125 6z m-7260 13 c9 -14 -73 -140 -90 -140 -15 0 -65 80 -65 103 0
    31 139 64 155 37z m3713 -7 c32 -14 42 -23 40 -38 -4 -30 -53 -50 -87 -35 -35
    14 -57 56 -40 76 15 18 35 18 87 -3z m460 5 c34 -43 13 -95 -31 -79 -25 9 -33
    41 -17 70 12 24 33 27 48 9z m836 -4 c22 -21 20 -50 -4 -74 -23 -23 -43 -25
    -59 -6 -10 12 -9 40 5 84 5 17 39 15 58 -4z m-4418 -41 c-3 -26 -13 -54 -21
    -62 -13 -14 -17 -13 -32 2 -16 16 -16 19 5 62 13 26 29 45 38 45 14 0 16 -7
    10 -47z m7028 -5 c83 -52 100 -73 72 -94 -40 -29 -144 -9 -160 31 -8 21 17 29
    44 15 33 -18 35 -5 3 17 -62 44 -72 46 -83 18 -6 -15 -16 -25 -23 -23 -17 6
    -21 43 -7 69 17 31 67 20 154 -33z m-10040 11 c37 -44 34 -66 -11 -78 -55 -16
    -67 -14 -92 13 -29 31 -22 57 22 79 45 22 52 21 81 -14z m767 5 c13 -35 -1
    -108 -22 -112 -21 -4 -69 35 -69 56 0 20 53 82 70 82 6 0 15 -12 21 -26z
    m2053 5 c26 -21 34 -43 17 -53 -5 -4 -30 -9 -55 -12 -45 -7 -46 -6 -46 20 0
    25 30 66 49 66 4 0 20 -9 35 -21z m2355 3 c5 -9 12 -35 16 -57 4 -22 12 -49
    18 -59 9 -18 11 -17 23 12 18 43 60 54 86 22 10 -12 18 -30 18 -39 0 -9 12
    -27 25 -40 28 -26 42 -68 28 -82 -6 -6 -28 0 -59 17 -27 14 -96 51 -154 81
    -113 59 -150 87 -150 114 0 30 25 41 117 47 12 1 27 -6 32 -16z m-6562 -9 c5
    -14 -65 -83 -84 -83 -25 0 -13 38 23 69 35 31 54 36 61 14z m407 9 c9 -14 -21
    -48 -54 -62 -26 -11 -34 -11 -46 2 -18 18 -10 42 19 56 27 13 74 15 81 4z
    m8597 -14 c44 -13 49 -29 23 -84 -16 -34 -45 -51 -65 -39 -6 4 -9 26 -8 49 2
    32 0 40 -12 37 -8 -3 -30 -5 -49 -5 -38 -1 -52 23 -29 51 14 17 67 13 140 -9z
    m-8461 -14 c14 -37 12 -70 -5 -84 -28 -23 -8 -21 75 10 l83 31 24 -23 c16 -15
    23 -31 21 -48 -3 -22 -8 -25 -48 -27 -25 -1 -76 -5 -113 -9 -57 -5 -71 -4 -87
    11 -19 17 -21 17 -60 -9 -47 -31 -48 -31 -72 -9 -17 15 -18 15 -18 -5 0 -18 7
    -21 48 -24 39 -3 47 -6 47 -23 0 -30 52 -65 96 -65 31 0 36 3 32 19 -3 10 6
    30 21 47 20 24 28 27 43 18 32 -19 28 -51 -9 -70 -32 -17 -32 -17 -9 -25 30
    -12 23 -28 -19 -44 -19 -7 -49 -19 -66 -26 -40 -16 -64 -6 -64 25 0 23 -3 24
    -35 19 -39 -6 -46 8 -24 49 10 18 9 20 -6 14 -41 -15 -191 -148 -200 -176 -10
    -31 -33 -30 -109 4 -78 36 -213 152 -199 171 27 35 177 155 195 155 23 0 47
    -26 48 -51 0 -18 -71 -68 -133 -94 -20 -8 -37 -20 -37 -25 0 -16 33 -11 60 10
    33 26 67 26 75 0 4 -13 15 -20 32 -20 15 0 35 -7 45 -17 14 -13 23 -14 41 -5
    12 6 32 14 45 17 13 4 21 12 19 18 -5 13 -9 13 -53 -4 -40 -16 -64 -6 -64 24
    0 20 -4 23 -25 19 -34 -6 -33 20 1 47 27 22 84 29 84 11 0 -5 5 -10 10 -10 6
    0 9 14 8 32 -3 30 1 33 72 69 97 48 130 56 142 35 14 -25 29 -19 22 9 -9 36 2
    55 31 55 18 0 28 -7 35 -26z m316 14 c4 -6 -10 -27 -34 -50 -35 -33 -45 -37
    -62 -28 -35 19 -24 46 28 68 55 25 59 26 68 10z m1191 -5 c2 -6 -14 -29 -36
    -50 -23 -21 -41 -41 -41 -46 0 -4 17 -5 38 -1 31 5 43 1 80 -27 23 -18 42 -37
    42 -42 0 -9 -98 -57 -117 -57 -24 0 -62 61 -74 120 -16 84 -33 77 -24 -9 l7
    -70 -42 -21 c-49 -25 -80 -19 -80 16 0 21 -5 24 -33 24 -19 0 -60 -9 -93 -20
    -34 -12 -72 -19 -89 -16 -23 4 -34 0 -46 -17 l-17 -23 61 1 c49 0 66 4 85 22
    43 40 125 41 110 1 -3 -7 -37 -28 -74 -47 -38 -19 -79 -43 -91 -54 l-22 -20
    32 -17 c21 -12 33 -26 35 -43 3 -22 -3 -30 -32 -43 -33 -16 -36 -16 -61 0 -22
    15 -26 23 -21 47 5 24 1 31 -24 44 -37 19 -40 19 -40 -4 0 -11 -11 -33 -25
    -49 -31 -36 -32 -46 -4 -31 14 7 25 7 31 1 9 -9 -15 -39 -139 -170 -33 -34
    -33 -34 -100 -27 -87 9 -98 18 -75 57 26 46 90 100 114 96 32 -5 45 -32 29
    -61 -25 -47 -6 -48 27 -2 37 52 39 65 14 65 -29 0 -43 20 -31 43 8 13 8 22 0
    30 -15 15 -14 50 1 65 19 19 46 14 64 -14 25 -37 39 -15 18 30 -17 35 -37 46
    -49 26 -23 -37 -61 18 -71 102 -6 54 -6 55 24 67 16 7 43 11 58 9 23 -2 30 -9
    32 -30 2 -16 9 -28 16 -28 21 0 24 10 12 41 -9 27 -8 33 8 45 26 19 80 18 97
    -2 12 -14 14 -14 21 5 17 47 119 52 140 6 8 -19 21 -25 62 -30 28 -4 63 -14
    79 -21 40 -21 33 0 -8 25 -69 40 -33 86 84 108 78 14 133 12 138 -4z m1569 9
    c15 -11 74 -119 74 -137 0 -36 -90 -44 -135 -11 -18 13 -18 15 -1 77 16 56 29
    79 46 79 3 0 10 -4 16 -8z m923 -37 c18 -37 0 -54 -66 -61 -58 -7 -72 9 -51
    54 27 56 91 60 117 7z m128 39 c27 -8 38 -36 23 -64 -8 -15 -21 -20 -50 -20
    -66 0 -93 50 -40 77 28 14 36 15 67 7z m2356 -22 c15 -15 27 -33 27 -40 0 -13
    -90 -62 -114 -62 -38 0 -40 74 -2 107 35 30 56 29 89 -5z m2411 18 c30 -11 36
    -53 12 -85 -23 -32 -126 0 -126 40 0 16 30 42 55 48 32 8 32 8 59 -3z m-1768
    -35 c32 -78 5 -119 -47 -69 -31 29 -36 53 -19 85 17 31 49 24 66 -16z m-4129
    9 c11 -28 -34 -104 -70 -119 -45 -18 -129 -24 -134 -8 -6 18 82 101 130 123
    52 24 66 25 74 4z m331 -11 c5 -17 -54 -76 -71 -70 -21 7 -20 38 4 63 24 25
    59 29 67 7z m1284 0 c23 -21 23 -68 1 -88 -91 -78 -115 -90 -127 -59 -3 9 -6
    19 -6 24 0 12 70 113 88 128 20 15 22 15 44 -5z m-4894 -9 c31 -21 16 -44 -47
    -73 -54 -26 -73 -21 -84 18 -6 24 1 34 38 53 40 21 66 21 93 2z m660 -15 c4
    -34 -34 -81 -62 -77 -34 5 -32 43 3 79 35 35 55 34 59 -2z m3134 6 c15 -33
    -15 -118 -41 -113 -13 3 -16 15 -15 56 1 28 4 58 8 67 8 23 35 18 48 -10z
    m3374 1 c19 -30 15 -65 -8 -79 -21 -14 -98 8 -98 27 0 15 65 76 80 76 5 0 17
    -11 26 -24z m900 -12 c51 -41 57 -72 19 -109 -13 -14 -28 -25 -33 -25 -13 0
    -72 88 -72 108 0 18 26 62 37 62 3 0 26 -16 49 -36z m837 14 c41 -16 33 -35
    -28 -65 -43 -21 -60 -25 -73 -17 -27 17 -26 51 2 79 27 27 36 27 99 3z m-8109
    -7 c23 -25 16 -36 -41 -61 -85 -38 -108 -19 -52 45 35 39 67 45 93 16z m716 6
    c0 -17 -20 -37 -37 -37 -13 0 -18 32 -6 43 11 12 43 7 43 -6z m2188 1 c19 -19
    14 -76 -8 -98 -14 -14 -33 -20 -65 -20 -54 0 -59 17 -20 71 42 57 69 71 93 47z
    m-1392 -11 c9 -23 -14 -69 -33 -65 -25 5 -42 56 -23 68 22 14 50 12 56 -3z
    m4304 -2 c0 -21 -48 -65 -70 -65 -31 0 -34 33 -5 57 30 27 75 31 75 8z m940
    -5 c23 -23 15 -51 -20 -70 -14 -7 -20 -23 -22 -57 -6 -88 -38 -61 -53 44 -6
    47 -4 54 19 78 30 30 49 32 76 5z m155 -1 c44 -21 63 -48 49 -70 -9 -16 -109
    -5 -140 16 -23 15 -33 53 -17 68 13 13 64 7 108 -14z m-6725 -4 c19 -23 5 -43
    -41 -55 -46 -13 -69 -8 -69 15 0 43 82 73 110 40z m7400 0 c0 -8 -4 -15 -9
    -15 -13 0 -22 16 -14 24 11 11 23 6 23 -9z m-4329 -17 c10 -15 -14 -44 -53
    -64 -23 -12 -29 -12 -42 2 -19 19 -21 55 -3 73 15 16 86 8 98 -11z m2804 -32
    c0 -56 -21 -80 -52 -60 -26 16 -27 56 -2 88 33 42 54 31 54 -28z m-7145 18 c6
    -14 10 -29 10 -34 0 -21 -124 -119 -136 -107 -13 12 23 93 57 129 42 45 56 47
    69 12z m3360 16 c0 -17 -71 -90 -88 -90 -19 0 -52 29 -52 45 0 14 84 53 118
    54 12 1 22 -3 22 -9z m4234 -6 c34 -33 13 -79 -33 -72 -34 5 -43 -7 -11 -15
    11 -3 20 -14 20 -25 0 -26 -28 -92 -39 -92 -19 0 -72 72 -65 89 3 9 10 33 14
    54 4 21 15 46 25 57 22 24 68 26 89 4z m1342 2 c23 -18 17 -25 -33 -37 -89
    -20 -144 -2 -112 37 15 19 119 19 145 0z m417 -2 c66 -22 68 -28 58 -129 -8
    -78 -12 -91 -39 -118 -27 -27 -34 -29 -56 -19 -13 6 -27 20 -31 32 -8 25 16
    66 45 75 31 10 24 21 -24 39 -54 21 -96 52 -96 72 0 23 47 64 73 64 13 0 44
    -7 70 -16z m-6830 -25 l19 -27 -23 -31 c-27 -37 -114 -95 -128 -86 -6 3 -13
    21 -17 40 -3 19 -12 39 -20 46 -21 17 -18 -35 4 -73 16 -28 16 -30 -3 -44 -38
    -28 -67 -14 -97 46 -16 30 -28 57 -28 60 0 3 21 16 48 28 162 80 209 88 245
    41z m1666 5 c39 -49 17 -78 -37 -50 -37 19 -46 41 -26 61 22 22 40 19 63 -11z
    m517 11 c6 -15 -32 -85 -46 -85 -13 0 -40 42 -40 62 0 33 75 53 86 23z m4064
    -35 c18 -36 23 -39 50 -33 26 5 30 2 30 -15 0 -35 -31 -44 -76 -22 -85 43
    -118 90 -63 90 10 0 19 5 19 10 0 23 21 7 40 -30z m-7650 1 c0 -10 -10 -27
    -22 -38 -30 -26 -134 -83 -152 -83 -13 0 -26 20 -26 40 0 19 33 40 64 40 22 0
    40 8 57 26 41 44 79 51 79 15z m7130 3 c44 -38 59 -73 67 -159 6 -81 19 -105
    29 -56 7 35 28 56 45 46 16 -10 39 -69 39 -100 0 -19 -8 -29 -34 -42 -19 -9
    -40 -13 -48 -9 -7 4 -24 13 -37 21 -13 7 -30 11 -38 8 -12 -5 -12 -8 1 -22 17
    -19 41 -154 32 -178 -5 -12 -16 -14 -54 -9 -26 4 -55 9 -64 12 -22 7 -23 37
    -3 54 13 11 18 10 31 -6 14 -17 15 -8 10 96 -3 63 -9 134 -12 157 -6 41 -6 42
    25 45 l32 3 -45 53 c-47 55 -55 79 -34 100 17 17 22 15 58 -14z m1350 -6 c12
    -22 12 -30 2 -40 -23 -23 -71 24 -59 56 10 24 38 16 57 -16z m-5790 -2 c0 -12
    14 -37 31 -55 33 -35 35 -64 5 -69 -19 -4 -126 45 -126 58 0 4 14 26 30 48 34
    47 60 55 60 18z m675 13 c8 -13 -33 -59 -52 -59 -20 0 -26 25 -13 49 11 22 54
    29 65 10z m119 -26 c36 -56 39 -77 17 -104 l-19 -24 -44 31 c-38 27 -43 35
    -42 67 2 74 49 89 88 30z m2317 -26 c-10 -29 -9 -41 3 -64 20 -40 7 -58 -30
    -46 -22 7 -30 17 -32 39 -2 16 -8 33 -13 39 -17 17 -9 43 23 70 27 23 33 24
    46 12 12 -12 12 -21 3 -50z m-2541 20 c0 -24 -35 -87 -48 -87 -11 0 -39 31
    -44 48 -3 14 72 72 85 65 4 -2 7 -14 7 -26z m432 16 c24 -21 23 -31 -7 -76
    -30 -43 -59 -48 -93 -17 -26 25 -26 23 -7 60 26 50 73 64 107 33z m2233 -36
    c-9 -33 -40 -61 -60 -53 -38 14 -30 79 12 94 36 13 57 -5 48 -41z m164 22 c13
    -37 14 -79 3 -95 -4 -6 -17 -16 -29 -23 -20 -10 -23 -20 -23 -66 0 -52 -1 -55
    -25 -55 -45 0 -91 111 -65 159 11 22 54 29 65 11 13 -22 25 -8 25 29 0 74 29
    98 49 40z m-3983 -26 l27 -47 -24 -45 c-13 -26 -30 -46 -38 -46 -8 0 -24 15
    -34 33 l-20 33 28 30 c40 41 23 49 -24 11 -23 -18 -57 -34 -81 -38 -35 -6 -44
    -12 -52 -36 -6 -16 -23 -35 -39 -43 -37 -20 -88 -19 -95 0 -11 28 -41 15 -91
    -40 -28 -30 -59 -55 -70 -55 -21 0 -73 49 -73 68 0 15 40 35 108 55 28 9 85
    32 125 52 87 43 273 113 304 114 15 1 29 -12 49 -46z m4168 26 c39 -23 48 -57
    20 -80 -33 -28 -98 40 -81 85 8 21 19 20 61 -5z m291 -6 c6 -12 17 -28 24 -37
    28 -34 -21 -96 -63 -80 -25 9 -38 57 -26 89 22 58 45 68 65 28z m899 21 c20
    -8 20 -43 0 -94 -12 -30 -22 -40 -39 -40 -42 0 -54 80 -17 123 16 18 30 21 56
    11z m1743 -9 c3 -9 3 -19 -1 -22 -7 -7 -36 16 -36 28 0 15 30 10 37 -6z
    m-9464 -9 c7 -18 -9 -38 -57 -70 -49 -33 -71 -33 -92 -1 -21 33 -5 55 41 55
    18 0 38 7 45 15 16 19 56 20 63 1z m6435 -54 c3 -59 -8 -146 -23 -184 -5 -13
    -2 -18 9 -18 14 0 21 14 28 64 4 28 24 30 47 7 23 -23 27 -61 11 -92 -8 -14
    -21 -19 -51 -19 -54 0 -93 22 -113 64 -21 44 -20 71 3 93 26 25 41 57 41 88 0
    14 5 35 11 46 19 36 34 15 37 -49z m631 43 c32 -31 -13 -71 -70 -63 -31 4 -40
    55 -13 75 19 14 61 8 83 -12z m538 17 c20 -12 26 -65 11 -85 -15 -20 -83 -39
    -110 -31 -36 11 -11 66 47 104 34 22 35 23 52 12z m1050 -11 c31 -20 32 -21
    31 -95 -1 -68 -3 -77 -24 -91 -31 -20 -41 -19 -69 10 -28 28 -33 70 -9 79 16
    6 16 8 0 24 -20 23 -21 56 0 76 20 21 32 20 71 -3z m-8235 -21 c15 -54 30
    -159 23 -169 -9 -16 -43 -13 -53 4 -5 10 -15 13 -25 9 -23 -8 -21 -21 3 -27
    29 -7 25 -25 -12 -47 -43 -26 -65 -25 -73 3 -4 12 -17 33 -29 46 -20 23 -20
    24 -2 35 10 6 28 18 39 27 19 15 19 17 4 40 -32 45 -19 70 50 95 50 18 66 14
    75 -16z m6880 13 c27 -24 23 -67 -8 -87 -41 -28 -68 -18 -72 25 -3 30 2 41 24
    58 32 25 33 25 56 4z m929 -12 c27 -34 21 -52 -29 -79 -55 -31 -77 -23 -88 31
    l-8 42 -4 -42 c-6 -80 -57 -79 -87 2 -28 72 -21 77 96 73 92 -3 102 -5 120
    -27z m92 17 c39 -20 97 -71 97 -84 0 -7 -12 -27 -27 -44 -24 -29 -31 -32 -71
    -27 -24 3 -48 9 -54 15 -16 16 -1 43 32 55 36 14 39 27 6 27 -33 0 -50 23 -36
    49 12 24 22 26 53 9z m-5543 -14 c71 -28 33 -71 -66 -76 l-49 -3 2 33 c2 62
    37 76 113 46z m5060 -10 c22 -15 40 -32 40 -39 0 -16 -120 -95 -143 -95 -9 0
    -17 6 -17 12 0 28 54 148 67 148 7 0 31 -12 53 -26z m-5222 4 c7 -7 12 -29 12
    -49 0 -31 -6 -43 -37 -68 -38 -32 -58 -38 -67 -22 -7 11 14 122 27 139 12 15
    49 16 65 0z m673 -3 c32 -17 32 -19 -11 -75 -44 -57 -44 -57 0 -85 23 -14 40
    -31 37 -38 -2 -6 -23 -15 -48 -19 -52 -9 -62 -1 -79 74 -11 43 -10 55 6 91 32
    74 42 79 95 52z m3897 -24 c2 -18 -1 -38 -6 -43 -15 -15 -48 0 -60 27 -17 37
    -5 57 32 53 27 -3 31 -7 34 -37z m-4678 -51 c0 -68 -13 -84 -62 -75 -54 10
    -64 19 -50 49 6 14 28 43 48 66 47 52 64 42 64 -40z m641 70 c23 -13 25 -46 2
    -54 -23 -9 -99 3 -120 20 -17 13 -17 15 1 29 23 17 88 20 117 5z m886 -12 c31
    -29 30 -68 -4 -100 -64 -59 -143 -97 -143 -69 0 10 84 156 102 179 14 16 18
    16 45 -10z m-4324 0 c13 -39 -46 -65 -73 -33 -10 12 -10 18 0 30 15 18 67 20
    73 3z m1668 -62 c16 -38 35 -76 43 -84 12 -12 16 -12 26 8 6 12 28 29 48 39
    20 9 49 25 65 35 22 15 30 16 42 6 8 -7 15 -16 15 -21 0 -15 -41 -47 -102 -79
    -92 -49 -134 -92 -141 -142 -7 -52 -35 -90 -74 -102 -23 -7 -33 -17 -37 -38
    -10 -50 -48 -78 -105 -78 -32 0 -55 6 -65 16 -15 14 -14 19 6 57 30 53 84 110
    98 102 17 -10 12 -23 -26 -65 -38 -42 -40 -59 -6 -41 23 12 132 130 132 143 0
    5 -11 1 -25 -8 -25 -17 -27 -16 -60 16 -31 30 -35 31 -35 14 0 -46 -117 -188
    -164 -200 -66 -16 -60 28 13 110 80 87 87 101 66 132 -9 14 -24 28 -33 31 -28
    10 -62 45 -62 64 0 27 31 39 89 35 47 -2 51 -1 51 19 0 33 32 57 72 53 44 -4
    50 -37 13 -67 -24 -18 -26 -25 -20 -61 4 -22 10 -40 14 -40 4 0 12 20 19 44 8
    31 20 49 42 63 27 17 29 21 16 33 -23 18 -20 46 7 65 35 25 48 15 78 -59z
    m2786 57 c8 -20 -39 -63 -68 -63 -28 0 -23 25 12 54 36 30 47 32 56 9z m-3042
    -4 c15 -24 -97 -101 -117 -81 -19 19 -2 47 42 70 49 25 66 27 75 11z m606 -54
    c19 -57 17 -71 -16 -79 -37 -9 -52 2 -64 49 -14 55 -14 51 5 70 30 29 57 15
    75 -40z m1669 45 c0 -36 -71 -117 -91 -104 -19 11 -8 49 23 81 31 32 68 44 68
    23z m228 -21 c2 -20 -4 -32 -25 -46 -37 -26 -74 -35 -90 -21 -21 17 -15 38 19
    70 41 38 91 37 96 -3z m-3364 -5 c9 -36 -9 -54 -55 -54 -46 0 -52 20 -17 57
    30 32 64 30 72 -3z m-223 6 c27 -15 24 -35 -8 -55 -63 -40 -182 -134 -246
    -192 -51 -47 -75 -63 -97 -63 -30 0 -166 27 -181 35 -29 19 62 77 170 109 29
    9 60 21 68 28 24 19 111 47 131 41 14 -3 21 2 26 20 7 31 70 87 97 87 11 0 29
    -5 40 -10z m2866 -16 c25 -19 33 -32 33 -57 0 -40 -18 -104 -30 -112 -6 -3
    -34 17 -64 45 l-55 52 27 49 c15 27 33 49 41 49 8 0 29 -11 48 -26z m938 4
    c37 -17 42 -51 14 -111 -29 -62 -44 -77 -74 -77 -51 0 -47 119 7 188 13 15 20
    15 53 0z m4109 -4 c21 -20 20 -32 -4 -71 -22 -37 -35 -40 -62 -16 -25 23 -23
    68 4 87 28 20 43 20 62 0z m-6977 -58 c-8 -20 -83 -58 -109 -54 -28 4 -46 33
    -33 54 6 9 31 27 55 40 l45 24 24 -24 c14 -14 21 -31 18 -40z m2721 48 c34
    -24 27 -53 -33 -128 -59 -73 -73 -106 -27 -64 39 37 72 52 84 40 20 -20 -2
    -43 -74 -77 -93 -43 -112 -46 -116 -18 -4 27 34 116 59 139 10 9 19 24 19 33
    0 18 47 91 58 91 4 0 18 -7 30 -16z m2466 0 c9 -8 16 -31 16 -50 0 -27 -4 -34
    -20 -34 -34 0 -54 62 -28 88 15 15 13 15 32 -4z m972 -4 c40 -15 54 -39 54
    -91 0 -63 -16 -71 -71 -35 -50 33 -76 88 -60 123 11 25 17 25 77 3z m-3676
    -20 c0 -27 -29 -103 -43 -112 -16 -10 -47 21 -47 48 0 30 56 95 76 87 8 -3 14
    -13 14 -23z m1677 -2 c-3 -7 -5 -2 -5 12 0 14 2 19 5 13 2 -7 2 -19 0 -25z
    m1446 21 c48 -13 72 -50 70 -107 -2 -64 -24 -92 -73 -92 -33 0 -40 3 -40 19 0
    35 12 51 36 51 29 0 31 15 4 30 -12 6 -20 21 -20 36 0 21 -4 24 -20 19 -26 -8
    -60 11 -60 35 0 16 7 20 33 20 17 0 49 -5 70 -11z m189 -24 l31 -36 22 21 c12
    11 26 20 32 20 20 0 22 -29 4 -52 -15 -18 -18 -34 -14 -78 5 -47 2 -58 -16
    -74 -18 -16 -23 -17 -37 -5 -13 11 -15 24 -9 72 5 53 4 58 -11 55 -13 -2 -19
    -14 -21 -41 -3 -49 -19 -69 -52 -65 -36 4 -35 9 15 206 6 21 23 13 56 -23z
    m-4492 -14 c22 -21 40 -44 40 -50 0 -6 -18 -23 -41 -38 -31 -20 -45 -24 -57
    -17 -18 12 -46 109 -38 130 10 27 55 15 96 -25z m488 8 c-4 -44 -30 -59 -57
    -35 -27 25 -27 44 2 56 45 18 59 13 55 -21z m4241 17 c24 -29 -27 -76 -83 -76
    -37 0 -48 46 -16 72 26 21 83 24 99 4z m-3907 -32 c3 -27 0 -37 -11 -41 -9 -3
    -22 -7 -30 -9 -11 -4 -10 -9 5 -25 18 -20 18 -22 -2 -77 -15 -43 -28 -61 -50
    -71 -16 -8 -42 -21 -57 -29 -57 -29 -74 17 -31 84 14 21 23 25 46 20 31 -6 33
    -2 14 34 -10 17 -11 30 -4 43 7 13 6 23 -1 30 -6 6 -11 21 -11 34 0 24 36 40
    96 42 29 1 32 -2 36 -35z m4572 11 c14 -10 26 -25 26 -34 0 -25 -55 -75 -75
    -67 -21 8 -57 89 -49 111 8 21 59 15 98 -10z m-7549 5 c8 -13 -20 -39 -113
    -104 -43 -31 -107 -81 -142 -112 -43 -38 -66 -52 -73 -45 -22 22 65 105 232
    220 78 54 86 57 96 41z m7188 -8 c9 -10 20 -33 23 -50 6 -30 4 -33 -29 -47
    -50 -21 -74 -19 -87 6 -16 28 4 75 39 94 34 18 35 18 54 -3z m737 -12 l35 -30
    -28 -25 c-27 -24 -113 -55 -190 -69 -34 -6 -41 -4 -72 27 -39 39 -45 71 -16
    87 35 18 59 11 87 -25 14 -19 34 -35 43 -35 19 0 46 27 74 73 10 15 21 27 25
    27 4 0 23 -13 42 -30z m175 20 c12 -19 -7 -71 -31 -86 -22 -15 -26 -15 -58 12
    -19 16 -35 35 -35 42 -2 27 109 56 124 32z m-8662 -44 c20 -18 37 -41 37 -49
    0 -38 -110 -90 -181 -85 -59 4 -63 27 -12 75 31 30 111 93 118 93 0 0 18 -15
    38 -34z m3112 3 c59 -52 43 -83 -49 -95 -43 -6 -46 -5 -56 22 -15 39 -5 71 28
    88 36 20 36 20 77 -15z m501 -53 c-8 -41 -39 -64 -61 -46 -12 10 -11 18 7 53
    32 65 41 73 51 49 5 -11 6 -37 3 -56z m-2979 9 c0 -54 0 -55 -53 -95 -48 -38
    -71 -67 -60 -77 2 -2 30 20 62 50 76 70 98 81 114 62 11 -13 5 -27 -35 -85
    l-48 -70 -94 0 c-123 0 -127 9 -41 98 35 37 71 76 79 86 13 17 12 18 -8 12
    -30 -9 -39 11 -16 36 21 23 49 36 79 37 19 1 21 -5 21 -54z m1427 39 c27 -10
    18 -41 -20 -65 -31 -19 -37 -20 -50 -7 -19 19 -9 45 25 63 32 17 26 16 45 9z
    m828 -45 c-5 -34 -35 -83 -54 -87 -18 -3 -78 44 -78 62 0 17 39 52 70 64 34
    14 66 -7 62 -39z m1103 32 c0 -19 -61 -55 -80 -47 -20 7 -19 31 1 51 20 20 79
    17 79 -4z m-1396 -5 c7 -8 11 -34 9 -57 -2 -36 -8 -47 -37 -66 -54 -37 -68
    -31 -81 32 -13 65 -6 80 44 94 44 13 52 13 65 -3z m6165 -54 c11 -34 23 -62
    28 -62 11 0 10 23 -1 53 -16 41 0 52 53 37 46 -13 70 -37 81 -83 6 -24 3 -27
    -51 -43 -66 -19 -163 -14 -201 11 -34 23 -39 58 -13 100 46 74 77 71 104 -13z
    m287 26 c43 -33 49 -34 42 -9 -3 13 3 25 21 36 24 16 28 16 50 1 38 -24 81
    -85 69 -97 -5 -5 -63 -18 -127 -28 -134 -20 -145 -17 -164 47 -14 47 -9 66 21
    79 27 12 42 8 88 -29z m-6600 2 c4 -14 13 -58 20 -98 12 -71 12 -73 -12 -98
    -35 -37 -56 -47 -78 -35 -43 23 -33 69 22 98 l32 16 -35 10 c-71 18 -77 44
    -23 99 42 43 63 45 74 8z m5039 15 c35 -18 37 -33 12 -98 -22 -56 -35 -72 -56
    -64 -13 5 -16 23 -16 85 0 99 5 105 60 77z m-5282 -25 c6 -53 -80 -137 -103
    -100 -12 19 -25 10 -25 -17 0 -57 -60 -83 -100 -43 -28 28 -26 58 5 66 13 3
    35 21 49 39 28 37 120 87 151 83 13 -2 21 -12 23 -28z m1096 -30 c29 -35 31
    -43 16 -71 -14 -24 -24 -24 -63 3 -82 58 -91 74 -57 108 19 19 23 19 49 6 16
    -9 40 -29 55 -46z m-316 8 c25 -56 45 -74 62 -53 7 8 21 15 32 15 16 0 19 -6
    16 -37 -4 -53 -31 -54 -117 -2 -70 41 -89 70 -56 83 8 3 12 12 9 21 -4 10 0
    15 14 15 15 0 27 -12 40 -42z m-1541 20 c18 -7 33 -18 33 -25 0 -8 -34 -49
    -75 -94 -41 -44 -82 -93 -90 -110 l-16 -30 -70 7 c-97 9 -132 18 -137 32 -6
    20 113 132 140 132 18 0 28 9 39 33 25 57 103 81 176 55z m513 -38 c0 -32 -13
    -45 -57 -53 -42 -8 -49 6 -23 48 38 62 80 65 80 5z m5438 4 c4 -54 -12 -94
    -38 -94 -34 0 -50 62 -30 115 8 21 16 26 38 23 24 -3 27 -8 30 -44z m795 28
    c21 -23 5 -42 -34 -42 -32 0 -43 12 -34 40 8 25 46 26 68 2z m-7325 -6 c-2 -8
    -39 -58 -82 -110 -59 -72 -85 -96 -103 -96 -39 0 -38 26 4 76 73 91 191 175
    181 130z m4652 -2 c0 -8 -5 -12 -10 -9 -6 4 -8 11 -5 16 9 14 15 11 15 -7z
    m57 -6 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m3006 4 c9 -10
    22 -33 28 -50 17 -49 0 -62 -79 -62 -54 0 -70 4 -89 22 -37 35 -30 66 20 88
    53 25 99 25 120 2z m-4737 -6 c7 -19 -23 -76 -41 -76 -8 0 -19 9 -25 20 -9 17
    -6 25 14 45 28 28 44 32 52 11z m-3368 -17 c1 -8 -20 -45 -48 -82 -45 -59 -54
    -67 -85 -67 -64 0 -49 40 48 121 59 49 79 56 85 28z m3270 -25 c2 -29 -2 -45
    -14 -55 -14 -12 -19 -10 -35 10 -34 41 -18 95 26 89 16 -2 21 -12 23 -44z
    m3853 15 c19 -19 19 -22 4 -45 -16 -24 -13 -44 6 -44 6 0 16 15 24 33 7 18 22
    40 32 49 44 40 113 30 113 -17 0 -27 -72 -103 -105 -110 -11 -3 -49 4 -85 14
    -64 18 -65 18 -68 56 -5 60 5 85 33 85 14 0 34 -9 46 -21z m-3651 0 c0 -55
    -63 -146 -94 -136 -32 11 -8 110 32 131 33 18 62 20 62 5z m4130 -4 c28 -14
    110 -136 110 -163 0 -15 -51 -36 -60 -25 -4 4 -12 27 -18 50 -7 23 -32 63 -57
    91 -25 27 -45 53 -45 56 0 11 41 6 70 -9z m-5306 -16 c38 -30 33 -55 -14 -79
    -21 -11 -46 -20 -54 -20 -20 0 -86 58 -86 75 0 14 70 43 106 44 12 1 33 -8 48
    -20z m5635 -47 c13 -28 21 -57 18 -65 -7 -20 -85 -33 -100 -18 -7 7 -12 37
    -11 68 0 42 5 59 18 69 27 19 48 4 75 -54z m-7249 38 c0 -42 -132 -159 -165
    -146 -28 10 -15 35 51 100 45 45 73 66 90 66 17 0 24 -5 24 -20z m350 3 c0
    -10 -25 -49 -55 -86 -30 -38 -57 -77 -60 -87 -7 -24 -34 -33 -51 -19 -22 18
    -18 27 39 87 30 31 64 72 76 90 24 35 51 43 51 15z m794 -5 c19 -27 22 -138 4
    -156 -23 -23 -98 -7 -98 20 0 7 19 32 42 55 46 47 38 59 -11 17 -57 -47 -84
    -3 -35 55 32 38 75 42 98 9z m1345 5 c13 -24 -4 -53 -32 -53 -12 0 -32 -3 -45
    -6 -22 -6 -22 -8 -7 -31 14 -21 15 -32 5 -74 -14 -58 -32 -79 -66 -79 -22 0
    -24 4 -24 53 0 36 9 70 28 111 24 51 33 61 72 76 58 23 57 23 69 3z m4612 -3
    c15 -8 19 -21 19 -60 0 -26 -3 -55 -6 -64 -8 -21 -37 -20 -57 2 -23 25 -59
    110 -52 122 8 13 71 13 96 0z m-5313 -26 c24 -16 29 -53 10 -72 -15 -15 -53
    -15 -81 -1 -42 23 -48 48 -16 80 21 21 44 20 87 -7z m279 5 c38 -24 38 -34 1
    -62 -32 -24 -52 -18 -73 23 -31 59 7 79 72 39z m4780 -9 c16 -6 39 -23 50 -38
    30 -40 53 -89 46 -96 -4 -3 -37 -6 -74 -6 -80 0 -92 9 -109 81 -10 43 -10 53
    1 60 19 12 50 11 86 -1z m-5363 -74 c31 -59 33 -83 6 -91 -30 -10 -58 12 -70
    53 -13 47 -13 68 1 94 14 25 26 14 63 -56z m1165 25 c27 -38 27 -40 -11 -56
    -40 -16 -48 -12 -48 25 0 65 26 78 59 31z m-101 -20 c4 -27 -19 -65 -54 -87
    -23 -16 -26 -16 -41 -1 -14 14 -15 22 -4 56 6 22 21 47 32 55 27 19 63 6 67
    -23z m-1760 -7 c3 -27 -6 -38 -78 -102 -82 -73 -94 -80 -105 -62 -10 16 19 61
    85 133 68 74 93 82 98 31z m206 12 c9 -38 -9 -76 -37 -76 -25 0 -47 17 -47 36
    0 20 41 64 60 64 11 0 20 -10 24 -24z m6375 15 c19 -12 5 -31 -24 -31 -13 0
    -27 5 -31 11 -7 11 12 29 31 29 6 0 16 -4 24 -9z m118 3 c-3 -3 -12 -4 -19 -1
    -8 3 -5 6 6 6 11 1 17 -2 13 -5z m-5589 -16 c12 -16 -2 -56 -24 -65 -8 -3 -23
    1 -32 10 -13 13 -13 21 -4 42 12 27 43 33 60 13z m263 -16 c7 -18 2 -30 -29
    -63 -20 -23 -50 -69 -67 -103 -22 -44 -36 -62 -52 -64 -34 -5 -30 29 11 102
    18 34 37 72 41 86 18 63 79 89 96 42z m-159 -9 c32 -31 36 -58 10 -72 -21 -11
    -81 11 -83 31 -3 35 13 68 34 68 6 0 24 -12 39 -27z m294 0 c-3 -16 -9 -54
    -13 -86 -4 -43 -11 -62 -27 -72 -27 -20 -65 -19 -73 1 -4 12 -11 8 -33 -17
    -18 -22 -32 -30 -43 -26 -23 8 -21 24 6 72 26 46 56 58 64 25 8 -29 23 -6 23
    34 0 32 57 96 85 96 14 0 16 -6 11 -27z m-910 -19 c8 -20 14 -50 12 -68 -2
    -25 -8 -32 -29 -34 -28 -3 -79 31 -79 53 0 17 58 85 72 85 5 0 16 -16 24 -36z
    m282 -26 l21 -61 -24 -29 c-14 -16 -25 -36 -25 -45 0 -29 -56 -73 -94 -73 -19
    0 -38 4 -41 10 -8 13 18 60 49 89 32 30 32 40 4 87 -24 41 -17 64 23 75 58 17
    65 12 87 -53z m-988 42 c0 -12 -28 -25 -36 -17 -9 9 6 27 22 27 8 0 14 -5 14
    -10z m1106 -27 c41 -26 26 -57 -34 -69 -30 -6 -33 -4 -47 31 -27 63 14 82 81
    38z m-906 -12 c18 -35 11 -71 -19 -102 -26 -25 -37 -29 -88 -29 -38 0 -66 5
    -79 15 -19 15 -19 16 0 28 10 7 44 33 75 59 60 51 94 60 111 29z m-242 2 c-1
    -5 -18 -29 -37 -55 -35 -48 -61 -62 -61 -33 0 20 69 95 87 95 8 0 13 -3 11 -7z
    m577 -17 c12 -18 13 -30 6 -50 -12 -30 -36 -34 -63 -9 -21 19 -23 36 -6 63 17
    27 44 25 63 -4z m-145 -24 c0 -10 -22 -41 -48 -70 -38 -41 -55 -52 -79 -52
    -95 0 -82 52 27 114 54 31 100 35 100 8z m460 -17 c0 -9 -11 -37 -25 -63 -14
    -26 -25 -52 -25 -59 0 -35 -101 -29 -108 7 -4 23 70 102 109 116 46 17 49 17
    49 -1z m422 -2 c24 -22 23 -53 -4 -93 -32 -47 -54 -58 -73 -40 -12 12 -13 23
    -4 55 25 97 42 113 81 78z m2433 -18 c39 -38 30 -118 -9 -86 -8 6 -16 25 -20
    41 -8 44 -34 39 -35 -7 0 -21 -1 -51 -3 -68 -1 -16 2 -38 6 -47 6 -14 2 -20
    -19 -28 -31 -12 -25 -30 11 -30 13 0 24 -2 24 -4 0 -2 3 -11 6 -19 3 -8 -4
    -24 -15 -34 l-21 -20 20 -18 c27 -24 25 -41 -5 -61 -30 -20 -32 -31 -5 -39 24
    -8 26 -24 3 -40 -14 -11 -13 -14 15 -35 48 -36 39 -70 -18 -70 -12 0 -19 -10
    -23 -32 -3 -18 -11 -51 -17 -73 -7 -22 -13 -51 -14 -65 -3 -37 -32 -87 -55
    -93 -55 -14 -67 46 -82 388 -18 415 0 464 169 465 54 0 66 -4 87 -25z m-3238
    -20 c49 -41 69 -44 85 -11 14 32 34 39 75 25 61 -20 65 -81 6 -95 -29 -8 -219
    1 -245 11 -10 4 -18 17 -18 30 0 22 34 75 49 75 4 0 26 -16 48 -35z m703 8 c0
    -43 -38 -113 -62 -113 -21 0 -21 10 -2 78 12 41 -16 24 -37 -23 -21 -48 -47
    -69 -73 -59 -41 16 -1 81 72 119 26 13 59 24 75 25 23 0 27 -4 27 -27z m2504
    -569 c16 -6 23 -44 8 -44 -18 0 -45 28 -38 38 8 14 9 14 30 6z m-9 -204 c-5
    -8 -11 -8 -17 -2 -6 6 -7 16 -3 22 5 8 11 8 17 2 6 -6 7 -16 3 -22z m20 -84
    c19 -29 8 -61 -25 -71 -27 -9 -25 -19 5 -33 32 -15 32 -28 -2 -44 l-28 -13 -8
    -185 c-17 -441 -19 -469 -31 -486 -9 -12 -33 -18 -84 -22 -70 -5 -71 -4 -78
    22 -3 15 -4 188 -2 384 6 438 4 432 113 458 84 20 122 18 140 -10z m6 -211
    c-1 -15 -24 -12 -29 3 -3 9 2 13 12 10 10 -1 17 -7 17 -13z m-11 -130 c0 -8
    -7 -15 -15 -15 -8 0 -15 7 -15 15 0 8 7 15 15 15 8 0 15 -7 15 -15z m4 -151
    c9 -24 7 -172 -3 -178 -4 -3 -16 3 -26 14 -27 29 -14 180 15 180 4 0 11 -7 14
    -16z m-9 -235 c0 -7 -8 -15 -17 -17 -18 -3 -25 18 -11 32 10 10 28 1 28 -15z
    m55 -19 c0 -5 -4 -10 -10 -10 -5 0 -10 5 -10 10 0 6 5 10 10 10 6 0 10 -4 10
    -10z m-60 -81 c0 -5 -7 -9 -15 -9 -15 0 -20 12 -9 23 8 8 24 -1 24 -14z m-62
    -72 c7 -9 8 -53 2 -142 -14 -205 -8 -334 19 -386 l23 -43 -23 -16 c-28 -22
    -20 -62 16 -86 14 -9 25 -26 25 -37 0 -11 3 -17 7 -13 4 4 8 44 8 89 0 75 2
    82 20 82 19 0 20 -7 21 -128 1 -89 -2 -127 -10 -124 -6 2 -12 13 -14 25 -6 38
    -26 26 -87 -50 -22 -28 -46 -48 -57 -48 -11 0 -33 -13 -48 -30 -35 -37 -77
    -41 -89 -7 -7 20 -27 580 -25 732 0 67 28 163 52 183 21 16 146 16 160 -1z
    m75 -30 c8 -20 -9 -41 -27 -34 -23 9 -21 47 3 47 10 0 21 -6 24 -13z m45 -100
    c2 -19 -1 -27 -12 -27 -11 0 -16 10 -16 31 0 38 24 35 28 -4z m-48 -81 c0 -54
    -8 -76 -26 -76 -17 0 -19 55 -4 94 15 40 30 31 30 -18z m54 -112 c9 -34 -3
    -94 -19 -94 -17 0 -27 44 -19 86 7 40 29 45 38 8z m-64 -84 c0 -53 -12 -82
    -27 -66 -8 8 -7 111 1 125 15 23 26 -2 26 -59z m-32 -483 c2 -10 -3 -17 -12
    -17 -18 0 -29 16 -21 31 9 14 29 6 33 -14z m3 -77 c25 -14 24 -34 -3 -52 -20
    -14 -21 -15 -3 -41 14 -23 16 -38 10 -90 -5 -34 -7 -122 -6 -195 1 -90 -2
    -138 -10 -148 -16 -19 -29 -8 -29 26 0 33 -18 49 -31 29 -5 -8 -9 -44 -9 -81
    0 -85 -12 -118 -39 -111 -12 3 -32 -2 -46 -11 -29 -19 -56 -21 -73 -4 -16 16
    -15 112 3 233 9 55 18 170 22 255 3 85 10 163 14 172 13 25 161 39 200 18z
    m103 -442 c3 -18 7 -60 8 -93 2 -48 0 -60 -12 -60 -12 0 -16 18 -18 93 -2 56
    1 92 7 92 6 0 12 -15 15 -32z m-111 -163 c1 -5 -6 -11 -15 -13 -11 -2 -18 3
    -18 13 0 17 30 18 33 0z m107 -45 c13 -9 13 -11 0 -20 -33 -22 -91 -7 -75 20
    8 13 55 13 75 0z m-187 -65 c15 -14 19 -48 33 -270 3 -55 12 -118 19 -139 12
    -35 12 -46 -7 -101 -19 -59 -22 -63 -57 -69 -46 -8 -145 -8 -165 0 -8 3 -20
    20 -26 38 -8 26 -4 55 25 171 20 77 41 185 47 240 6 55 16 106 21 113 9 11 56
    29 84 31 6 1 18 -6 26 -14z m96 6 c16 -11 7 -47 -15 -55 -32 -12 -48 26 -22
    52 14 14 19 15 37 3z m65 -43 c3 -18 7 -84 10 -145 4 -89 2 -113 -9 -113 -7 0
    -16 10 -19 23 -10 32 -20 232 -13 251 10 26 26 18 31 -16z m-61 -128 c4 -41
    11 -106 17 -145 10 -80 1 -101 -30 -70 -22 22 -39 120 -40 221 0 65 5 76 30
    72 11 -2 17 -23 23 -78z m112 -290 c10 -36 20 -77 22 -91 5 -29 -17 -52 -44
    -47 -23 4 -30 38 -9 38 20 0 20 1 -1 81 -16 62 -12 113 6 93 5 -5 17 -38 26
    -74z m-100 -10 c-5 -8 -11 -8 -17 -2 -6 6 -7 16 -3 22 5 8 11 8 17 2 6 -6 7
    -16 3 -22z m56 -53 c-13 -13 -26 -3 -16 12 3 6 11 8 17 5 6 -4 6 -10 -1 -17z
    m-41 -41 c0 -8 -5 -18 -11 -22 -14 -8 -33 11 -25 25 10 16 36 13 36 -3z m59
    -70 c14 -17 31 -105 21 -111 -5 -3 -16 15 -27 40 -11 29 -24 45 -35 45 -22 0
    -23 -13 -3 -30 22 -19 18 -30 -15 -41 -22 -8 -30 -17 -30 -34 0 -13 -5 -36
    -11 -52 -6 -15 -14 -57 -17 -93 l-7 -64 -44 -16 c-65 -22 -65 -42 -1 -23 55
    16 80 8 80 -27 0 -25 -10 -30 -31 -17 -27 17 -33 4 -39 -76 -4 -55 -9 -72 -20
    -72 -12 0 -16 15 -18 68 -2 37 -7 67 -11 67 -17 0 -36 -33 -33 -56 2 -13 -6
    -41 -17 -61 -11 -21 -22 -55 -26 -75 -7 -43 -23 -58 -39 -36 -6 9 -20 78 -30
    155 -16 115 -17 148 -7 186 6 26 16 104 21 173 6 70 15 135 21 145 9 17 24 19
    158 19 113 0 151 -3 160 -14z m-15 -168 c10 -39 7 -58 -14 -75 -11 -10 -23
    -32 -26 -51 -9 -45 -26 -27 -28 28 0 29 5 46 17 55 9 6 17 24 17 39 0 32 25
    35 34 4z m96 -194 c0 -24 -4 -34 -12 -32 -24 8 -22 68 2 68 5 0 10 -16 10 -36z
    m-172 -143 c3 -37 1 -42 -15 -39 -19 3 -30 46 -19 75 11 28 31 7 34 -36z m92
    -106 c6 -30 8 -64 5 -75 -17 -55 -53 25 -54 120 l0 55 19 -23 c10 -12 24 -47
    30 -77z"/>
    <path d="M6792 9171 c-10 -20 -9 -28 1 -38 11 -11 16 -10 31 6 17 19 17 20 -1
    38 -19 19 -19 19 -31 -6z"/>
    <path d="M6637 9033 c-4 -3 -7 -24 -7 -45 0 -22 -5 -49 -11 -61 -11 -21 -11
    -21 7 -5 10 10 19 33 20 50 1 18 5 41 9 51 7 17 -5 24 -18 10z"/>
    <path d="M538 8843 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
    <path d="M10711 8716 c-8 -20 -8 -33 -2 -39 13 -13 24 13 19 45 -4 22 -5 22
    -17 -6z"/>
    <path d="M10467 8651 c-4 -17 -3 -21 5 -13 5 5 8 16 6 23 -3 8 -7 3 -11 -10z"/>
    <path d="M6323 8620 c-15 -37 -27 -144 -15 -136 14 8 35 109 29 138 -3 23 -3
    23 -14 -2z"/>
    <path d="M6280 8364 c0 -14 4 -23 10 -19 6 3 10 15 10 26 0 10 -4 19 -10 19
    -5 0 -10 -12 -10 -26z"/>
    <path d="M12500 8452 c1 -13 95 -72 99 -61 2 6 -1 15 -7 21 -15 15 -92 48 -92
    40z"/>
    <path d="M361 8209 c-17 -7 -21 -13 -14 -20 15 -15 47 -7 51 14 4 19 -2 20
    -37 6z"/>
    <path d="M3480 8324 c0 -8 5 -12 10 -9 6 3 10 10 10 16 0 5 -4 9 -10 9 -5 0
    -10 -7 -10 -16z"/>
    <path d="M3625 8280 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
    -8 -4 -11 -10z"/>
    <path d="M10420 8321 c0 -12 5 -21 10 -21 6 0 10 6 10 14 0 8 -4 18 -10 21 -5
    3 -10 -3 -10 -14z"/>
    <path d="M1430 8251 c0 -5 5 -13 10 -16 6 -3 10 -2 10 4 0 5 -4 13 -10 16 -5
    3 -10 2 -10 -4z"/>
    <path d="M10335 8069 c-4 -6 -5 -12 -2 -15 7 -7 37 7 37 17 0 13 -27 11 -35
    -2z"/>
    <path d="M6482 8138 c-12 -12 -16 -38 -6 -38 3 0 19 11 36 25 29 25 29 25 6
    25 -13 0 -29 -5 -36 -12z"/>
    <path d="M6350 7814 c0 -8 5 -12 10 -9 6 3 10 10 10 16 0 5 -4 9 -10 9 -5 0
    -10 -7 -10 -16z"/>
    <path d="M10912 7998 c3 -7 15 -14 29 -16 24 -4 24 -3 4 12 -24 19 -38 20 -33
    4z"/>
    <path d="M9125 7850 c-86 -4 -94 -6 -60 -13 40 -8 106 -28 136 -41 12 -5 15
    -1 15 16 -1 14 8 27 24 35 21 11 22 12 5 11 -11 -1 -65 -4 -120 -8z"/>
    <path d="M2878 7793 c17 -2 47 -2 65 0 17 2 3 4 -33 4 -36 0 -50 -2 -32 -4z"/>
    <path d="M2765 7740 c-11 -5 -34 -9 -52 -9 -29 -1 -63 -29 -63 -53 0 -17 29
    -7 35 11 7 25 36 35 74 26 18 -4 32 -2 36 5 11 17 -7 29 -30 20z"/>
    <path d="M3005 7738 c-4 -10 -4 -26 0 -35 8 -17 8 -17 12 0 3 9 3 25 0 35 -4
    16 -4 16 -12 0z"/>
    <path d="M10328 7553 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
    <path d="M10680 7449 c0 -13 68 -42 83 -35 7 2 6 5 -3 5 -8 1 -26 10 -40 21
    -28 22 -40 25 -40 9z"/>
    <path d="M9660 7580 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
    -10 -4 -10 -10z"/>
    <path d="M2340 7150 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
    <path d="M4078 6923 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
    <path d="M10736 5992 c-8 -16 -31 -41 -51 -56 -20 -16 -34 -31 -31 -34 3 -3
    14 2 24 11 10 10 32 17 49 17 29 0 31 3 35 41 5 50 -6 59 -26 21z"/>
    <path d="M10756 5861 c-4 -7 -5 -15 -2 -18 9 -9 19 4 14 18 -4 11 -6 11 -12 0z"/>
    <path d="M10506 5804 c-11 -8 -31 -14 -44 -14 -24 0 -25 -2 -19 -53 6 -45 4
    -55 -13 -70 -19 -16 -27 -37 -15 -37 3 0 16 7 29 15 20 13 28 13 70 -1 41 -14
    50 -14 57 -3 12 19 11 86 -1 94 -6 3 -10 -4 -10 -17 0 -14 -7 -33 -15 -44 -14
    -18 -16 -18 -45 14 -34 37 -40 72 -11 72 23 0 44 24 39 44 -3 13 -5 13 -22 0z"/>
    <path d="M11278 5814 c-12 -19 -26 -94 -17 -94 15 0 30 40 27 73 -2 18 -6 27
    -10 21z"/>
    <path d="M11183 5758 c-23 -26 -43 -61 -43 -77 0 -21 17 -10 33 22 9 17 24 42
    33 55 9 12 12 22 7 22 -5 0 -19 -10 -30 -22z"/>
    <path d="M10790 5685 c7 -9 15 -13 17 -11 7 7 -7 26 -19 26 -6 0 -6 -6 2 -15z"/>
    <path d="M11298 5664 c-5 -4 -8 -19 -8 -33 1 -23 2 -24 11 -8 11 19 9 53 -3
    41z"/>
    <path d="M3765 5820 c-65 -55 -84 -60 -122 -30 -15 11 -28 18 -31 16 -10 -11
    9 -36 38 -51 29 -15 33 -15 58 1 26 17 26 17 54 -17 24 -29 28 -31 28 -12 0
    11 -7 26 -15 33 -22 19 -19 27 28 70 61 57 32 49 -38 -10z"/>
    <path d="M795 5469 c-12 -19 5 -23 22 -6 16 16 16 17 1 17 -9 0 -20 -5 -23
    -11z"/>
    <path d="M2368 5673 c-24 -6 -23 -23 1 -23 26 0 51 10 51 21 0 9 -22 10 -52 2z"/>
    <path d="M2201 5554 c-13 -30 -9 -39 14 -31 15 7 22 57 7 57 -5 0 -14 -12 -21
    -26z"/>
    <path d="M10037 5653 c-4 -3 -7 -11 -7 -17 0 -6 5 -5 12 2 6 6 9 14 7 17 -3 3
    -9 2 -12 -2z"/>
    <path d="M3180 5640 c0 -5 4 -10 9 -10 5 0 18 -3 28 -7 16 -6 16 -5 4 10 -15
    19 -41 23 -41 7z"/>
    <path d="M2880 5401 c0 -15 38 -56 45 -49 9 9 -21 58 -35 58 -6 0 -10 -4 -10
    -9z"/>
    <path d="M1297 5329 c-48 -40 -48 -59 1 -21 20 16 46 34 57 40 20 11 20 11 0
    12 -11 0 -37 -14 -58 -31z"/>
    <path d="M2469 5294 l-34 -36 30 15 c39 20 74 57 54 57 -9 0 -31 -16 -50 -36z"/>
    <path d="M6564 2165 c-7 -18 3 -165 11 -173 13 -14 20 17 20 95 0 60 -4 87
    -12 90 -7 3 -16 -3 -19 -12z"/>
    <path d="M6420 530 c0 -5 4 -10 9 -10 6 0 13 5 16 10 3 6 -1 10 -9 10 -9 0
    -16 -4 -16 -10z"/>
    <path d="M11900 8815 c-14 -8 -44 -23 -67 -34 -24 -11 -43 -22 -43 -23 0 -2
    82 -3 182 -3 101 0 201 -4 223 -8 30 -6 36 -5 23 3 -15 9 -62 17 -227 36 -32
    4 -45 11 -48 25 -6 23 -10 23 -43 4z"/>
    <path d="M12210 8821 c0 -5 9 -11 20 -14 24 -6 27 8 4 17 -21 8 -24 8 -24 -3z"/>
    <path d="M11315 8800 c-3 -5 3 -10 14 -10 11 0 23 5 26 10 3 6 -3 10 -14 10
    -11 0 -23 -4 -26 -10z"/>
    <path d="M1587 8773 c-4 -3 -7 -11 -7 -17 0 -6 5 -5 12 2 6 6 9 14 7 17 -3 3
    -9 2 -12 -2z"/>
    <path d="M12395 8760 c27 -12 43 -12 25 0 -8 5 -22 9 -30 9 -10 0 -8 -3 5 -9z"/>
    <path d="M11910 8609 c0 -5 11 -9 25 -9 14 0 25 2 25 4 0 2 -11 6 -25 8 -14 3
    -25 1 -25 -3z"/>
    <path d="M11741 8386 c59 -13 133 -38 165 -55 33 -17 66 -31 74 -31 8 0 39 -9
    69 -20 68 -26 80 -18 15 11 -150 66 -292 111 -359 115 l-70 4 106 -24z"/>
    </g>
        <clipPath id="goodyWingUL" clipPathUnits="userSpaceOnUse"><polygon points="0,0 635,0 635,175 610,245 0,310"/></clipPath>
        <clipPath id="goodyWingLL" clipPathUnits="userSpaceOnUse"><polygon points="0,155 620,185 620,470 0,510"/></clipPath>
        <clipPath id="goodyWingUR" clipPathUnits="userSpaceOnUse"><polygon points="645,0 1280,0 1280,310 670,245 645,175"/></clipPath>
        <clipPath id="goodyWingLR" clipPathUnits="userSpaceOnUse"><polygon points="660,185 1280,155 1280,510 660,470"/></clipPath>
        <clipPath id="goodyBodyClip" clipPathUnits="userSpaceOnUse"><rect x="565" y="0" width="150" height="936"/></clipPath>
      </defs>
    
      <g transform="translate(936 0) rotate(90)">
        <g class="goody-real-dragonfly__wing goody-real-dragonfly__wing--ul" clip-path="url(#goodyWingUL)" color="#78958e" opacity=".64">
          <use href="#goodyDragonflySource"/><animateTransform attributeName="transform" type="rotate" values="-2.5 620 215;3.5 620 215;-2.5 620 215" keyTimes="0;0.5;1" dur="0.095s" repeatCount="indefinite"/>
        </g>
        <g class="goody-real-dragonfly__wing goody-real-dragonfly__wing--ll" clip-path="url(#goodyWingLL)" color="#78958e" opacity=".59">
          <use href="#goodyDragonflySource"/><animateTransform attributeName="transform" type="rotate" values="2.2 620 225;-3.2 620 225;2.2 620 225" keyTimes="0;0.5;1" dur="0.108s" begin="-0.024s" repeatCount="indefinite"/>
        </g>
        <g class="goody-real-dragonfly__wing goody-real-dragonfly__wing--ur" clip-path="url(#goodyWingUR)" color="#78958e" opacity=".64">
          <use href="#goodyDragonflySource"/><animateTransform attributeName="transform" type="rotate" values="2.5 660 215;-3.5 660 215;2.5 660 215" keyTimes="0;0.5;1" dur="0.095s" begin="-0.018s" repeatCount="indefinite"/>
        </g>
        <g class="goody-real-dragonfly__wing goody-real-dragonfly__wing--lr" clip-path="url(#goodyWingLR)" color="#78958e" opacity=".59">
          <use href="#goodyDragonflySource"/><animateTransform attributeName="transform" type="rotate" values="-2.2 660 225;3.2 660 225;-2.2 660 225" keyTimes="0;0.5;1" dur="0.108s" begin="-0.053s" repeatCount="indefinite"/>
        </g>
        <g class="goody-real-dragonfly__body" clip-path="url(#goodyBodyClip)" color="#294a42">
          <use href="#goodyDragonflySource"/>
        </g>
      </g>
    </svg>`;

  function ensureGoodyRealDragonflyStyles(){
    if(document.getElementById("goody-real-dragonfly-styles")) return;

    var style = document.createElement("style");
    style.id = "goody-real-dragonfly-styles";
    style.textContent = `
      .goody-real-dragonfly{
        position:absolute;
        left:0;
        top:0;
        width:clamp(73px,8.5vw,115px);
        aspect-ratio:936/1280;
        pointer-events:none;
        z-index:4;
        will-change:transform;
        filter:drop-shadow(0 5px 8px rgba(21,54,47,.18));
      }

      .goody-real-dragonfly__svg{
        display:block;
        width:100%;
        height:100%;
        overflow:visible;
      }

      .goody-real-dragonfly.is-hovering{
        filter:drop-shadow(0 4px 7px rgba(21,54,47,.16));
      }

      .goody-real-dragonfly.is-darting{
        filter:drop-shadow(0 6px 9px rgba(21,54,47,.20));
      }

      @media(max-width:749px){
        .goody-real-dragonfly{
          width:clamp(66px,16vw,89px);
        }
      }

      @media(prefers-reduced-motion:reduce){
        .goody-real-dragonfly{
          transform:translate3d(8vw,8vh,0)!important;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function initGoodyRealBiographyDragonfly(root){
    if(!root || root.dataset.goodyRealDragonflyReady === "true") return;

    var zone = root.querySelector(".goody-biography-panel__surface");
    if(!zone) return;

    ensureGoodyRealDragonflyStyles();

    var fly = root.querySelector("[data-goody-real-dragonfly]");
    if(!fly){
      fly = document.createElement("div");
      fly.className = "goody-real-dragonfly";
      fly.setAttribute("data-goody-real-dragonfly", "");
      fly.setAttribute("aria-hidden", "true");
      fly.innerHTML = GOODY_REAL_DRAGONFLY_SVG;

      var seal = zone.querySelector(".goody-biography-panel__bg-seal");
      if(seal && seal.nextSibling) zone.insertBefore(fly, seal.nextSibling);
      else if(seal) zone.appendChild(fly);
      else zone.insertBefore(fly, zone.firstChild);
    }

    root.dataset.goodyRealDragonflyReady = "true";

    if(window.matchMedia && window.matchMedia("(prefers-reduced-motion:reduce)").matches) return;

    var segment = null;
    var hover = null;
    var raf = 0;

    function random(min,max){ return min + Math.random() * (max - min); }
    function clamp(value,min,max){ return Math.max(min,Math.min(max,value)); }
    function cubic(a,b,c,d,t){
      var u = 1 - t;
      return u*u*u*a + 3*u*u*t*b + 3*u*t*t*c + t*t*t*d;
    }
    function cubicDerivative(a,b,c,d,t){
      var u = 1 - t;
      return 3*u*u*(b-a) + 6*u*t*(c-b) + 3*t*t*(d-c);
    }
    function smootherStep(t){ return t*t*t*(t*(t*6-15)+10); }
    function easeIn(t){ return t*t; }
    function easeOut(t){ return 1 - Math.pow(1-t,3); }

    function bounds(){
      var zoneBox = zone.getBoundingClientRect();
      var flyBox = fly.getBoundingClientRect();
      var minY = Math.max(10,zoneBox.height * .025);
      var maxY = Math.max(minY + 70,Math.min(zoneBox.height * .33 - flyBox.height * .55,280));
      return {
        width:zoneBox.width,
        height:zoneBox.height,
        flyW:flyBox.width,
        flyH:flyBox.height,
        minY:minY,
        maxY:maxY
      };
    }

    function applyPose(x,y,pitch,scale,dir){
      var facing = dir === -1 ? -1 : 1;
      var orientedPitch = facing === 1 ? pitch : -pitch;
      fly.style.transform = "translate3d("+x+"px,"+y+"px,0) scaleX("+(facing * scale)+") scaleY("+scale+") rotate("+orientedPitch+"deg)";
    }

    function beginHover(x,y,dir,scale,duration,next){
      hover = {
        x:x,
        y:y,
        dir:dir === -1 ? -1 : 1,
        scale:scale,
        startedAt:null,
        duration:duration,
        phase:random(0,Math.PI * 2),
        next:next || null
      };
      fly.classList.add("is-hovering");
      fly.classList.remove("is-darting");
    }

    function chooseMode(){
      var r = Math.random();
      if(r < .22) return "dart";
      if(r < .55) return "glide";
      return "cruise";
    }

    function newSegment(x,y,dir,options){
      var b = bounds();
      var mobile = b.width < 750;
      var direction = dir === -1 ? -1 : 1;
      var opts = options || {};
      var mode = opts.mode || chooseMode();
      var edgeExit = !!opts.edgeExit;
      var launch = !!opts.launch;
      var distance;
      var duration;

      if(edgeExit){
        var edgeX = direction === 1
          ? b.width + b.flyW * random(.7,1.05)
          : -b.flyW * random(.7,1.05);
        distance = Math.abs(edgeX - x);
      }else if(launch){
        distance = mobile ? random(120,190) : random(185,285);
      }else if(mode === "dart"){
        distance = random(mobile ? 85 : 125,mobile ? 165 : 235);
      }else if(mode === "glide"){
        distance = random(mobile ? 145 : 215,mobile ? 255 : 375);
      }else{
        distance = random(mobile ? 115 : 175,mobile ? 220 : 320);
      }

      var endX = edgeExit
        ? (direction === 1 ? b.width + b.flyW * random(.7,1.05) : -b.flyW * random(.7,1.05))
        : x + distance * direction;

      if(!edgeExit && !launch){
        var edgeLimit = direction === 1 ? b.width + b.flyW * .75 : -b.flyW * .75;
        if(direction === 1 && endX > edgeLimit) endX = edgeLimit;
        if(direction === -1 && endX < edgeLimit) endX = edgeLimit;
      }

      var verticalRange = mode === "dart" ? .46 : (mode === "glide" ? .72 : .60);
      var targetBias = random(-1,1) * (b.maxY - b.minY) * verticalRange;
      var endY = clamp(y + targetBias,b.minY,b.maxY);
      if(launch) endY = clamp(y + random(-38,38),b.minY,b.maxY);
      if(edgeExit) endY = clamp(y + random(-52,52),b.minY,b.maxY);

      var span = Math.max(1,Math.abs(endX - x));
      var verticalSwing = mode === "dart" ? random(18,52) : random(35,105);
      if(edgeExit) verticalSwing = random(24,70);
      if(launch) verticalSwing = random(22,62);
      var bend1 = verticalSwing * (Math.random() < .5 ? -1 : 1);
      var bend2 = verticalSwing * (Math.random() < .5 ? -1 : 1);

      var c1x = x + span * random(.22,.38) * direction;
      var c2x = x + span * random(.62,.82) * direction;
      var c1y = clamp(y + bend1,b.minY - 28,b.maxY + 28);
      var c2y = clamp(endY + bend2,b.minY - 28,b.maxY + 28);

      if(edgeExit){
        c1y = clamp(y + random(-30,30),b.minY - 18,b.maxY + 18);
        c2y = clamp(endY + random(-18,18),b.minY - 18,b.maxY + 18);
      }

      if(mode === "dart") duration = random(520,900);
      else if(mode === "glide") duration = random(1900,3300);
      else duration = random(1200,2350);
      if(edgeExit) duration = random(1050,1750);
      if(launch) duration = random(900,1550);

      segment = {
        b:b,
        dir:direction,
        mode:mode,
        edgeExit:edgeExit,
        launch:launch,
        startX:x,
        startY:y,
        c1x:c1x,
        c1y:c1y,
        c2x:c2x,
        c2y:c2y,
        endX:endX,
        endY:endY,
        startTime:null,
        duration:duration,
        scale:random(.88,1.035),
        wave:mode === "dart" ? random(2,6) : random(4,12),
        cycles:mode === "glide" ? random(.55,.95) : random(.8,1.45)
      };

      fly.classList.toggle("is-darting",mode === "dart");
      fly.classList.remove("is-hovering");
    }

    function reset(first,dir){
      var b = bounds();
      var direction = dir === -1 ? -1 : 1;
      var startX = direction === 1
        ? (first ? -b.flyW * 1.05 : -b.flyW * random(.75,1.05))
        : (first ? b.width + b.flyW * .05 : b.width + b.flyW * random(.75,1.05));
      newSegment(startX,random(b.minY,b.maxY),direction,{launch:true,mode:"cruise"});
    }

    function shouldExitAtEdge(x,dir,b){
      var threshold = Math.max(b.flyW * 1.2,b.width * .12);
      return dir === 1 ? (b.width - x < threshold) : (x < threshold);
    }

    function frame(timestamp){
      if(!document.documentElement.contains(root)){
        if(raf) cancelAnimationFrame(raf);
        return;
      }

      if(!root.classList.contains("is-open")){
        if(segment) segment.startTime = null;
        if(hover) hover.startedAt = null;
        raf = requestAnimationFrame(frame);
        return;
      }

      if(!segment && !hover) reset(true,1);

      if(hover){
        if(hover.startedAt === null) hover.startedAt = timestamp;
        var holdRaw = clamp((timestamp - hover.startedAt) / hover.duration,0,1);
        var trembleX = Math.sin(holdRaw * Math.PI * 6 + hover.phase) * 2.2;
        var trembleY = Math.sin(holdRaw * Math.PI * 8 + hover.phase * .7) * 3.6;
        var tremblePitch = Math.sin(holdRaw * Math.PI * 5 + hover.phase) * 2.1;
        var trembleScale = hover.scale + Math.sin(holdRaw * Math.PI * 4) * .012;
        applyPose(hover.x + trembleX,hover.y + trembleY,tremblePitch,trembleScale,hover.dir);

        if(holdRaw >= 1){
          var next = hover.next;
          hover = null;
          fly.classList.remove("is-hovering");
          if(next) next();
        }

        raf = requestAnimationFrame(frame);
        return;
      }

      if(segment.startTime === null) segment.startTime = timestamp;

      var raw = clamp((timestamp - segment.startTime) / segment.duration,0,1);
      var eased = segment.edgeExit ? easeOut(raw) : (segment.launch ? easeIn(raw) : smootherStep(raw));
      var baseX = cubic(segment.startX,segment.c1x,segment.c2x,segment.endX,eased);
      var baseY = cubic(segment.startY,segment.c1y,segment.c2y,segment.endY,eased);
      var waveEnvelope = Math.sin(raw * Math.PI);
      var wave = Math.sin(raw * Math.PI * 2 * segment.cycles) * segment.wave * waveEnvelope;
      var x = baseX;
      var y = clamp(baseY + wave,segment.b.minY - 10,segment.b.maxY + 10);
      var dx = cubicDerivative(segment.startX,segment.c1x,segment.c2x,segment.endX,eased);
      var dy = cubicDerivative(segment.startY,segment.c1y,segment.c2y,segment.endY,eased)
        + Math.cos(raw * Math.PI * 2 * segment.cycles) * segment.wave * waveEnvelope;
      var pitch = clamp(Math.atan2(dy,Math.max(1,Math.abs(dx))) * 180 / Math.PI,-18,18);
      var scale = segment.scale + Math.sin(raw * Math.PI) * (segment.mode === "dart" ? .035 : .022);

      applyPose(x,y,pitch,scale,segment.dir);

      if(raw >= 1){
        var completed = segment;
        segment = null;

        if(completed.edgeExit){
          var reverseDir = -completed.dir;
          var edgePause = random(130,390);
          beginHover(x,y,completed.dir,scale,edgePause,function(){
            reset(false,reverseDir);
          });
        }else if(shouldExitAtEdge(x,completed.dir,completed.b)){
          newSegment(x,y,completed.dir,{edgeExit:true,mode:"glide"});
        }else{
          var pauseChance = completed.mode === "dart" ? .18 : .42;
          if(Math.random() < pauseChance){
            beginHover(x,y,completed.dir,scale,random(220,980),function(){
              newSegment(x,y,completed.dir);
            });
          }else{
            newSegment(x,y,completed.dir);
          }
        }
      }

      raf = requestAnimationFrame(frame);
    }

    raf = requestAnimationFrame(frame);

    window.addEventListener("resize",function(){
      segment = null;
      hover = null;
      fly.classList.remove("is-hovering","is-darting");
    },{passive:true});
  }

  function initRoot(root){
    if(!root || root.dataset.goodyBiographyReady === "true") return;
    ensureControls(root);
    initGoodyRealBiographyDragonfly(root);
    root.dataset.goodyBiographyReady = "true";
    root.hidden = true;
    root.setAttribute("aria-hidden","true");
    render(root,readLang());
  }

  function init(){
    roots().forEach(initRoot);
    document.querySelectorAll(TRIGGER_SELECTOR).forEach(function(button){
      button.setAttribute("aria-label","Ouvrir la biographie de Goodÿ");
      button.setAttribute("aria-haspopup","dialog");
      button.setAttribute("aria-controls","goody-biography-panel");
    });
  }

  document.addEventListener("click",onDocumentClick,true);
  document.addEventListener("keydown",onDocumentKeydown,true);
  window.addEventListener("storage",function(event){
    if(event && (event.key === STORAGE_KEY || event.key === STORAGE_KEY_COMPAT)) setLang(readLang(),false);
  });
  window.addEventListener("po:locale-changed",function(event){
    var source = event && event.detail ? event.detail.source : "";
    if(source === "goody-biography") return;
    roots().forEach(function(root){ render(root,readLang()); });
  });
  document.addEventListener("shopify:section:load",function(){ window.setTimeout(init,60); });

  window.GoodyBiographyFR_EN_ES_20260726 = {
    init:init,
    open:openPanel,
    close:closePanel,
    getLang:readLang,
    setLang:setLang,
    stopAudio:function(){ stopAudio(true); }
  };

  if(document.readyState === "loading") document.addEventListener("DOMContentLoaded",init);
  else init();
})();
